// Detail klienta — fullscreen overlay ve stylu Total statistics.
// Nahrazuje původní úzkou modálku v Clients.jsx — varianta D: rozbalovací sekce, široký layout,
// dark gradient header, KpiCard top stats, Card sekce s tematickými ikonami.
//
// Sekce:
//   - Top KPI strip (4 dlaždice)
//   - Spolupráce / Kontakt / Finance (3 sloupce s grid layoutem)
//   - Měsíční heatmap + monthly bars
//   - Informace k tréninku (vhodné / nevhodné cviky, zranění, doporučení)
//   - Cviky a váhy (přehled cviků s kg)
//   - Kardio (pás, SkiErg, rotoped, …)
//   - Pro náhrady (jak klient trénuje, info pro náhradníka)
//   - Poznámky
//   - Historie tréninků (z Cache bookings 2026)
//   - Budoucí tréninky
//
// Data ze sheetu "Přehled klientů a stav tréninků" jsou v `client.prehled.*` sekcích.
// Historie / budoucnost se načítá zvlášť přes /api/client-bookings při otevření.

import { toast } from "../components/Toast.jsx";
import { PodpisSmlouvyKlientky } from "../components/deal/DealDialogy.jsx";
import DokumentyKlientky, { useDokumentyKlientky } from "../components/smlouva/DokumentyKlientky.jsx";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { FolderOpen } from "lucide-react";
import { X, ChevronDown, Phone, Mail, ExternalLink, MapPin, Calendar, DollarSign, Activity, Package, Award, User as UserIcon, FileText, History, CalendarClock, Clock, CheckCircle2, Pause, XCircle, Receipt, Building2, ClipboardList, RefreshCw, Download, AlertTriangle, Sparkles, Lock, Pin, Archive, Send, MessageSquare, Trash2, Pencil, Smartphone, Inbox, Plane, Mountain, Salad, RotateCcw, ArrowLeft, CalendarPlus, Check, Eye, Wallet, Star, Baby, Flame, UserPlus, PhoneForwarded } from "lucide-react";
import ClientEmailsSection from "../components/ClientEmailsSection.jsx";
import CopyButton from "../components/CopyButton.jsx";
import TrainingProfileSection from "../components/TrainingProfileSection.jsx";
import ClientVolnoSection from "../components/ClientVolnoSection.jsx";
import ClientHodnoceniSection from "../components/ClientHodnoceniSection.jsx";
import ClientDetiSection from "../components/ClientDetiSection.jsx";
import ClientBootcampSection from "../components/ClientBootcampSection.jsx";
import ClientReferralsSection from "../components/ClientReferralsSection.jsx";
import PlanovanaZmenaBalickuSection from "../components/PlanovanaZmenaBalickuSection.jsx";
import PlanovaneUkonceniSection from "../components/PlanovaneUkonceniSection.jsx";
import PlanFakturaceSection from "../components/PlanFakturaceSection.jsx";
import { PRAZDNE_UKONCENI, chybaUkonceni } from "../components/UkonceniVolby.jsx";
import { UkonceniDialog, VYCHOZI_KONEC, chybaKonce, EmailNahledDialog, KonecSpolupraceSection } from "../components/Rozlouceni.jsx";
import PropadnutiFakturySection from "../components/PropadnutiFakturySection.jsx";
import JidelnicekSection from "../components/JidelnicekSection.jsx";
import NutriReportySection from "../components/NutriReportySection.jsx";
import ZpetnaVazbaVyzivaSection from "../components/ZpetnaVazbaVyzivaSection.jsx";
import InBodySection from "../components/InBodySection.jsx";
import MasterplanSection from "../components/MasterplanSection.jsx";
import ClientWeekendsSection from "../components/ClientWeekendsSection.jsx";
import PhoneInput from "../components/PhoneInput.jsx";
import RenameClientDialog from "../components/RenameClientDialog.jsx";
import { HlavickaKlientky, DlazdiceKlientky } from "../components/KlientkaPrehled.jsx";
import Card from "../components/Card.jsx";
import InfoTip from "../components/InfoTip.jsx";
import { fmt, formatDate as fmtDate, formatDateTime, balicekKratce } from "../lib/format.js";
import { useDemoMode } from "../lib/DemoModeContext.jsx";
import { LOGO_SVG_BILE, brandFontCss } from "../lib/brand.js";
import { apiFetch, useApiData } from "../lib/api.js";
import { getCurrentUser } from "../lib/auth.js";
import { useUzkaObrazovka } from "../lib/obrazovka.js";
import { Stitek, Oddelovac, Segment } from "../components/ui.jsx";
import { TONY } from "../lib/tony.js";
import { confirmDialog as confirmModal } from "../components/confirmHost.jsx";
import { fetchLogExpired } from "../lib/logExpiredCache.js";
import { canonicalNorm } from "../lib/nameAliases.js";
import ConfirmDialog from "../components/ConfirmDialog.jsx";
import PoslatSalesDialog from "../components/sales/PoslatSalesDialog.jsx";
import { CommentBubble, formatCommentTime } from "../components/Komentare.jsx"; // 14. 9. 2026 (fáze 6)
import { useNotifications } from "../lib/AlertContext.jsx";
import { getClientFieldOptions, addCurrentToOptions, invalidateClientFieldOptions } from "../lib/clientFieldOptions.js";

const MONTH_FULL = ["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"];
const MONTH_SHORT = ["Led","Úno","Bře","Dub","Kvě","Čer","Čvc","Srp","Zář","Říj","Lis","Pro"];

// Persistentní cache pro klient field overrides (Modul 2A1 + 2B + 2C + 2D).
// Přesunuto do src/lib/clientOverrides.js aby ho mohl použít i Clients list page
// (po edit klienta v detail user vyjede do listu a hned tam vidí novou hodnotu).
import {
  getClientOverride,
  setClientOverride,
  odeberClientOverride,
  getContactOverride,
  setContactOverrideCache,
} from "../lib/clientOverrides.js";

// Parser pro sloupec Důvod z Log Expired YYYY.
// Format: "Permanentka: minimum 2 tréninků/měsíc. Odchozeno v Duben: 0. Automatizace 1.5.2026."
// Vrátí { balicek, minimum, odchozeno } — všechny mohou být null, pokud parsing selže.
function parsePropadleDuvod(duvod) {
  if (!duvod) return { balicek: null, minimum: null, odchozeno: null };
  const s = String(duvod);
  const colonIdx = s.indexOf(":");
  const balicek = colonIdx > -1 ? s.substring(0, colonIdx).trim() : null;
  const minMatch = s.match(/minimum\s+(\d+)/i);
  const minimum = minMatch ? parseInt(minMatch[1], 10) : null;
  const odchMatch = s.match(/Odchozeno\s+v\s+\S+:\s*(\d+)/i);
  const odchozeno = odchMatch ? parseInt(odchMatch[1], 10) : null;
  return { balicek, minimum, odchozeno };
}

const STAV_META = {
  "Aktivní":   { color: "emerald", Icon: CheckCircle2, label: "Aktivní" },
  "Přerušeno": { color: "amber",   Icon: Pause,        label: "Přerušeno" },
  "Ukončeno":  { color: "slate",   Icon: XCircle,      label: "Ukončeno" },
};

function StavBadge({ stav }) {
  const meta = STAV_META[stav] || { color: "slate", Icon: UserIcon, label: stav || "?" };
  const cls = {
    emerald: "bg-emerald-500/20 text-emerald-100 border-emerald-400/40",
    amber:   "bg-amber-500/20 text-amber-100 border-amber-400/40",
    slate:   "bg-slate-500/20 text-slate-100 border-slate-400/40",
  }[meta.color];
  return (
    <span className={`inline-flex items-center gap-1.5 text-sm font-medium px-2.5 py-1 rounded-full border ${cls}`}>
      <meta.Icon className="w-3.5 h-3.5" />
      {meta.label}
    </span>
  );
}

// Krátké datum bez roku (5. 9. 2026) — na telefon, kde je rok zřejmý z pořadí.
function kratkeDatum(iso) {
  if (!iso) return "";
  const d = datumZIso(iso);
  if (isNaN(d)) return "";
  return `${d.getDate()}. ${d.getMonth() + 1}.`;
}

// SMS upomínky k faktuře (8. 10. 2026, mockup „Upomínky v detailu klientky“, varianta A).
// Pilulka s počtem do řádku faktury a časová osa do rozbalení. Data posílá
// /api/client-invoices v inv.upominky (sms_log podle čísla faktury).
// Místní čas "YYYY-MM-DD HH:MM:SS" pro optimisticky přidaný nebo upravený komentář
// (server vrací pražský čas ve stejném tvaru, 8. 10. 2026).
function mistniCasKomentare() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}
function popisStupne(s) {
  const stupen = Number(s) || 0;
  if (stupen === 1) return "1 den po splatnosti";
  if (stupen >= 2 && stupen <= 4) return `${stupen} dny po splatnosti`;
  if (stupen) return `${stupen} dní po splatnosti`;
  return "po splatnosti";
}
// Datum a čas vždy v pražském čase, i když je prohlížeč v jiném pásmu. Samotné
// datum (YYYY-MM-DD) se bere z textu, aby se neposunulo o den.
function datumPraha(iso, { mezery = true } = {}) {
  if (!iso) return "";
  const s = String(iso);
  let d, m;
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    m = Number(s.slice(5, 7)); d = Number(s.slice(8, 10));
  } else {
    const x = new Date(s);
    if (isNaN(x)) return "";
    const casti = new Intl.DateTimeFormat("cs-CZ", { day: "numeric", month: "numeric", timeZone: "Europe/Prague" }).formatToParts(x);
    d = Number((casti.find((c) => c.type === "day") || {}).value);
    m = Number((casti.find((c) => c.type === "month") || {}).value);
  }
  return mezery ? `${d}. ${m}.` : `${d}.${m}.`;
}
function casUpominky(iso) {
  const d = datumZIso(iso);
  if (!iso || isNaN(d)) return "";
  return d.toLocaleTimeString("cs-CZ", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Prague" });
}
function PocetUpominek({ upominky }) {
  const n = (upominky || []).length;
  if (!n) return null;
  return <Stitek ton="pozor" velikost="mala" ikona={MessageSquare}>{n} SMS</Stitek>;
}
function UpominkyFaktury({ inv, maly = false }) {
  const upominky = inv.upominky || [];
  if (!upominky.length) return null;
  const radek = maly ? "text-[13px]" : "text-sm";
  // Zaplacení se řadí mezi SMS podle data, aby osa šla časově.
  const polozky = upominky.map((u) => ({ ...u, typ: "sms", klic: String(u.kdy || "") }));
  if (inv.status === "paid" && inv.datum_uhrady) polozky.push({ typ: "zaplaceno", kdy: inv.datum_uhrady, klic: `${String(inv.datum_uhrady).slice(0, 10)}T23:59` });
  polozky.sort((a, b) => a.klic.localeCompare(b.klic));
  return (
    <ol className="mt-1 space-y-1.5">
      {polozky.map((u, i) => u.typ === "zaplaceno" ? (
        <li key={i} className={`flex items-center gap-2.5 ${radek}`}>
          <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${TONY.ok.pole}`}>
            <CheckCircle2 className="h-4 w-4" />
          </span>
          <span className="w-12 shrink-0 font-semibold tabular-nums text-slate-900">{datumPraha(u.kdy)}</span>
          <span className="min-w-0 flex-1"><span className="font-semibold text-slate-800">Zaplaceno</span> <span className="text-slate-500">(upomínky skončily)</span></span>
        </li>
      ) : (
        <li key={i} className={`flex items-center gap-2.5 ${radek}`}>
          <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${u.nejista ? TONY.problem.pole : TONY.pozor.pole}`}>
            <MessageSquare className="h-4 w-4" />
          </span>
          <span className="w-12 shrink-0 font-semibold tabular-nums text-slate-900">{datumPraha(u.kdy)}</span>
          <span className="min-w-0 flex-1">
            <span className="font-semibold text-slate-800">SMS {u.stupen ? `${u.stupen}. stupeň` : "upomínka"}</span>{" "}
            <span className="text-slate-500">({popisStupne(u.stupen)}{u.presnyCas !== false && casUpominky(u.kdy) ? `, ${casUpominky(u.kdy)}` : ""}{u.nejista ? ", nejisté odeslání, ověř v BulkGate" : ""})</span>
          </span>
        </li>
      ))}
    </ol>
  );
}

// Badge stavu posledni FAPI faktury — pro header (dark variant) i finance card (light variant).
// status: "paid" | "overdue" | "pending" | null
// daysOverdue: int | null (pri paid = dni pozdě platil, pri overdue = dni od splatnosti)
// variant: "dark" (na gradient headeru) | "light" (na bilem pozadi v card)
function InvoiceStatusBadge({ status, daysOverdue, variant = "light" }) {
  if (!status) return null;
  const dark = variant === "dark";
  let label, classes, IconComp;
  if (status === "paid") {
    const wasLate = daysOverdue && daysOverdue > 0;
    label = wasLate ? `Zaplacená (${daysOverdue} dní pozdě)` : "Zaplacená";
    IconComp = CheckCircle2;
    // "Cokoliv po splatnosti = červená" (zadani Lada 16.5.) — i zaplacena s pozdrzenim
    if (wasLate) {
      classes = dark
        ? "bg-rose-500/30 text-rose-100 border-rose-400/50"
        : "bg-rose-50 text-rose-700 border-rose-200";
    } else {
      classes = dark
        ? "bg-emerald-500/20 text-emerald-100 border-emerald-400/40"
        : "bg-emerald-50 text-emerald-700 border-emerald-200";
    }
  } else if (status === "overdue") {
    label = daysOverdue ? `Po splatnosti ${daysOverdue} dní` : "Po splatnosti";
    IconComp = AlertTriangle;
    classes = dark
      ? "bg-rose-500/30 text-rose-100 border-rose-400/50"
      : "bg-rose-50 text-rose-700 border-rose-200";
  } else { // pending
    label = "Vystavená";
    IconComp = Receipt;
    classes = dark
      ? "bg-blue-500/20 text-blue-100 border-blue-400/40"
      : "bg-blue-50 text-blue-700 border-blue-200";
  }
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border ${classes}`}>
      <IconComp className="w-3.5 h-3.5" />
      {label}
    </span>
  );
}

// FW-154 (14. 10. 2026): Permice a Výživový koučink jsou dané balíčkem, Typ jinak
// nese jen délku smlouvy (Úvodní období / Na neurčito). Stejné pravidlo drží klient-edit.
function typZBalicku(balicek) {
  const b = String(balicek || "").toLowerCase();
  if (/permanentk|permic/.test(b)) return "Permice";
  if (/v[yý][žz]ivov/.test(b)) return "Výživový koučink";
  return null;
}
function smlouvaText(typ) {
  if (/^[uú]vodn/i.test(String(typ || ""))) return "Úvodní období";
  if (/neomezen/i.test(String(typ || ""))) return "Na neurčito";
  return typ || "";
}

// FW-159 (14. 10. 2026): datum bez času („2026-10-12“) bere new Date jako půlnoc UTC,
// takže v časovém pásmu západně od Greenwiche (cesta, dovolená) ukázal o den dřív
// („Ne 11.10.“ místo „Po 12.10.“). Čisté datum se proto čte jako místní den.
function datumZIso(x) {
  const m = typeof x === "string" ? x.match(/^(\d{4})-(\d{2})-(\d{2})$/) : null;
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(x);
}

function formatDate(iso) {
  if (!iso || iso === "0") return "";
  try {
    const d = datumZIso(iso);
    if (isNaN(d)) return iso;
    return fmtDate(d);
  } catch { return iso; }
}

// Kompaktni datum se zkracenym rokem ("14. 5. 26" misto "14. 5. 2026") — pro KPI dlazdice
// kde dlouhy 4-mistny rok zalamoval value na dva radky.
function formatDateShort(iso) {
  if (!iso || iso === "0") return "";
  try {
    const d = datumZIso(iso);
    if (isNaN(d)) return iso;
    return fmtDate(d);
  } catch { return iso; }
}

// Normalizuje hodnotu na pure YYYY-MM-DD (input type="date" vyžaduje tento formát).
// Effective hodnoty z /api/clients můžou být ISO datetime ("2024-01-15T00:00:00").
function isoDateOnly(v) {
  if (!v) return "";
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : "";
}

// Délka spolupráce.
// Pravidla (2.6.2026 v9):
//   Počítá se VŽDY k dnešku. Datum konce se použije jen pokud UŽ NASTAL (ukončený klient).
//   Budoucí konec (klient pořád spolupracuje) se ignoruje a počítá se do dneška.
//   Příklad: Lenka Brynychová, začátek 25.9.2025, konec 4.9.2026 (v budoucnu) → k 2.6.2026
//   je to ~8 měsíců, ne "1 rok" (to by bylo start→budoucí konec).
//   Bez konce → běžící kontrakt, počítá se do dneška.
function calcMonthsCooperation(startIso, endIso, _typSpoluprace) {
  if (!startIso) return null;
  const start = new Date(startIso);
  if (isNaN(start)) return null;

  let end = new Date(); // default dnešek
  if (endIso) {
    const e = new Date(endIso);
    // konec použij jen pokud je platný A už nastal (minulost); budoucí konec = počítej k dnešku
    if (!isNaN(e) && e < end) end = e;
  }

  const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  return Math.max(0, months);
}

// Formátování trvání spolupráce — "1 rok 3 měsíce", "8 měsíců", …
function formatCooperationDuration(months) {
  if (months === null || months === undefined) return null;
  if (months < 1) return "Méně než měsíc";
  const years = Math.floor(months / 12);
  const rest = months % 12;
  const parts = [];
  if (years > 0) parts.push(`${years} ${years === 1 ? "rok" : years < 5 ? "roky" : "let"}`);
  if (rest > 0) parts.push(`${rest} ${rest === 1 ? "měsíc" : rest < 5 ? "měsíce" : "měsíců"}`);
  if (parts.length === 0) return "0 měsíců";
  return parts.join(" ");
}

// Sekce s rozbalovací hlavičkou. Default rozbalená; klikem na hlavičku se zavře/otevře.
// 5.9.2026 (fáze 4b): sekce detailu vypadají jako karty ve vzorníku, tedy
// gradientová lišta s ikonou, názvem, podtitulkem a odznakem s počtem.
// Dřív měla každá sekce vlastní přízvukovou barvu (blue, green, amber, rose,
// indigo…), což na jedné stránce dělalo šest různých karet. `accent` zůstává
// v props kvůli místům, která ho posílají, ale na vzhled už nemá vliv.
// vzdyPripojeno: obsah se po sbalení jen skryje, neodpojí se. Používají to sekce,
// které samy hlásí počet do odznaku v hlavičce (Volno, Hodnocení, Děti, Bootcamp,
// Kamarádky) — odpojený obsah by počet neměl odkud vzít (9.9.2026).
// `pevne` (1. 10. 2026): sekce je vždy otevřená, bez šipky a bez sbalení (Kontakt u nutriční).
function ExpandableSection({ icon: Icon, title, subtitle, children, defaultOpen = true, accent = "slate", count, info, action, vzdyPripojeno = false, pevne = false }) {
  const [openStav, setOpen] = useState(defaultOpen);
  const open = pevne ? true : openStav;
  // Header je <div role="button"> ne <button>, aby do něj šlo vnořit action button (Export PDF apod.)
  // bez invalid HTML <button><button>. Klávesnicová ovládání zachováno přes onKeyDown.
  return (
    <div className="glass min-w-0 overflow-hidden !p-0">
      <div
        role={pevne ? undefined : "button"}
        tabIndex={pevne ? undefined : 0}
        aria-expanded={pevne ? undefined : open}
        onClick={pevne ? undefined : () => setOpen((o) => !o)}
        onKeyDown={pevne ? undefined : (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen((o) => !o); } }}
        data-nadpis-karty
        className={`flex w-full select-none items-center gap-2.5 bg-gradient-to-r from-brand-950 via-brand-900 to-brand-700 px-4 py-3 text-left ${pevne ? "" : "cursor-pointer"}`}
      >
        {Icon && <Icon className="h-5 w-5 shrink-0 text-white" />}
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="min-w-0 font-serif text-lg font-bold leading-tight text-white">{title}</h3>
            {info && <InfoTip text={info} />}
          </div>
          {subtitle && <div className="truncate text-[11px] text-white/70">{subtitle}</div>}
        </div>
        {count !== undefined && (
          <span className="shrink-0 rounded-full bg-white/15 px-2.5 py-1 text-xs font-bold tabular-nums text-white">{count}</span>
        )}
        {action && (
          <span onClick={(e) => e.stopPropagation()} className="shrink-0">{action}</span>
        )}
        {!pevne && <ChevronDown className={`h-4 w-4 shrink-0 text-white transition-transform ${open ? "" : "-rotate-90"}`} />}
      </div>
      {open
        ? <div className="p-4 sm:p-5">{children}</div>
        : (vzdyPripojeno ? <div className="hidden">{children}</div> : null)}
    </div>
  );
}

// 3. 11. 2026 (schválený mockup): sekce Dokumenty dole v kartě, ve výchozím stavu zavřená.
// Podepsané smlouvy z elektronického podpisu. Bez dokumentů se sekce neukáže.
function SekceDokumenty({ klientId }) {
  const { nacteno, dokumenty } = useDokumentyKlientky(klientId);
  if (!nacteno || !dokumenty.length) return null;
  return (
    <ExpandableSection icon={FolderOpen} title="Dokumenty" subtitle="Podepsané smlouvy klientky" count={dokumenty.length} defaultOpen={false}>
      <DokumentyKlientky dokumenty={dokumenty} />
    </ExpandableSection>
  );
}

// 9.7.2026 (Masterplan 2.0) — Masterplán a Aktivní víkendy jsou defaultně
// sbalené a v hlavičce ukazují počty. Počet se načítá lehkým fetchhem tady
// ve wrapperu (sekce uvnitř je unmountnutá dokud se nerozbalí, takže by
// count jinak nebyl k dispozici). Po rozbalení si sekce data načte znovu
// a hlásí změny přes onCount, takže badge zůstává aktuální i při editaci.
function notionIdFromUrlCd(u) {
  const m = String(u || "").match(/([0-9a-f]{32}|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);
  return m ? m[1] : "";
}

// 9.7.2026 — profilová fotka klientky z portálu (clients.data.profile_foto,
// nahrává si ji sama v kartě Profil klienta). Bez fotky se nic nezobrazí
// (hlavička zůstává jako dřív), s fotkou kulatý avatar před jménem.
function ClientPhotoAvatar({ klientId, klientNotion, klientName }) {
  const id = klientId || notionIdFromUrlCd(klientNotion);
  const [foto, setFoto] = useState(null);
  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await apiFetch(`/api/client-photo?klient_id=${encodeURIComponent(id)}`);
        const j = await r.json();
        if (!cancelled && j.ok && j.foto) setFoto(j.foto);
      } catch (_) { /* ticho */ }
    })();
    return () => { cancelled = true; };
  }, [id]);
  if (!foto) return null;
  return (
    <img
      src={foto}
      alt={klientName || "Profilová fotka"}
      title="Profilová fotka z klientského portálu"
      className="w-28 h-28 rounded-full object-cover border-[3px] border-white/60 shadow-lg demo-sensitive"
    />
  );
}

function czPluralUkoly(n) {
  return n === 1 ? "1 úkol" : n >= 2 && n <= 4 ? `${n} úkoly` : `${n} úkolů`;
}
function czPluralVikendy(n) {
  return n === 1 ? "1 víkend" : n >= 2 && n <= 4 ? `${n} víkendy` : `${n} víkendů`;
}


function WeekendsExpandable({ klientId, klientNotion, readOnly }) {
  const id = klientId || notionIdFromUrlCd(klientNotion);
  const [count, setCount] = useState(null);
  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await apiFetch(`/api/client-weekends?klient_id=${encodeURIComponent(id)}`);
        const j = await r.json();
        if (cancelled || !j.ok) return;
        setCount((j.weekends || []).length);
      } catch (_) { /* ticho */ }
    })();
    return () => { cancelled = true; };
  }, [id]);
  return (
    <ExpandableSection
      icon={Mountain}
      title="Aktivní víkendy"
      subtitle="Odznaky za víkendové akce v portálu"
      accent="green"
      defaultOpen={false}
      count={count == null ? undefined : czPluralVikendy(count)}
    >
      <ClientWeekendsSection
        klientId={klientId}
        klientNotion={klientNotion}
        readOnly={readOnly}
        onCount={(c) => setCount(c)}
      />
    </ExpandableSection>
  );
}

// ?focus=jid-*/mp-* (deep-link z nutri dashboardu) → sekce Výživa se má rovnou
// otevřít, aby scroll kotvy (JidelnicekSection/MasterplanSection) existovaly.
const VYZIVA_FOCUS = (() => {
  try { return /^(jid-|mp-)/.test(new URLSearchParams(window.location.search).get("focus") || ""); }
  catch { return false; }
})();

// Nutriční sekce (10.7.2026): nárok na výživové služby + poslední nutriční
// konzultace + jídelníček na míru (dotazník z portálu → AI návrh → schválení).
// jenMasterplan (13.7.2026): trenérský pohled — vidí POUZE plnění masterplánu
// a úkoly (read-only), bez jídelníčku a nutričních chipů.
function VyzivaExpandable({ klientId, klientNotion, klientName, readOnly, narokNaVyzSl, posledniVyziva, defaultOpen = false, jenMasterplan = false }) {
  const [stavLabel, setStavLabel] = useState(null);
  const [mpCount, setMpCount] = useState(null);
  const [nutriPocet, setNutriPocet] = useState(null);
  const [inbodyPocet, setInbodyPocet] = useState(null);
  const [mpPending, setMpPending] = useState(0);
  // 1. 11. 2026: Zpětná vazba výživa (Hodnocení výživy ze sales) vidí owner a CSM, trenér ani nutriční ne.
  const [zvPocet, setZvPocet] = useState(null);
  const vidiZpetnouVazbu = ["owner", "csm"].includes(String(getCurrentUser()?.role || "").toLowerCase());
  const maNarok = String(narokNaVyzSl || "").trim().toLowerCase() === "ano";
  const badgeParts = [];
  if (mpCount != null && mpCount > 0) badgeParts.push(czPluralUkoly(mpCount) + (mpPending > 0 ? ` +${mpPending}` : ""));
  if (stavLabel) badgeParts.push(stavLabel);
  return (
    <ExpandableSection
      icon={Salad}
      title="Výživa"
      subtitle="Masterplán, nutriční služby a jídelníček na míru"
      accent={mpPending > 0 ? "amber" : "green"}
      defaultOpen={defaultOpen}
      count={badgeParts.length ? badgeParts.join(", ") : undefined}
    >
      <div className="space-y-2.5">
        {/* Přehled nutričních služeb (trenér nevidí) */}
        {!jenMasterplan && <div className="flex flex-wrap items-center gap-2 text-[13px]">
          <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border font-medium ${
            maNarok ? "bg-emerald-50 border-emerald-200 text-emerald-700" : "bg-slate-50 border-slate-200 text-slate-500"
          }`}>
            <Award className="w-3.5 h-3.5" />
            Výživové služby: {maNarok ? "Ano" : "Ne"}
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-slate-50 border border-slate-200 text-slate-600">
            <Calendar className="w-3.5 h-3.5 opacity-60" />
            Poslední nutriční konzultace: <span className="font-semibold">{formatDate(posledniVyziva) || "—"}</span>
          </span>
        </div>}

        {/* Nutriční reporty — konzultace + analýzy jídelníčku (13.7.2026, trenér nevidí) */}
        {!jenMasterplan && (
          <VyzivaPodsekce
            id="reporty"
            icon={FileText}
            tone="emerald"
            title="Nutriční reporty"
            poznamka="konzultace a analýzy jídelníčku"
            badge={nutriPocet ? <VyzivaOdznak>{nutriPocet}</VyzivaOdznak> : <VyzivaOdznak tone="slate">zatím žádný</VyzivaOdznak>}
          >
            <NutriReportySection
              klientId={klientId}
              klientNotion={klientNotion}
              klientName={klientName}
              readOnly={readOnly}
              onCount={setNutriPocet}
            />
          </VyzivaPodsekce>
        )}

        {!jenMasterplan && vidiZpetnouVazbu && (
          <VyzivaPodsekce
            id="zpetna-vazba"
            icon={Star}
            tone="violet"
            title="Zpětná vazba výživa"
            poznamka="hodnocení konzultací z obvolávání"
            badge={zvPocet ? <VyzivaOdznak>{zvPocet}</VyzivaOdznak> : zvPocet === 0 ? <VyzivaOdznak tone="slate">zatím žádná</VyzivaOdznak> : null}
          >
            <ZpetnaVazbaVyzivaSection klientId={klientId} onCount={setZvPocet} />
          </VyzivaPodsekce>
        )}

        {/* Měření InBody (3.8.2026) — stejný přehled jako klientská appka (tab Měření):
            poslední výsledky, grafy, historie. Vidí owner/manager/CSM/nutritionist,
            trenér ne (jenMasterplan). Části jsou sbalené dropdowny. */}
        {!jenMasterplan && (
          <VyzivaPodsekce
            id="inbody"
            icon={Activity}
            tone="violet"
            title="Měření InBody"
            poznamka="výsledky a vývoj v čase"
            badge={inbodyPocet ? <VyzivaOdznak>{inbodyPocet}</VyzivaOdznak> : <VyzivaOdznak tone="slate">žádné</VyzivaOdznak>}
          >
            <InBodySection klientId={klientId} klientNotion={klientNotion} onCount={setInbodyPocet} />
          </VyzivaPodsekce>
        )}

        {/* Masterplán — denní/týdenní úkoly klienta v portálu */}
        <VyzivaPodsekce
          id="masterplan"
          icon={ClipboardList}
          tone="indigo"
          title="Masterplán"
          poznamka="denní a týdenní úkoly v portálu"
          defaultOpen={jenMasterplan}
          badge={(
            <>
              {mpCount ? <VyzivaOdznak>{czPluralUkoly(mpCount)}</VyzivaOdznak> : <VyzivaOdznak tone="slate">žádné úkoly</VyzivaOdznak>}
              {mpPending > 0 && <VyzivaOdznak tone="amber">+{mpPending} čeká</VyzivaOdznak>}
            </>
          )}
        >
          <MasterplanSection
            klientId={klientId}
            klientNotion={klientNotion}
            klientName={klientName}
            readOnly={readOnly}
            onCount={(c, p) => { setMpCount(c); setMpPending(p || 0); }}
          />
        </VyzivaPodsekce>

        {/* Jídelníček na míru (trenér nevidí) */}
        {!jenMasterplan && (
          <VyzivaPodsekce
            id="jidelnicek"
            icon={Salad}
            tone="lime"
            title="Jídelníček"
            poznamka="dotazník, AI návrh, schválení"
            badge={stavLabel ? <VyzivaOdznak tone="amber">{stavLabel}</VyzivaOdznak> : <VyzivaOdznak tone="slate">dotazník chybí</VyzivaOdznak>}
          >
            <JidelnicekSection
              klientId={klientId}
              klientNotion={klientNotion}
              klientName={klientName}
              readOnly={readOnly}
              onCount={(s) => setStavLabel(s)}
            />
          </VyzivaPodsekce>
        )}
      </div>
    </ExpandableSection>
  );
}

// 9.9.2026 — podsekce Výživy jsou rozbalovačky, stejně jako v Tréninkovém profilu.
// Vedle názvu je počet, takže i zavřená sekce říká, co klientka má. Stav rozbalení
// se drží v localStorage a zavřená část se vůbec nenačítá (rychlejší otevření detailu).
const VYZIVA_OTEVRENE_KLIC = "fw40_vyziva_otevrene";
function nactiVyzivaOtevrene() {
  if (typeof window === "undefined") return {};
  try { return JSON.parse(window.localStorage.getItem(VYZIVA_OTEVRENE_KLIC) || "{}") || {}; } catch { return {}; }
}
function ulozVyzivaOtevrene(mapa) {
  if (typeof window === "undefined") return;
  try { window.localStorage.setItem(VYZIVA_OTEVRENE_KLIC, JSON.stringify(mapa)); } catch { /* quota */ }
}

function VyzivaOdznak({ children, tone = "brand" }) {
  const barvy = {
    brand: "bg-brand-100 text-brand-800",
    amber: "bg-amber-100 text-amber-800",
    slate: "bg-slate-100 text-slate-600",
    emerald: "bg-emerald-100 text-emerald-800",
  };
  return <span className={`inline-flex min-w-[24px] items-center justify-center rounded-full px-2 py-0.5 text-xs font-bold tabular-nums ${barvy[tone] || barvy.brand}`}>{children}</span>;
}

function VyzivaPodsekce({ id, icon: Icon, tone = "emerald", title, badge, poznamka, defaultOpen = false, children }) {
  const tones = {
    emerald: "bg-emerald-50 text-emerald-600 border-emerald-100",
    indigo: "bg-plum-50 text-plum-600 border-plum-100",
    lime: "bg-lime-50 text-lime-600 border-lime-100",
    violet: "bg-brand-50 text-brand-600 border-brand-100",
  };
  const [open, setOpen] = useState(() => {
    const m = nactiVyzivaOtevrene();
    return typeof m[id] === "boolean" ? m[id] : defaultOpen;
  });
  const prepni = () => {
    setOpen((o) => {
      const novy = !o;
      const m = nactiVyzivaOtevrene();
      m[id] = novy;
      ulozVyzivaOtevrene(m);
      return novy;
    });
  };
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <div
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onClick={prepni}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); prepni(); } }}
        className="flex min-h-[56px] cursor-pointer select-none items-center justify-between gap-2.5 px-4 py-3"
      >
        <div className="flex min-w-0 items-center gap-2.5">
          <span className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-xl border ${tones[tone] || tones.emerald}`}>
            <Icon className="h-4 w-4" />
          </span>
          <span className="truncate text-sm font-bold text-slate-800">{title}</span>
          {badge}
        </div>
        <div className="flex flex-shrink-0 items-center gap-2">
          {poznamka && <span className="hidden text-xs text-slate-500 sm:inline">{poznamka}</span>}
          <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open ? "" : "-rotate-90"}`} />
        </div>
      </div>
      {open && <div className="border-t border-slate-100 px-4 py-3.5">{children}</div>}
    </div>
  );
}

// Pole klíč/hodnota v gridu, pro Spolupráce / Kontakt / Finance.
// Pokud item.forceShow=true, pole se zobrazí i s prázdnou hodnotou (jako "—").
// Pokud item.alert=true (string), zobrazí pod hodnotou červený alert badge.
// 5.9.2026 (fáze 4b): na telefonu je z mřížky seznam řádků „popisek vlevo,
// hodnota vpravo" (schváleno). Dřív měl každý údaj ikonu a popisek nad
// hodnotou a zabral skoro 60 px, takže devět údajů bylo přes půl obrazovky.
// Na počítači zůstávají dva až tři sloupce i s ikonami.
function FieldGrid({ items }) {
  const uzka = useUzkaObrazovka();
  const visible = items.filter((i) => {
    if (i.forceShow) return true;
    return i.value !== null && i.value !== undefined && i.value !== "" && i.value !== 0;
  });
  if (visible.length === 0) {
    return <div className="text-sm text-slate-400 italic">Žádné údaje</div>;
  }
  if (uzka) {
    return (
      <div className="divide-y divide-slate-100">
        {visible.map((item, i) => {
          const isEmpty = item.value === null || item.value === undefined || item.value === "" || item.value === 0;
          return (
            <div key={i} className="flex min-h-[44px] items-center gap-3 py-2">
              <span className="shrink-0 text-[13px] text-slate-500">{item.label}</span>
              <span className="ml-auto flex min-w-0 items-center justify-end gap-1.5">
                {item.copy && !isEmpty && <CopyButton value={item.copy} title={`Zkopírovat ${item.label.toLowerCase()}`} />}
                <span className={`min-w-0 break-words text-right text-sm font-bold ${item.demoSensitive ? "demo-sensitive" : ""} ${isEmpty ? "text-slate-400" : "text-slate-900"}`}>
                  {item.link ? (
                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-brand-deep underline-offset-2 hover:underline">
                      {item.value}
                    </a>
                  ) : (isEmpty ? "—" : item.value)}
                </span>
                {item.alert && (
                  <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-rose-50 px-2 py-0.5 text-[11px] font-bold text-rose-700">
                    <AlertTriangle className="h-3 w-3" /> {item.alert}
                  </span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {visible.map((item, i) => {
        const Icon = item.icon;
        const isEmpty = item.value === null || item.value === undefined || item.value === "" || item.value === 0;
        return (
          <div key={i} className="flex items-start gap-2.5 min-w-0">
            <div className="flex flex-col items-center gap-1.5 flex-shrink-0 w-6">
              {Icon && <Icon className={`w-4 h-4 mt-0.5 ${item.alert ? "text-rose-500" : "text-slate-400"}`} />}
              {item.copy && !isEmpty && <CopyButton value={item.copy} title={`Zkopírovat ${item.label.toLowerCase()}`} />}
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-sm text-slate-500">{item.label}</div>
              <div className={`flex items-start gap-1.5 text-base font-medium ${isEmpty ? "text-slate-400" : "text-slate-900"}`}>
                <div className={`min-w-0 break-words ${item.demoSensitive ? "demo-sensitive" : ""}`}>
                  {item.link ? (
                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-brand-deep hover:underline">
                      {item.value}
                    </a>
                  ) : (isEmpty ? "—" : item.value)}
                </div>
              </div>
              {item.alert && (
                <div className="mt-1 inline-flex items-center gap-1 text-xs font-medium px-1.5 py-0.5 rounded bg-rose-50 text-rose-700 border border-rose-200">
                  <AlertTriangle className="w-3 h-3" /> {item.alert}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// Dlaždice kontaktu (1. 10. 2026): stejný tvar jako KPI dlaždice (proužek, drobný
// popisek, velká hodnota), vedle hodnoty malé tlačítko pro zkopírování do schránky.
function KontaktDlazdice({ label, hodnota, ikona: Ikona, citlive = false, mensi = false }) {
  const prazdne = !hodnota;
  // Telefon o devíti číslicích se ukáže po trojicích (602 612 254), kopíruje se bez mezer.
  const cislice = String(hodnota || "").replace(/\D/g, "");
  const zobraz = !citlive && cislice.length === 9 ? cislice.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3") : hodnota;
  return (
    <div className="min-w-0 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-glass">
      <div className="h-1.5 bg-brand" />
      <div className="p-3">
        <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-slate-400">
          {Ikona && <Ikona className="h-3.5 w-3.5" />}{label}
        </div>
        <div className="mt-0.5 flex items-center gap-2">
          <span className={`min-w-0 break-all font-bold ${mensi ? "text-base sm:text-lg" : "text-lg sm:text-xl"} ${prazdne ? "text-slate-400" : "text-slate-900"} ${citlive ? "demo-sensitive" : ""}`}>{prazdne ? "—" : zobraz}</span>
          {!prazdne && <CopyButton value={hodnota} title={`Zkopírovat ${label.toLowerCase()}`} className="!h-8 !w-8" />}
        </div>
      </div>
    </div>
  );
}

// Stage badge — barevný tag pro každou hodnotu Stage v sales pipeline.
// Mapování barev semantické: Lead/Kvalifikace = pre-pipeline (blue/cyan), Trial = active (amber),
// Trial proběhl = awaiting decision (violet), Deal = success (emerald), Prohra/NQLead = lost/dead (rose/slate).
function StageBadge({ stage }) {
  if (!stage) return null;
  const palette = {
    "Lead":          { bg: "bg-blue-50", text: "text-blue-800", border: "border-blue-200" },
    "Kvalifikace":   { bg: "bg-sky-50", text: "text-sky-800", border: "border-sky-200" },
    "NQLead":        { bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-300" },
    "Trial":         { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200" },
    "Trial proběhl": { bg: "bg-brand-50", text: "text-brand-800", border: "border-brand-200" },
    "Deal":          { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200" },
    "Prohra":        { bg: "bg-rose-50", text: "text-rose-800", border: "border-rose-200" },
  };
  const colors = palette[stage] || { bg: "bg-slate-50", text: "text-slate-700", border: "border-slate-200" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-sm font-medium rounded-lg border ${colors.bg} ${colors.text} ${colors.border}`}>
      {stage}
    </span>
  );
}

// 2. 10. 2026 (mockup „Klientky bez Notionu“, schválená varianta A s přepínačem stavu 2):
// po vypnutí Notionu se stav a stage mění tady v úpravě Spolupráce. Vypínač se čte jednou
// za načtení stránky z /api/sales?akce=notion_rezim.
let _notionVypnutoPromise = null;
function useNotionVypnuto() {
  const [v, setV] = useState(null);
  useEffect(() => {
    if (!_notionVypnutoPromise) {
      _notionVypnutoPromise = apiFetch("/api/sales?akce=notion_rezim").then((r) => (r.ok ? r.json() : {})).then((j) => !!j.vypnuto).catch(() => false);
    }
    let zr = false;
    _notionVypnutoPromise.then((x) => { if (!zr) setV(x); });
    return () => { zr = true; };
  }, []);
  return v;
}
// Kdo smí přejmenovat klientku (2. 10. 2026, Láďa): owner a CSM vždy, sales jen nový
// kontakt (stage Lead, Kvalifikace, Trial a bez stavu spolupráce), manažer nikdy.
// Stejné pravidlo hlídá server v client-training-profile.js (action rename).
function smiPrejmenovatKlientku(role, client, stage) {
  if (role === "owner" || role === "csm") return true;
  if (role !== "sales") return false;
  const stav = String(client?.stav || "").trim();
  return !stav && /^(lead|kvalifikace|trial)/i.test(String(stage || client?.stage || "").trim());
}
const STAVY_KLIENTKY = [
  { key: "Aktivní", tecka: "bg-emerald-500", zap: "border-emerald-500 bg-emerald-50 text-emerald-800",
    potvrzeni: "Klientka bude zase aktivní, uvidí ji trenér i aplikace." },
  { key: "Přerušeno", tecka: "bg-amber-500", zap: "border-amber-500 bg-amber-50 text-amber-800",
    potvrzeni: "Pauza. Po prvním tréninku se klientka sama vrátí na Aktivní. Doplň Konec spolupráce, do kdy pauza může trvat." },
  { key: "Ukončeno", tecka: "bg-rose-600", zap: "border-rose-500 bg-rose-50 text-rose-800",
    potvrzeni: "Spolupráce skončí, do Konce se zapíše dnešek a klientka se objeví sales v Bývalých klientkách. Má 90 dní na vychození zbývajících tréninků (v aplikaci je vidí a může si brát last minute), musí ale dodržet minimum svého balíčku. Zkontroluj fakturaci ve FAPI." },
];

// Mini badge "🔒 Notion (do migrace)" — pro pole co se nedají editovat v aplikaci
// (Stage / Stav spolupráce / BLACKLIST jsou read-only z Notion sync, do cutoveru na Postgres).
function LockBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 ml-1.5 px-1.5 py-0.5 text-[11px] font-medium text-slate-500 bg-slate-100 border border-slate-200 rounded"
      title="Tato hodnota se aktualizuje z Notion (přes Leady sync). Editovat půjde po migraci na Postgres."
    >
      <Lock className="w-2.5 h-2.5" /> Notion
    </span>
  );
}

// 9.9.2026 (redesign Vstupního dotazníku) — nadpis skupiny uvnitř sekce.
// Světle fialový pruh přes celou šířku, aby bylo poznat, kde skupina začíná.
function SkupinaNadpis({ children, right }) {
  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-2 rounded-xl bg-brand-100 px-3 py-2">
      <span className="text-[15px] font-extrabold leading-tight tracking-tight text-brand-800">{children}</span>
      {right}
    </div>
  );
}

// Dlaždice jedné odpovědi z poptávky. Prázdná se NEskrývá (na rozdíl od FieldGridu),
// ukáže se přerušovaným rámečkem jako "nevyplněno", aby sales viděl, na co se doptat.
function DotaznikKarta({ label, value }) {
  const v = value === null || value === undefined ? "" : String(value).trim();
  if (!v) {
    return (
      <div className="min-h-[66px] rounded-xl border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5">
        <div className="text-xs font-bold text-slate-600">{label}</div>
        <div className="mt-1 text-[13px] italic text-slate-400">nevyplněno</div>
      </div>
    );
  }
  return (
    <div className="min-h-[66px] rounded-xl border border-slate-200 bg-white px-3 py-2.5">
      <div className="text-xs font-bold text-slate-600">{label}</div>
      <div className="mt-1 break-words text-[15px] font-bold leading-tight text-slate-900">{v}</div>
    </div>
  );
}

// Poznámka od sales jako karta. Zdravotní omezení červeně, ať se nepřehlédne.
// Prázdné se nevykreslí vůbec, sesbírají se do jednoho řádku s pilulkami.
function SalesNoteCard({ label, value, alert }) {
  const v = (value || "").trim();
  if (!v) return null;
  return (
    <div className={`rounded-xl border p-3 ${alert ? "border-rose-200 bg-rose-50/60" : "border-slate-200 bg-white"}`}>
      <div className={`flex items-center gap-1.5 text-xs font-bold ${alert ? "text-rose-700" : "text-slate-600"}`}>
        {alert && <AlertTriangle className="h-3.5 w-3.5 shrink-0" />}{label}
      </div>
      <div className="mt-1.5 whitespace-pre-wrap break-words text-sm leading-snug text-slate-900">{v}</div>
    </div>
  );
}


// Reusable rolovací select s ikonou a labelem — používá se v edit režimu Spolupráce + Finance.
// Options jsou pole stringů. Pokud `value` není v options (data outdated), helper addCurrentToOptions
// jí stejně přidá na začátek aby se neztratila.
function SelectField({ label, icon: Icon, value, onChange, options, disabled, placeholder }) {
  const list = Array.isArray(options) ? options : [];
  return (
    <label className="block text-sm">
      <div className="flex items-center gap-2 text-slate-600 mb-1.5 font-medium">
        {Icon && <Icon className="w-4 h-4" />} {label}
      </div>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="field w-full font-medium"
      >
        <option value="">{placeholder || "Vyber"}</option>
        {list.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
    </label>
  );
}

// Vnořená položka uvnitř seskupené dlaždice (Celkem / Celkem odchozeno).
// Klikatelná jen pokud má detail (hasDetail) — pak spíná příslušný rozpad níže.
function SubStat({ label, value, onClick, open = false, hasDetail = false, valueClass = "" }) {
  const clickable = hasDetail && typeof onClick === "function";
  return (
    <button
      type="button"
      onClick={clickable ? onClick : undefined}
      className={`w-full flex items-center justify-between gap-2 rounded-lg px-2.5 py-1.5 border bg-white border-slate-200 text-left transition ${clickable ? "cursor-pointer hover:bg-slate-50" : "cursor-default"} ${open ? "ring-1 ring-slate-300 bg-slate-50" : ""}`}
    >
      <span className="text-sm text-slate-600 flex items-center gap-1">
        {label}
        {hasDetail && <ChevronDown className={`w-3 h-3 text-slate-400 transition ${open ? "rotate-180" : ""}`} />}
      </span>
      <span className={`text-sm font-semibold tabular-nums ${valueClass || "text-slate-900"}`}>{value}</span>
    </button>
  );
}

// Heatmap měsíčních tréninků (12 buněk). Zelená = odchozené tréninky (intenzita podle počtu).
// Červený badge (vpravo nahoře) = propadlé z nesplněného minima (Log Expired Schváleno=ANO).
// Oranžový badge (vlevo nahoře) = pozdě zrušené (trenér označil PROPADL v rozvrhu). Oddělené
// barvy i rohy → oba jdou vidět naráz i když měsíc má obojí.
function MonthlyHeatmap({ months, propadle = [], late = [], rok = null }) {
  const uzka = useUzkaObrazovka();
  // 8.9.2026 (rozhodnuti ownera): v bunce je pocet treninku, o ktere klient v mesici prisel
  // z permanentky = odchozene PLUS pozde zrusene. Oranzovy odznak dal rika, kolik z toho bylo
  // pozde zrusenych. Propadle z nesplneneho minima (cerveny odznak) se neprictou, to nejsou
  // rezervace. Vypocty (stav treninku, mesicni minimum, bonusy) dal jedou z ciste dochazky.
  const bunky = months.map((v, i) => (parseInt(v, 10) || 0) + (parseInt(late[i], 10) || 0));
  const max = Math.max(...bunky, 1);
  const today = new Date();
  const letosniRok = today.getFullYear();
  // Prstenec u aktualniho mesice a vybledle budouci mesice davaji smysl jen u letosniho
  // roku. U starsich rocniku je odchozeny cely rok, u budoucich by bylo vybledle vsechno.
  const currentMonth = (rok === null || rok === letosniRok) ? today.getMonth() : (rok < letosniRok ? 11 : -1);
  return (
    <div>
      {/* Telefon (8.9.2026): dvanact sloupcu vedle sebe znamena bunku 26 px, do ktere se
          odznaky nevejdou a prekryvaji cislo. Sest mesicu na radek, bunka 52 px. */}
      <div className={uzka ? "grid grid-cols-6 gap-2" : "grid grid-cols-12 gap-1.5"}>
        {months.map((_, i) => {
          const v = bunky[i];
          const ratio = v / max;
          const cls =
            v === 0 ? "bg-slate-50 text-slate-300" :
            ratio > 0.8 ? "bg-emerald-500 text-white" :
            ratio > 0.6 ? "bg-emerald-400 text-white" :
            ratio > 0.4 ? "bg-emerald-300 text-emerald-900" :
            ratio > 0.2 ? "bg-emerald-200 text-emerald-900" :
            "bg-emerald-100 text-emerald-800";
          const isFuture = i > currentMonth;
          const ring = i === currentMonth ? "ring-2 ring-offset-1 ring-amber-400" : "";
          const propadlych = propadle[i] || 0;
          const lateCount = late[i] || 0;
          const titleParts = [`${MONTH_FULL[i]}: ${v} tréninků`];
          if (propadlych > 0) titleParts.push(`${propadlych} z nesplněného minima`);
          if (lateCount > 0) titleParts.push(`z toho ${lateCount} zrušených pozdě`);
          const titleText = titleParts.join(", ");
          return (
            <div key={i} className="text-center min-w-0 relative">
              {/* 8.7.2026: badges drženy UVNITŘ šířky buňky (right-0/left-0 místo -right/-left-1.5).
                  Negativní horizontální offset přesahoval do 6px mezery mezi buňkami, takže červený
                  badge (pravý roh) a oranžový badge sousedního měsíce (levý roh) se překrývaly. */}
              {propadlych > 0 && (
                <div
                  className="absolute -top-1.5 right-0 z-10 min-w-[20px] h-5 px-1 rounded-full bg-rose-500 text-white text-[11px] font-bold flex items-center justify-center shadow-md ring-2 ring-white tabular-nums"
                  title={`${propadlych} propadlých z nesplněného minima`}
                >
                  {propadlych}
                </div>
              )}
              {lateCount > 0 && (
                <div
                  className="absolute -top-1.5 left-0 z-10 min-w-[20px] h-5 px-1 rounded-full bg-amber-500 text-white text-[11px] font-bold flex items-center justify-center shadow-md ring-2 ring-white tabular-nums"
                  title={`${lateCount} zrušených pozdě (klient přišel o trénink)`}
                >
                  {lateCount}
                </div>
              )}
              <div className={`${uzka ? "h-[52px] rounded-xl text-lg" : "h-12 rounded-lg text-base"} flex items-center justify-center font-bold tabular-nums ${cls} ${ring} ${isFuture ? "opacity-40" : ""}`}
                   title={titleText}>
                {v || "—"}
              </div>
              <div className={`mt-1 ${uzka ? "text-[13px] font-semibold text-slate-600" : "text-xs text-slate-500"}`}>{MONTH_SHORT[i]}</div>
            </div>
          );
        })}
      </div>
      {/* Vysvetlivky: na telefonu pod sebou, ve trech sloupcich se lamaly pres tri radky. */}
      <div className={`mt-3 text-slate-500 ${uzka ? "space-y-1.5 text-[13px]" : "flex items-center gap-3 text-xs"}`}>
        <div className="flex items-center gap-1.5">
          <span className="inline-block w-3 h-3 rounded bg-emerald-300"></span>
          <span>Tréninky v měsíci, včetně pozdě zrušených</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="inline-block w-3 h-3 rounded-full bg-rose-500"></span>
          <span>Propadlé z nesplněného minima</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="inline-block w-3 h-3 rounded-full bg-amber-500"></span>
          <span>Z toho zrušené pozdě{uzka ? "" : " (klient o trénink přišel)"}</span>
        </div>
      </div>
    </div>
  );
}

// ClientCommentsPanel — vícevláknové komentáře ke klientovi (pinable, archive bez delete).
// Sekce: 📌 Pinned (top, žlutá), 💬 Aktivní (chronologicky), 📦 Archiv (collapsed).
// Confirm dialog před pin / archive akcí. Add new komentář dole + Cmd+Enter shortcut.
// SessionStorage cache pro komentare — instant first paint pri opetovnem otevreni klienta.
// Pri prvnim otevreni: ukaz cached (pokud je) okamzite + fetch fresh na pozadi.
// TTL 5 min (resp. cache se prepise pri kazdem fetchi).
const COMMENTS_CACHE_PREFIX = "fw40_client_comments_";
const COMMENTS_CACHE_TTL_MS = 5 * 60 * 1000;
function readCommentsCache(klient) {
  try {
    const raw = sessionStorage.getItem(COMMENTS_CACHE_PREFIX + klient);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || !Array.isArray(obj.comments)) return null;
    if (Date.now() - obj.savedAt > COMMENTS_CACHE_TTL_MS) return null;
    return obj.comments;
  } catch { return null; }
}
function writeCommentsCache(klient, comments) {
  try {
    sessionStorage.setItem(COMMENTS_CACHE_PREFIX + klient, JSON.stringify({ comments, savedAt: Date.now() }));
  } catch { /* quota / private mode — silent fail */ }
}

function ClientCommentsPanel({ client, canEdit }) {
  // 5.9.2026 (fáze 4b): telefon má jiné pole na komentář a Archiv jako tlačítko.
  const uzka = useUzkaObrazovka();
  // Inicializace z cache — instant first paint, pokud user otevre klienta podruhe.
  const cachedInit = client?.klient ? readCommentsCache(client.klient) : null;
  const [comments, setComments] = useState(cachedInit || []);
  // Backgroundovy fetch indikator — UI se NIKDY neblokuje skeletonem (zadani Lada 16.5.:
  // "chci aby se to nacetlo instantne, ne abych videl ze se nacita"). Input + list jsou
  // vzdy hned k dispozici. Komentare se objevi ve chvili kdy dorazi z backendu.
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState(null);
  const [draft, setDraft] = useState("");
  const [posting, setPosting] = useState(false);
  const [showArchive, setShowArchive] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(null); // { action: "pin"|"archive"|"delete", comment, newValue? }
  // Owner-only mazání komentářů (hard delete, neobnovitelné)
  const currentUser = getCurrentUser();
  const canDelete = currentUser?.role === "owner";
  const isOwner = currentUser?.role === "owner";

  // Edit komentare — optimistic update + rollback pri chybe.
  // Owner muze editovat vsechny komentare, ostatni jen sve vlastni (per autor_email match).
  const editComment = async (comment, newText) => {
    const snapshot = comments;
    const now = mistniCasKomentare();
    setComments((prev) => prev.map((c) =>
      c.id === comment.id ? { ...c, text: newText, aktualizovano: now } : c,
    ));
    try {
      const res = await apiFetch("/api/client-comments", {
        method: "POST",
        body: JSON.stringify({ action: "update", id: comment.id, text: newText }),
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.error || `HTTP ${res.status}`);
      }
      setError(null);
      // Update cache
      setComments((prev) => {
        writeCommentsCache(client.klient, prev);
        return prev;
      });
    } catch (e) {
      setComments(snapshot);
      setError(`Úprava komentáře selhala: ${e.message}`);
      throw e; // re-throw aby CommentBubble vedel ze save selhal
    }
  };

  // Load při mountu / změně klienta. Pokud je cache, ukaze ji okamzite a fetch ji refreshne na pozadi.
  // POZOR: UI je VZDY render-ready — input + list area jsou videt hned. Background fetch
  // pouze updatuje state kdyz dorazi nove data. Zadny skeleton, zadne "Nacitam...".
  useEffect(() => {
    let aborted = false;
    const cached = readCommentsCache(client.klient);
    if (cached) {
      setComments(cached);
    }
    // POZN: Nesetujeme setComments([]) pri no-cache — necht UI zustane prazdne ale render-ready.
    // Pokud klient nema cache, state je [] z initial value (above) — to je OK.
    setError(null);
    setFetching(true);
    apiFetch(`/api/client-comments?klient=${encodeURIComponent(client.klient)}${client.notion_id ? `&klientId=${encodeURIComponent(client.notion_id)}` : ""}`)
      .then(async (res) => {
        const j = await res.json();
        if (aborted) return;
        if (!res.ok) throw new Error(j.error || `HTTP ${res.status}`);
        const fresh = j.comments || [];
        setComments(fresh);
        writeCommentsCache(client.klient, fresh);
      })
      .catch((e) => !aborted && setError(e.message))
      .finally(() => !aborted && setFetching(false));
    return () => { aborted = true; };
  }, [client?.klient]);

  // Submit nového komentáře — INSTANT optimistic add (komentář se objeví okamžitě),
  // backend zápis na pozadí. Při chybě rollback + error toast.
  const submitDraft = async () => {
    const text = draft.trim();
    if (!text || posting) return;
    setError(null);

    // Optimistický komentář — zobrazí se hned. ID je tmp, po backend odpovědi se nahradí real ID.
    const tmpId = `tmp_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`;
    const now = mistniCasKomentare();
    const optimistic = {
      id: tmpId,
      klient: client.klient,
      text,
      autor_email: currentUser?.email || "",
      autor_name: currentUser?.name || currentUser?.email || "—",
      vytvoreno: now,
      pinned: false,
      archived: false,
      aktualizovano: now,
      edit_history: "",
      _optimistic: true,
    };
    const draftSnapshot = draft;
    setComments((prev) => [...prev, optimistic]);
    setDraft("");
    setPosting(true);

    try {
      const res = await apiFetch("/api/client-comments", {
        method: "POST",
        body: JSON.stringify({ action: "create", klient: client.klient, text }),
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error || `HTTP ${res.status}`);
      // Nahraď tmp komentář real verzí ze serveru (s real ID + timestamp).
      setComments((prev) => prev.map((c) => (c.id === tmpId ? j.comment : c)));
    } catch (e) {
      // Rollback: odeber optimistický komentář, vrať draft do textarea.
      setComments((prev) => prev.filter((c) => c.id !== tmpId));
      setDraft(draftSnapshot);
      setError(e.message);
    } finally {
      setPosting(false);
    }
  };

  // Pin / archive / delete — confirm dialog před akcí
  const askPin = (comment, newValue) => setConfirmDialog({ action: "pin", comment, newValue });
  const askArchive = (comment, newValue) => setConfirmDialog({ action: "archive", comment, newValue });
  const askDelete = (comment) => setConfirmDialog({ action: "delete", comment });
  // Confirm action — INSTANT optimistic update (UI okamžitě odpoví), backend volání na pozadí.
  // Při chybě backend → rollback state na původní hodnotu + error toast.
  const confirmAction = async () => {
    if (!confirmDialog) return;
    const { action, comment, newValue } = confirmDialog;
    setConfirmDialog(null);

    // 1. INSTANT optimistic update — uživatel okamžitě vidí změnu, žádný delay.
    const snapshot = comments; // pro případný rollback
    if (action === "delete") {
      setComments((prev) => prev.filter((c) => c.id !== comment.id));
    } else {
      setComments((prev) => prev.map((c) =>
        c.id === comment.id
          ? { ...c, [action === "pin" ? "pinned" : "archived"]: newValue }
          : c,
      ));
    }

    // 2. Backend call na pozadí. Pokud selže, rollback state.
    try {
      const payload = action === "delete"
        ? { action: "delete", id: comment.id }
        : { action, id: comment.id, [action === "pin" ? "pinned" : "archived"]: newValue };
      const res = await apiFetch("/api/client-comments", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.error || `HTTP ${res.status}`);
      }
      // Backend OK — state už je správný, nic dalšího není třeba.
      setError(null);
    } catch (e) {
      // Rollback: vrať původní seznam komentářů + zobraz error.
      setComments(snapshot);
      setError(`Akce "${action}" selhala: ${e.message}`);
    }
  };

  const pinned = comments.filter((c) => c.pinned && !c.archived);
  const active = comments.filter((c) => !c.pinned && !c.archived).sort((a, b) => (a.vytvoreno || "").localeCompare(b.vytvoreno || ""));
  const archived = comments.filter((c) => c.archived).sort((a, b) => (b.vytvoreno || "").localeCompare(a.vytvoreno || ""));

  const totalActive = pinned.length + active.length;

  return (
    <div className="mt-5 pt-5 border-t border-slate-100">
      <ConfirmDialog
        open={!!confirmDialog}
        title={
          confirmDialog?.action === "pin"
            ? (confirmDialog?.newValue ? "Připnout komentář?" : "Odepnout komentář?")
            : confirmDialog?.action === "archive"
              ? (confirmDialog?.newValue ? "Skrýt do archivu?" : "Obnovit z archivu?")
              : "Trvale smazat komentář?"
        }
        description={
          confirmDialog ? (
            <div className="space-y-2 mt-2 text-sm">
              <div className="bg-slate-50 border border-slate-200 rounded p-2 italic text-slate-700">
                "{confirmDialog.comment.text.substring(0, 120)}{confirmDialog.comment.text.length > 120 ? "…" : ""}"
              </div>
              <div className="text-xs text-slate-500">
                <span className="font-medium">{confirmDialog.comment.autor_name || confirmDialog.comment.autor_email}</span>
                {confirmDialog.comment.vytvoreno && `, ${formatCommentTime(confirmDialog.comment.vytvoreno)}`}
              </div>
              {confirmDialog.action === "pin" && (
                <div className="text-slate-500 text-xs">
                  {confirmDialog.newValue
                    ? "Komentář se zobrazí nahoře jako důležitý (žlutý badge)."
                    : "Komentář se vrátí mezi běžné aktivní komentáře."}
                </div>
              )}
              {confirmDialog.action === "archive" && (
                <div className="text-slate-500 text-xs">
                  {confirmDialog.newValue
                    ? "Komentář se skryje do archivu, ale zůstane v historii (lze obnovit)."
                    : "Komentář se vrátí mezi aktivní."}
                </div>
              )}
              {confirmDialog.action === "delete" && (
                <div className="rounded-xl border border-rose-300 bg-rose-50 p-2.5 text-xs text-rose-800 leading-relaxed">
                  <div className="font-bold mb-0.5 flex items-center gap-1">
                    <AlertTriangle className="w-3.5 h-3.5" /> Trvalé smazání
                  </div>
                  <div>
                    Komentář bude <strong>fyzicky odstraněn</strong> z databáze. Tato akce <strong>nelze vrátit zpět</strong>.
                    Pokud chceš jen schovat, zruš a zvol Archiv místo toho.
                  </div>
                </div>
              )}
            </div>
          ) : ""
        }
        confirmLabel={
          confirmDialog?.action === "pin"
            ? (confirmDialog?.newValue ? "Připnout" : "Odepnout")
            : confirmDialog?.action === "archive"
              ? (confirmDialog?.newValue ? "Skrýt do archivu" : "Obnovit")
              : "Trvale smazat"
        }
        cancelLabel="Zrušit"
        variant={
          confirmDialog?.action === "delete"
            ? "danger"
            : (confirmDialog?.action === "archive" && confirmDialog?.newValue ? "warning" : "default")
        }
        onConfirm={confirmAction}
        onCancel={() => setConfirmDialog(null)}
      />

      {/* Sub-header s počítadlem + popiskem — viditelny JEN kdyz jsou komentare.
          Pokud zadne, sekce vypada jako "samotny input" ke psani. */}
      {totalActive > 0 && (
        <div className="mb-4 flex items-center gap-2 flex-wrap">
          <span className="inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded-full bg-plum-50 text-plum-700 border border-plum-100">
            {totalActive} {totalActive === 1 ? "komentář" : (totalActive < 5 ? "komentáře" : "komentářů")}
          </span>
          {pinned.length > 0 && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-lg bg-amber-50 text-amber-700 border border-amber-200">
              <Pin className="w-3 h-3" /> {pinned.length} {pinned.length === 1 ? "připnutý" : (pinned.length < 5 ? "připnuté" : "připnutých")}
            </span>
          )}
          <span className="text-xs text-slate-500">
            Interní poznámky pro tým, sales calls, vývoj klienta.
          </span>
        </div>
      )}

      {/* UI je vzdy render-ready (input dole + list area zde) — neexistuje stav kdy by user
          videl skeleton blokujici interakci. Background fetch tise updatuje state kdyz dorazi. */}
      {(
        <div className="space-y-2.5">
          {/* Pinned section */}
          {pinned.length > 0 && (
            <div className="space-y-2.5">
              {pinned.map((c) => (
                <CommentBubble key={c.id} comment={c} canEdit={canEdit} canDelete={canDelete} canEditThis={canEdit && (isOwner || c.autor_email === currentUser?.email)} onPin={askPin} onArchive={askArchive} onDelete={askDelete} onEdit={editComment} />
              ))}
            </div>
          )}
          {pinned.length > 0 && active.length > 0 && (
            <div className="flex items-center gap-2 my-3">
              <div className="flex-1 h-px bg-slate-200" />
              <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Ostatní</span>
              <div className="flex-1 h-px bg-slate-200" />
            </div>
          )}
          {/* Active section */}
          {active.map((c) => (
            <CommentBubble key={c.id} comment={c} canEdit={canEdit} canDelete={canDelete} canEditThis={canEdit && (isOwner || c.autor_email === currentUser?.email)} onPin={askPin} onArchive={askArchive} onDelete={askDelete} onEdit={editComment} />
          ))}
          {/* Empty state se zobrazi JEN kdyz user nemuze pridavat (read-only role).
              Pokud canEdit, sekce zobrazi rovnou jen input dole — bez prazdneho boxu nad.
              Plus skryta behem fetching, aby neflashnula pri prvnim otevreni (zadani Lada 16.5.). */}
          {pinned.length === 0 && active.length === 0 && !canEdit && !fetching && (
            <div className="flex flex-col items-center justify-center py-10 px-6 bg-gradient-to-br from-plum-50/40 via-slate-50 to-brand-50/30 border border-slate-200 rounded-2xl">
              <div className="w-14 h-14 rounded-2xl bg-white border border-slate-200 shadow-sm flex items-center justify-center mb-3">
                <MessageSquare className="w-7 h-7 text-plum-400" />
              </div>
              <div className="text-base font-semibold text-slate-700 mb-1">Zatím žádné komentáře</div>
              <div className="text-xs text-slate-500 text-center max-w-sm">
                Zatím nikdo nic nenapsal.
              </div>
            </div>
          )}
          {/* Archive collapsed */}
          {archived.length > 0 && (
            <div className="mt-4 pt-3 border-t border-slate-100">
              <button
                type="button"
                onClick={() => setShowArchive((s) => !s)}
                aria-expanded={showArchive}
                className="btn btn-secondary w-full sm:w-auto"
              >
                <Archive className="h-4 w-4 shrink-0 text-slate-400" />
                <span className="flex-1 text-left">Archiv</span>
                <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-bold text-slate-600">{archived.length}</span>
                <ChevronDown className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${showArchive ? "rotate-180" : ""}`} />
              </button>
              {showArchive && (
                <div className="space-y-2.5 mt-3">
                  {archived.map((c) => (
                    <CommentBubble key={c.id} comment={c} canEdit={canEdit} canDelete={canDelete} canEditThis={canEdit && (isOwner || c.autor_email === currentUser?.email)} onPin={askPin} onArchive={askArchive} onDelete={askDelete} onEdit={editComment} />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* Add new — chat-style input. Enter odesle, Shift+Enter novy radek. */}
      {canEdit && (
        <div className="mt-5 relative">
          <div className={`rounded-2xl border bg-white transition-all ${uzka ? "border-slate-300 p-2 focus-within:border-2 focus-within:border-brand" : "border-slate-200 p-3 shadow-sm focus-within:border-brand focus-within:ring-2 focus-within:ring-brand-100"}`}>
            <div className="flex items-end gap-2">
              <textarea
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    submitDraft();
                  }
                }}
                placeholder="Napiš komentář ke spolupráci…"
                rows={1}
                onInput={(e) => {
                  // Pole roste s textem, od šesti řádků se zastaví a roluje uvnitř
                  // (schváleno 5.9.2026). Dřív byly napevno dva řádky.
                  e.target.style.height = "auto";
                  e.target.style.height = `${Math.min(e.target.scrollHeight, 150)}px`;
                }}
                disabled={posting}
                data-gramm="false"
                data-gramm_editor="false"
                data-enable-grammarly="false"
                className="min-w-0 flex-1 resize-none border-0 bg-transparent px-2 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-0 disabled:opacity-50"
                style={{ maxHeight: 150 }}
              />
              <button
                type="button"
                onClick={submitDraft}
                disabled={!draft.trim() || posting}
                aria-label="Odeslat komentář"
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-white transition-all disabled:cursor-not-allowed ${
                  !draft.trim() || posting ? "bg-slate-200" : "bg-gradient-to-br from-brand to-brand-deep active:scale-95"
                }`}
                title="Odeslat (Enter)"
              >
                {posting ? <RefreshCw className="h-5 w-5 animate-spin" /> : <Send className="h-5 w-5" />}
              </button>
            </div>
            {/* Na telefonu žádné klávesy nejsou, nápověda se ukazuje jen na počítači. */}
            {!uzka && (
              <div className="ml-1 mt-1.5 flex flex-wrap items-center gap-1.5 text-[11px] text-slate-400">
                <kbd className="rounded border border-slate-200 bg-slate-50 px-1.5 py-0.5 font-mono text-[11px] text-slate-600">Enter</kbd>
                <span>odešle,</span>
                <kbd className="rounded border border-slate-200 bg-slate-50 px-1.5 py-0.5 font-mono text-[11px] text-slate-600">Shift + Enter</kbd>
                <span>nový řádek</span>
              </div>
            )}
          </div>
        </div>
      )}

      {error && (
        <div className="mt-2 text-xs text-rose-600 bg-rose-50 border border-rose-200 rounded-xl p-2.5 flex items-start gap-2">
          <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
          <div><strong>Chyba:</strong> {error}</div>
        </div>
      )}
    </div>
  );
}


// Tabulka tréninků (historie / budoucnost). Sloupce: #, Datum, Čas, Trenér, Lokalita, Služba, Stav.
const BookingActionsContext = React.createContext(null);

// Zrušený trénink se nepočítá do ničeho (5. 9. 2026). Propadnutí má přednost:
// když někdo trénink označil jako propadlý, bere se jako propadlý, ne jako zrušený.
function jeZrusenyTrenink(b) {
  if (!b || b.propadnuti) return false;
  const s = (b.stav || "").toLowerCase();
  return s.includes("zruš") || s.includes("zrus") || s.includes("cancel");
}

// Je termín v budoucnosti? Rozhoduje jen datum, ne čas.
function jeBudouciTrenink(b) {
  if (!b || !b.date) return false;
  const d = datumZIso(b.date);
  if (isNaN(d)) return false;
  const dnes = new Date();
  dnes.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return d > dnes;
}

function BookingTable({ bookings, mode }) {
  const uzka = useUzkaObrazovka();
  const _ba = React.useContext(BookingActionsContext) || {};
  const canManage = !!_ba.canManage;
  const oznacitPropad = async (b, value) => {
    const ok = await confirmModal({
      title: value ? "Označit trénink jako propadlý?" : "Vrátit propadnutí?",
      description: value
        ? `${formatDate(b.date)} ${b.cas || ""}${b.trener ? ", " + b.trener : ""}. Použij, když klient zrušil méně než 24 h dopředu nebo trénink propadl. Sníží to stav tréninků klienta.`
        : `${formatDate(b.date)} ${b.cas || ""}. Trénink se přestane počítat jako propadlý.`,
      confirmLabel: value ? "Dát propadlé" : "Vrátit",
      variant: value ? "danger" : "primary",
    });
    if (!ok) return;
    const prevVal = !!b.propadnuti;
    // Optimistic — stejně jako v týdenním rozvrhu u trenéra: hned překlop UI, zápis běží na pozadí.
    if (_ba.onOptimistic) _ba.onOptimistic(b, value);
    try {
      const r = await apiFetch("/api/booking-propadnuti", { method: "POST", body: JSON.stringify({ date: b.date, cas: b.cas, klient: b.klientName || _ba.klientName, trener: b.trener, propadnuti: value ? "ano" : "" }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.error) throw new Error(j.error || "Nepodařilo se uložit");
      toast(value ? "Trénink označen jako propadlý." : "Propadnutí zrušeno.", "success");
      if (_ba.onReload) _ba.onReload(); // force reload z PG — potvrdi ulozeni a prepise serverovou cache
    } catch (e) {
      if (_ba.onOptimistic) _ba.onOptimistic(b, prevVal); // revert při chybě
      toast("Chyba: " + e.message, "error");
    }
  };
  if (!bookings || bookings.length === 0) {
    return <div className="text-sm text-slate-400 italic py-2">Žádné tréninky.</div>;
  }
  // Telefon (5. 9. 2026): tabulka o sedmi sloupcích se nevejde, jméno trenéra se ořezávalo
  // a lokalita se schovávala úplně. Místo ní řádek na trénink: datum vlevo, čas s trenérem
  // a lokalitou uprostřed, stav jako jedna kruhová ikona vpravo.
  if (uzka) {
    return (
      <div className="-mx-4 divide-y divide-slate-100 sm:-mx-5">
        {bookings.map((b, i) => {
          const dateD = b.date ? datumZIso(b.date) : null;
          const platneDatum = dateD && !isNaN(dateD);
          const dayName = platneDatum ? ["Ne","Po","Út","St","Čt","Pá","So"][dateD.getDay()] : "";
          const denMesic = platneDatum ? `${dateD.getDate()}. ${dateD.getMonth() + 1}.` : "—";
          const jeZruseny = jeZrusenyTrenink(b);
          const jeBudouci = !b.propadnuti && !jeZruseny && jeBudouciTrenink(b);
          const popisRadku = [b.trener, b.lokalita].filter(Boolean).join(", ") || "—";
          const dlazdice = b.propadnuti
            ? "bg-rose-100 text-rose-700"
            : jeZruseny
              ? "bg-slate-200 text-slate-500"
              : jeBudouci
                ? "bg-brand-50 text-brand-deep"
                : "bg-slate-100 text-slate-900";
          const casCls = b.propadnuti
            ? "text-slate-500 line-through"
            : jeZruseny
              ? "text-slate-400 line-through"
              : "text-slate-900";
          const radekCls = b.propadnuti ? "bg-rose-50/40" : jeZruseny ? "bg-slate-50" : "";
          const ovladacCls = "flex h-10 w-10 shrink-0 items-center justify-center rounded-full border";
          let ovladac;
          if (b.propadnuti) {
            ovladac = canManage ? (
              <button type="button" onClick={() => oznacitPropad(b, false)} title="Propadlý, klepnutím vrátit"
                className={`${ovladacCls} border-rose-200 bg-rose-100 text-rose-600`}>
                <RotateCcw className="w-5 h-5" />
              </button>
            ) : (
              <span className={`${ovladacCls} border-rose-200 bg-rose-100 text-rose-600`} title="Propadlý"><RotateCcw className="w-5 h-5" /></span>
            );
          } else if (jeZruseny) {
            ovladac = <span className={`${ovladacCls} border-slate-200 bg-slate-100 text-slate-400`} title="Zrušený"><X className="w-5 h-5" /></span>;
          } else if (jeBudouci) {
            ovladac = <span className={`${ovladacCls} border-slate-200 bg-white text-slate-400`} title="Naplánovaný"><Clock className="w-5 h-5" /></span>;
          } else {
            ovladac = canManage ? (
              <button type="button" onClick={() => oznacitPropad(b, true)} title="Proběhl, klepnutím označit jako propadlý"
                className={`${ovladacCls} border-emerald-200 bg-emerald-50 text-emerald-600`}>
                <Check className="w-5 h-5" />
              </button>
            ) : (
              <span className={`${ovladacCls} border-emerald-200 bg-emerald-50 text-emerald-600`} title="Proběhl"><Check className="w-5 h-5" /></span>
            );
          }
          return (
            <div key={`${b.date}-${b.cas}-${i}`} className={`flex items-center gap-3 px-3 py-2.5 ${radekCls}`}>
              <span className={`flex w-12 shrink-0 flex-col items-center rounded-xl py-1 ${dlazdice}`}>
                <span className="text-[11px] font-semibold uppercase leading-tight">{dayName}</span>
                <span className="text-sm font-bold tabular-nums leading-tight">{denMesic}</span>
              </span>
              <span className="min-w-0 flex-1">
                <span className={`block text-sm font-bold tabular-nums ${casCls}`}>{b.cas || "—"}</span>
                <span className="block truncate text-[11px] text-slate-500">{popisRadku}</span>
              </span>
              {ovladac}
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <div className="overflow-x-auto -mx-4 sm:-mx-5">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-sm uppercase tracking-wider text-slate-500 border-b border-slate-200">
            <th className="text-left font-medium py-2 px-4 sm:px-5">#</th>
            <th className="text-left font-medium py-2 px-2">Datum</th>
            <th className="text-left font-medium py-2 px-2">Čas</th>
            <th className="text-left font-medium py-2 px-2">Trenér</th>
            <th className="text-left font-medium py-2 px-2 hidden md:table-cell">Lokalita</th>
            <th className="text-left font-medium py-2 px-2 hidden sm:table-cell">Služba</th>
            <th className="text-left font-medium py-2 px-2">Stav</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((b, i) => {
            const dateD = b.date ? datumZIso(b.date) : null;
            const dayName = dateD && !isNaN(dateD)
              ? ["Ne","Po","Út","St","Čt","Pá","So"][dateD.getDay()]
              : "";
            const stavLow = (b.stav || "").toLowerCase();
            const isCancelled = stavLow.includes("zruš") || stavLow.includes("zrus") || stavLow.includes("cancel");
            const rowCls =
              b.propadnuti ? "bg-rose-50/40 text-slate-500 line-through" :
              isCancelled  ? "bg-slate-50 text-slate-400 line-through" :
              "";
            return (
              <tr key={`${b.date}-${b.cas}-${i}`} className={`border-b border-slate-100 ${rowCls}`}>
                <td className="py-2 px-4 sm:px-5 text-slate-400 tabular-nums">{i + 1}.</td>
                <td className="py-2 px-2 whitespace-nowrap">
                  <span className="text-slate-700">{dayName}</span>{" "}
                  <span className="font-medium">{formatDate(b.date)}</span>
                </td>
                <td className="py-2 px-2 tabular-nums text-slate-700">{b.cas || "—"}</td>
                <td className="py-2 px-2 text-slate-700 truncate max-w-[160px]" title={b.trener}>{b.trener || "—"}</td>
                <td className="py-2 px-2 hidden md:table-cell text-slate-600 truncate max-w-[180px]" title={b.lokalita}>{b.lokalita || "—"}</td>
                <td className="py-2 px-2 hidden sm:table-cell text-slate-600 truncate max-w-[200px]" title={b.sluzba}>{b.sluzba || "—"}</td>
                <td className="py-2 px-2">
                  {b.propadnuti && (
                    <span className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full bg-rose-100 text-rose-700 border border-rose-200">
                      Propadlý
                    </span>
                  )}
                  {!b.propadnuti && isCancelled && (
                    <span className="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 border border-slate-200">
                      Zrušený
                    </span>
                  )}
                  {!b.propadnuti && !isCancelled && b.stav && (
                    <span className="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                      {b.stav}
                    </span>
                  )}
                  {canManage && (
                    <button type="button" onClick={() => oznacitPropad(b, !b.propadnuti)}
                      title={b.propadnuti ? "Vrátit propadnutí" : "Označit jako propadlý (klient zrušil <24 h)"}
                      className={`mt-1 p-1 rounded-full transition-colors ${b.propadnuti ? "text-emerald-600 hover:bg-emerald-100" : "text-slate-400 hover:text-rose-600 hover:bg-rose-100"}`}>
                      {b.propadnuti ? <RotateCcw className="w-5 h-5" /> : <XCircle className="w-5 h-5" />}
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// Group bookings by year + month. Vrátí array sortovaný DESC pro historii, ASC pro budoucí.
// Struktura: [{ year, months: [{ monthIdx, label, bookings, count }] }, …]
function groupByYearMonth(bookings, sortAsc) {
  if (!bookings || bookings.length === 0) return [];
  const yearMap = new Map();
  for (const b of bookings) {
    if (!b.date) continue;
    const d = datumZIso(b.date);
    if (isNaN(d)) continue;
    const y = d.getFullYear();
    const m = d.getMonth();
    if (!yearMap.has(y)) yearMap.set(y, new Map());
    const monthMap = yearMap.get(y);
    if (!monthMap.has(m)) monthMap.set(m, []);
    monthMap.get(m).push(b);
  }
  const years = [...yearMap.entries()].sort((a, b) => sortAsc ? a[0] - b[0] : b[0] - a[0]);
  return years.map(([year, monthMap]) => {
    const months = [...monthMap.entries()].sort((a, b) => sortAsc ? a[0] - b[0] : b[0] - a[0]);
    return {
      year,
      months: months.map(([monthIdx, list]) => ({
        monthIdx,
        label: MONTH_FULL[monthIdx],
        bookings: list,
        count: list.length,
      })),
    };
  });
}

// Sub-dropdown pro jeden měsíc — light-weight, žádný Card, jen border.
function MonthDropdown({ year, monthIdx, label, count, bookings, defaultOpen }) {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <div className="border-l-2 border-slate-200 pl-3 mb-2 last:mb-0">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 py-1.5 hover:text-slate-900 text-left"
      >
        <div className="flex items-center gap-2">
          <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? "" : "-rotate-90"}`} />
          <span className="text-base font-medium text-slate-700">{label} {year}</span>
          <span className="text-sm text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full">{count}</span>
        </div>
      </button>
      {open && (
        <div className="mt-1">
          <BookingTable bookings={bookings} />
        </div>
      )}
    </div>
  );
}

// Hierarchický grouping bookings po letech a měsících. Aktuální měsíc default open.
function GroupedBookings({ bookings, sortAsc }) {
  // Zrušené tréninky se nepočítají do ničeho (5. 9. 2026), takže se ve výchozím stavu
  // nezobrazují. Přepínač je vrátí zpět mezi ostatní podle data, nic se nemaže.
  const [zobrazitZrusene, setZobrazitZrusene] = useState(false);
  const zrusenych = useMemo(() => (bookings || []).filter(jeZrusenyTrenink).length, [bookings]);
  const viditelne = useMemo(
    () => (zobrazitZrusene ? (bookings || []) : (bookings || []).filter((b) => !jeZrusenyTrenink(b))),
    [bookings, zobrazitZrusene]
  );
  const grouped = useMemo(() => groupByYearMonth(viditelne, sortAsc), [viditelne, sortAsc]);
  const prepinac = zrusenych > 0 ? (
    <button
      type="button"
      role="switch"
      aria-checked={zobrazitZrusene}
      onClick={() => setZobrazitZrusene((v) => !v)}
      className={`mb-2 flex min-h-[44px] w-full items-center gap-2 rounded-xl border px-3 text-left transition-colors ${zobrazitZrusene ? "border-2 border-brand bg-brand-50" : "border-slate-300 bg-white"}`}
    >
      <Eye className={`w-4 h-4 shrink-0 ${zobrazitZrusene ? "text-brand-deep" : "text-slate-400"}`} />
      <span className={`min-w-0 flex-1 text-[13px] font-semibold ${zobrazitZrusene ? "text-brand-deep" : "text-slate-500"}`}>Zobrazit i zrušené</span>
      <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold ${zobrazitZrusene ? "bg-brand-100 text-brand-deep" : "bg-slate-200 text-slate-600"}`}>{zrusenych}</span>
      <span className={`flex h-6 w-11 shrink-0 items-center rounded-full p-0.5 transition-colors ${zobrazitZrusene ? "justify-end bg-brand" : "justify-start bg-slate-300"}`}>
        <span className="h-5 w-5 rounded-full bg-white shadow" />
      </span>
    </button>
  ) : null;
  if (grouped.length === 0) {
    return (
      <div>
        {prepinac}
        <div className="text-sm text-slate-400 italic py-2">Žádné tréninky.</div>
      </div>
    );
  }
  // Pokud je jediný rok a jediný měsíc — zobraz rovnou tabulku bez dropdownů.
  if (grouped.length === 1 && grouped[0].months.length === 1) {
    return (
      <div>
        {prepinac}
        <BookingTable bookings={grouped[0].months[0].bookings} />
      </div>
    );
  }
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  return (
    <div>
      {prepinac}
      <div className="space-y-3">
        {grouped.map(({ year, months }) => (
          <YearDropdown key={year} year={year} months={months} defaultOpen={year === currentYear} currentMonth={currentMonth} currentYear={currentYear} />
        ))}
      </div>
    </div>
  );
}

function YearDropdown({ year, months, defaultOpen, currentMonth, currentYear }) {
  const [open, setOpen] = useState(!!defaultOpen);
  const totalCount = months.reduce((s, m) => s + m.count, 0);
  return (
    <div>
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 py-2 px-3 bg-slate-50 hover:bg-slate-100 rounded-xl border border-slate-200 transition-colors text-left"
      >
        <div className="flex items-center gap-2.5">
          <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${open ? "" : "-rotate-90"}`} />
          <span className="text-base font-bold text-slate-900">Rok {year}</span>
          <span className="text-sm text-slate-600">{months.length} {months.length === 1 ? "měsíc" : months.length < 5 ? "měsíce" : "měsíců"}, {totalCount} tréninků</span>
        </div>
      </button>
      {open && (
        <div className="mt-2 ml-2">
          {months.map((m) => (
            <MonthDropdown
              key={`${year}-${m.monthIdx}`}
              year={year}
              monthIdx={m.monthIdx}
              label={m.label}
              count={m.count}
              bookings={m.bookings}
              defaultOpen={year === currentYear && m.monthIdx === currentMonth}
            />
          ))}
        </div>
      )}
    </div>
  );
}

// PDF export — otevře nové okno s profesionálně formátovaným HTML, user Cmd+P → Save as PDF.
// Browser native font dává perfect českou diakritiku.
// Obsah: hlavička s logem + stat boxy + tabulka termínů + footer.
function exportBookingsToPDF(klientName, bookings, label) {
  const dayNames = ["Ne","Po","Út","St","Čt","Pá","So"];
  const monthFull = ["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"];
  // 21.10.2026: v datu 2. pád („27. srpna 2026“), nominativ jen v záhlaví měsíce.
  const monthGen = ["ledna","února","března","dubna","května","června","července","srpna","září","října","listopadu","prosince"];
  const escapeHtml = (s) => String(s || "").replace(/[&<>"']/g, (c) => ({ "&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;" }[c]));
  // Lokální formátování data — MUSÍ být definováno před prvním použitím (todayStr níže),
  // jinak ReferenceError (TDZ) a celý export PDF spadne.
  const fmtDate = (iso) => {
    const d = datumZIso(iso);
    if (isNaN(d)) return iso || "";
    return `${d.getDate()}. ${monthGen[d.getMonth()]} ${d.getFullYear()}`;
  };
  const today = new Date();
  const todayStr = fmtDate(today);

  // Statistika
  const propadlych = bookings.filter((b) => b.propadnuti).length;
  const zrusenych = bookings.filter((b) => {
    const s = (b.stav || "").toLowerCase();
    return !b.propadnuti && (s.includes("zruš") || s.includes("zrus") || s.includes("cancel"));
  }).length;
  const realizovanych = bookings.length - propadlych - zrusenych;

  // Datum range pro období
  const validDates = bookings.map((b) => b.date).filter(Boolean).sort();
  const firstDate = validDates[0];
  const lastDate = validDates[validDates.length - 1];
  const obdobi = firstDate && lastDate
    ? (firstDate === lastDate ? fmtDate(firstDate) : `${fmtDate(firstDate)} – ${fmtDate(lastDate)}`)
    : "—";

  // Group rows by year + month pro vizuální separátory v tabulce
  let lastYearMonth = "";
  const rows = bookings.map((b, i) => {
    const d = b.date ? datumZIso(b.date) : null;
    const dayLbl = d && !isNaN(d) ? dayNames[d.getDay()] : "";
    const dateLbl = d && !isNaN(d) ? fmtDate(d) : (b.date || "—");
    const ymKey = d && !isNaN(d) ? `${d.getFullYear()}-${d.getMonth()}` : "";
    const showSeparator = ymKey && ymKey !== lastYearMonth;
    const ymLabel = d && !isNaN(d) ? `${monthFull[d.getMonth()]} ${d.getFullYear()}` : "";
    if (showSeparator) lastYearMonth = ymKey;
    const stavLow = (b.stav || "").toLowerCase();
    const isCancelled = stavLow.includes("zruš") || stavLow.includes("zrus") || stavLow.includes("cancel");

    let statusBadge = "";
    if (b.propadnuti) {
      statusBadge = `<span class="badge badge-rose">Propadlý</span>`;
    } else if (isCancelled) {
      statusBadge = `<span class="badge badge-slate">Zrušený</span>`;
    } else if (b.stav) {
      // 21.10.2026: klientka v exportu nevidí interní stav „confirmed“, ale srozumitelný text.
      const probehl = /^(confirmed|arrived|completed)$/i.test(String(b.stav).trim());
      const budouci = d && !isNaN(d) && d > today;
      const text = probehl ? (budouci ? "Naplánovaný" : "Odchozený") : b.stav;
      statusBadge = `<span class="badge badge-green">${escapeHtml(text)}</span>`;
    } else {
      statusBadge = `<span class="muted-text">—</span>`;
    }

    const rowCls = b.propadnuti ? "row-propadly" : isCancelled ? "row-zruseny" : "";
    return `${showSeparator ? `<tr class="separator"><td colspan="7">${escapeHtml(ymLabel)}</td></tr>` : ""}
    <tr class="${rowCls}">
      <td class="num idx">${i + 1}</td>
      <td class="cell-datum"><span class="day">${escapeHtml(dayLbl)}</span> <strong class="date">${escapeHtml(dateLbl)}</strong></td>
      <td class="num time" data-popis="Čas">${escapeHtml(b.cas || "—")}</td>
      <td class="strong" data-popis="Trenér">${escapeHtml(b.trener || "—")}</td>
      <td data-popis="Lokalita">${escapeHtml(b.lokalita || "—")}</td>
      <td class="muted-text" data-popis="Služba">${escapeHtml(b.sluzba || "—")}</td>
      <td class="cell-stav">${statusBadge}</td>
    </tr>`;
  }).join("");

  const html = `<!DOCTYPE html>
<html lang="cs">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>${escapeHtml(label)}: ${escapeHtml(klientName)}</title>
<style>
  /* 21.10.2026: vzhled podle značky FitWay40 (fitway40.cz/znacka): logo, DM Sans +
     Source Serif 4, barvy #241430 / #7C5DB0 / #C6B4E2 / #EEE7F8, fialová vždy plná. */
  ${brandFontCss()}
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    font-family: "DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    color: #241430;
    background: #F7F3FC;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .page {
    max-width: 210mm;
    margin: 0 auto;
    padding: 24px 24px 16px;
    background: #fff;
  }

  /* Toolbar — jen na obrazovce */
  .toolbar {
    background: #fff;
    border-bottom: 1px solid #EAE6EF;
    padding: 12px 24px;
    position: sticky;
    top: 0;
    z-index: 10;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  }
  .btn {
    display: inline-block;
    padding: 8px 14px;
    background: #241430;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    margin-right: 8px;
    font-family: inherit;
  }
  .btn:hover { background: #7C5DB0; }
  .btn-secondary { background: #EEE7F8; color: #241430; }
  .btn-secondary:hover { background: #C6B4E2; }

  /* Hlavička s gradientem */
  .header {
    background: #241430;
    color: #fff;
    padding: 22px 26px;
    border-radius: 14px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    page-break-after: avoid;
  }
  .logo {
    height: 44px;
    flex-shrink: 0;
  }
  .logo svg { height: 100%; width: auto; display: block; }
  .header-content { flex: 1; min-width: 0; text-align: right; }
  .header-label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    color: #C6B4E2;
    margin-bottom: 4px;
  }
  .header-title {
    font-family: "Source Serif 4", Georgia, serif;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 4px;
    word-wrap: break-word;
  }
  .header-meta {
    font-size: 12px;
    color: #C6B4E2;
  }

  /* Stat boxy */
  .stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 20px;
    page-break-after: avoid;
  }
  .stat {
    padding: 12px 14px;
    background: #fff;
    border: 1px solid #EEE7F8;
    border-radius: 12px;
  }
  .stat-label {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #695C74;
    margin-bottom: 4px;
  }
  .stat-value {
    font-family: "Source Serif 4", Georgia, serif;
    font-size: 22px;
    font-weight: 700;
    color: #241430;
    line-height: 1.1;
  }
  .stat-value-sm {
    font-size: 13px;
    font-weight: 600;
    color: #463654;
  }
  .stat.green { background: #7C5DB0; border-color: #7C5DB0; }
  .stat.green .stat-label { color: #EEE7F8; }
  .stat.green .stat-value { color: #fff; }
  .stat.rose .stat-value { color: #e11d48; }
  .stat.amber .stat-value { color: #b45309; }

  /* Tabulka */
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
    background: #fff;
    border: 1px solid #EAE6EF;
    border-radius: 10px;
    overflow: hidden;
  }
  thead {
    background: #241430;
    color: #fff;
  }
  th {
    text-align: left;
    padding: 10px 12px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: 0.5px;
  }
  th.num { text-align: right; }
  td {
    padding: 8px 12px;
    border-bottom: 1px solid #F6F3F8;
    vertical-align: middle;
  }
  td.num {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
  td.idx {
    color: #786786;
    width: 32px;
    font-weight: 500;
  }
  td.time {
    color: #554761;
    font-weight: 500;
  }
  td.strong { font-weight: 500; }
  .day {
    color: #695C74;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .date { color: #241430; }
  .muted-text { color: #786786; }
  tr.row-propadly { background: #fff1f2; color: #786786; }
  tr.row-propadly .date { text-decoration: line-through; color: #be123c; }
  tr.row-zruseny { background: #FBF9FC; color: #786786; }
  tr.row-zruseny .date { text-decoration: line-through; }

  /* Měsíční separátor */
  tr.separator td {
    background: #EEE7F8;
    padding: 6px 12px;
    font-weight: 700;
    font-size: 11px;
    color: #554761;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-top: 2px solid #C6B4E2;
  }

  /* Status badges */
  .badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 600;
    border: 1px solid;
    white-space: nowrap;
  }
  .badge-green { background: #EEE7F8; color: #241430; border-color: #C6B4E2; }
  .badge-rose { background: #fff1f2; color: #be123c; border-color: #fda4af; }
  .badge-slate { background: #F6F3F8; color: #554761; border-color: #D3CADB; }

  /* Footer */
  .footer {
    margin-top: 24px;
    padding-top: 12px;
    border-top: 1px solid #EAE6EF;
    font-size: 10px;
    color: #786786;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .footer-brand { font-weight: 600; color: #554761; }

  /* 9.9.2026 — telefon: tabulka o sedmi sloupcích se nedá přečíst, každý trénink
     je proto karta s popisky. Tisk na A4 se tím nemění, platí jen do 640 px. */
  @media (max-width: 640px) {
    .page { padding: 12px 12px 16px; }
    .toolbar { padding: 10px 12px; display: flex; gap: 8px; }
    .btn { flex: 1; margin-right: 0; padding: 12px 8px; font-size: 14px; min-height: 48px; }
    .header { padding: 16px 16px; gap: 12px; border-radius: 14px; }
    .logo { height: 32px; }
    .header-title { font-size: 18px; }
    .stats { grid-template-columns: repeat(2, 1fr); gap: 8px; }
    .stat-value { font-size: 18px; }
    table { border: 0; background: transparent; }
    thead { display: none; }
    table, tbody, tr, td { display: block; width: 100%; }
    tr { border: 1px solid #EAE6EF; border-radius: 12px; background: #fff; padding: 10px 12px; margin-bottom: 8px; }
    tr.separator { border: 0; background: transparent; padding: 10px 0 2px; margin: 0; }
    tr.separator td { background: transparent; border: 0; padding: 0; font-size: 12px; }
    td { border: 0; padding: 2px 0; font-size: 14px; text-align: left; }
    td.idx { display: none; }
    td.cell-datum { font-size: 16px; padding-bottom: 6px; }
    td.cell-datum .day { font-size: 12px; }
    td[data-popis]::before {
      content: attr(data-popis) ": ";
      color: #786786;
      font-weight: 600;
      font-size: 12px;
    }
    td.cell-stav { padding-top: 6px; }
    .badge { font-size: 12px; padding: 3px 10px; }
    .footer { flex-direction: column; align-items: flex-start; gap: 4px; font-size: 11px; }
  }

  @media print {
    .toolbar { display: none; }
    body { background: #fff; }
    .page { padding: 0; max-width: none; }
    .header { margin-bottom: 16px; padding: 18px 20px; }
    .stats { margin-bottom: 16px; gap: 8px; }
    table thead { display: table-header-group; }
    tr { page-break-inside: avoid; }
    tr.separator { page-break-after: avoid; }
    @page {
      size: A4 portrait;
      margin: 12mm 12mm 14mm 12mm;
    }
  }
</style>
</head>
<body>
  <div class="toolbar">
    <button class="btn" onclick="downloadAsPdf()" id="btn-download" title="Stáhnout PDF přímo do počítače (bez tisk dialogu)">⬇ Stáhnout PDF</button>
    <button class="btn btn-secondary" onclick="window.print()" title="Cmd+P / Ctrl+P → vyber Save as PDF">Vytisknout</button>
    <button class="btn btn-secondary" onclick="closeWindow()" title="Zavřít okno">✕ Zavřít</button>
  </div>

  <div class="page">
    <div class="header">
      <div class="logo">${LOGO_SVG_BILE}</div>
      <div class="header-content">
        <div class="header-label">${escapeHtml(label)}</div>
        <div class="header-title">${escapeHtml(klientName)}</div>
        <div class="header-meta">${escapeHtml(obdobi)}</div>
      </div>
    </div>

    <div class="stats">
      <div class="stat">
        <div class="stat-label">Celkem tréninků</div>
        <div class="stat-value">${bookings.length}</div>
      </div>
      <div class="stat green">
        <div class="stat-label">Realizovaných</div>
        <div class="stat-value">${realizovanych}</div>
      </div>
      ${propadlych > 0 ? `
      <div class="stat rose">
        <div class="stat-label">Propadlých</div>
        <div class="stat-value">${propadlych}</div>
      </div>` : `
      <div class="stat">
        <div class="stat-label">Propadlých</div>
        <div class="stat-value muted-text" style="color:#D3CADB">0</div>
      </div>`}
      <div class="stat">
        <div class="stat-label">Vygenerováno</div>
        <div class="stat-value-sm" style="margin-top:6px">${escapeHtml(todayStr)}</div>
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th class="num">#</th>
          <th>Datum</th>
          <th>Čas</th>
          <th>Trenér</th>
          <th>Lokalita</th>
          <th>Služba</th>
          <th>Stav</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>

    <div class="footer">
      <div class="footer-brand">FitWay40 · Osobní tréninky a výživové poradenství pro ženy 40+</div>
      <div>www.fitway40.cz</div>
    </div>
  </div>

  <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
  <script>
    // Default akce: DRŽÍ se v okně, user může klikat tlačítka. Žádný auto-print.
    function closeWindow() {
      try {
        window.close();
      } catch (_) { /* ignore */ }
      // Fallback: pokud window.close() v některých browseru neodlogguje
      // (security restriction pro nonopener tabs), nahradíme obsah hlášením.
      setTimeout(() => {
        if (!window.closed) {
          document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#241430;text-align:center;padding:24px"><div><div style="font-size:18px;font-weight:500;margin-bottom:8px">Okno lze zavřít.</div><div style="color:#695C74;font-size:14px">Použij Cmd+W (Mac) nebo Ctrl+W (Windows)</div></div></div>';
        }
      }, 200);
    }
    // Stáhnout PDF přímo (html2pdf.js → jsPDF → download)
    async function downloadAsPdf() {
      const btn = document.getElementById('btn-download');
      const orig = btn ? btn.innerText : '';
      if (btn) { btn.innerText = '⏳ Generuju PDF…'; btn.disabled = true; }
      const filename = ${JSON.stringify(`${label} - ${klientName}.pdf`)};
      const target = document.querySelector('.page');
      // Písma značky se musí načíst dřív, než html2canvas stránku vyfotí.
      await (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve());
      const opt = {
        margin: [10, 10, 10, 10],
        filename,
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['css', 'legacy'] }
      };
      html2pdf().set(opt).from(target).save().then(() => {
        if (btn) { btn.innerText = '✓ Staženo'; setTimeout(() => { btn.innerText = orig; btn.disabled = false; }, 2000); }
      }).catch((e) => {
        console.error(e);
        if (btn) { btn.innerText = orig; btn.disabled = false; }
        toast('Chyba při generování PDF: ' + e.message + '\\nZkus tisknout přes tlačítko Vytisknout (Cmd+P → Save as PDF).', "error");
      });
    }
  </script>
</body>
</html>`;

  // Na telefonu se okno otevírá jako nová karta přes celou obrazovku, pevná
  // šířka 1000 px by ho zmenšila (9.9.2026).
  const uzkeOkno = typeof window !== "undefined" && window.innerWidth < 640;
  const win = window.open("", "_blank", uzkeOkno ? "" : "width=1000,height=800");
  if (!win) {
    toast("Nový tab se neotevřel. Zkontroluj že prohlížeč nepovolil pop-ups pro tuto stránku.", "error");
    return;
  }
  win.document.write(html);
  win.document.close();
}

// 28.5.2026: restrictMode="trener" — trenér vidí redukovaný detail klienta:
//   skryté sekce: Komentáře, Email komunikace, Spolupráce, Finance, Historie plateb,
//   Vstupní dotazník. Kontakt zůstává bez Notion linku. Tréninkové sekce
//   (Tréninky po měsících, Tréninkový profil, Budoucí, Historie + PDF) zůstávají.
export default function ClientDetail({ client, onClose, onDeleted = null, restrictMode = null, otevritFakturaci = false }) {
  const isTrenerView = restrictMode === "trener";
  // 16.6.2026: manažerský náhled — vidí všechny sekce, ale read-only (žádné edit tlačítka).
  // Výjimka: komentáře smí přidávat + přišpendlit (mazání zůstává owner-only).
  const isManagerView = restrictMode === "manager";
  // 12.7.2026: nutritionist náhled — hlavička s veškerým infem (vidí nárok na
  // výživu) + POUZE sekce Výživa (editovatelná). Ostatní sekce schované.
  const isNutriView = restrictMode === "nutri";
  const { blurred } = useDemoMode();
  const [bookings, setBookings] = useState(null);
  const [bookingsLoading, setBookingsLoading] = useState(false);
  const [bookingsError, setBookingsError] = useState(null);
  // Historie plateb (FAPI faktury + log_cash) — lazy fetch on section open
  const [invoices, setInvoices] = useState(null);
  const [invoicesLoading, setInvoicesLoading] = useState(false);
  const [invoicesError, setInvoicesError] = useState(null);
  const [expandedInvoiceIds, setExpandedInvoiceIds] = useState(new Set()); // ID -> bool zda je items expanded
  // Log Expired pro daného klienta — pro zobrazení červených badges v heatmap + sekce dole
  const [logExpired, setLogExpired] = useState([]); // jen Schváleno=ANO za aktuální rok
  const [lateOpen, setLateOpen] = useState(false); // dropdown "Zrušené pozdě" (propadlé)
  // Bonusove treniky — strukturovany dropdown pod dlazdici "Bonusove" (Log bonus YYYY sheet)
  const [bonusOpen, setBonusOpen] = useState(false);
  const [bonusEntries, setBonusEntries] = useState(null); // null = nenacteno, [] = nacteno prazdne
  const [bonusLoading, setBonusLoading] = useState(false);
  const [bonusError, setBonusError] = useState(null);
  // Spojene treniky (ST) — analog k bonusove, dropdown pod novou dlazdici Spojene
  const [stOpen, setStOpen] = useState(false);
  const [stEntries, setStEntries] = useState(null);
  const [stLoading, setStLoading] = useState(false);
  const [stError, setStError] = useState(null);
  // Z fakturace — rozpad připsaných tréninků (faktury + hotovost) z /api/log-pripsane-treninky.
  const [faktOpen, setFaktOpen] = useState(false);
  const [faktEntries, setFaktEntries] = useState(null);
  const [faktLoading, setFaktLoading] = useState(false);
  const [faktError, setFaktError] = useState(null);
  // Seskupené dlaždice (24.6.2026): Celkem (k dispozici) + Celkem odchozeno — defaultně zavřené.
  const [celkemOpen, setCelkemOpen] = useState(false);
  const [odchozenoOpen, setOdchozenoOpen] = useState(false);
  const [propadleInlineOpen, setPropadleInlineOpen] = useState(false);

  // Owner: archivace / smazání klienta (13.7.2026) — /api/klient-sprava.
  // Archivace = soft (data.archivovan, v DB zůstává, nikdo ho nevidí, owner
  // obnoví ve filtru Archiv). Smazání = hard + blacklist proti Sheet syncu.
  const [spravaConfirm, setSpravaConfirm] = useState(null); // "archivovat"|"obnovit"|"smazat"|null
  const [spravaBusy, setSpravaBusy] = useState(false);
  const klientSprava = async (akce) => {
    setSpravaBusy(true);
    try {
      const res = await apiFetch("/api/klient-sprava", {
        method: "POST",
        body: JSON.stringify({ action: akce, klient_id: client.notion_id || notionIdFromUrlCd(client.notion) }),
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok || !j.ok) throw new Error(j.error || `HTTP ${res.status}`);
      setSpravaConfirm(null);
      if (onDeleted) onDeleted(); else onClose?.();
    } catch (e) {
      toast("Akce selhala: " + e.message, "error");
    } finally {
      setSpravaBusy(false);
    }
  };

  // Owner: smazání leadu (smaže řádek v PG + archivuje Notion stránku, aby ji sync nevrátil).
  const [leadDeleteConfirm, setLeadDeleteConfirm] = useState(false);
  const [leadDeleting, setLeadDeleting] = useState(false);
  const deleteLead = async () => {
    setLeadDeleting(true);
    try {
      const res = await apiFetch("/api/lead-delete", {
        method: "POST",
        body: JSON.stringify({ notionUrl: client.notion, email: client.email, jmeno: client.klient }),
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok || !j.ok) throw new Error(j.error || `HTTP ${res.status}`);
      setLeadDeleteConfirm(false);
      if (onDeleted) onDeleted(); else onClose?.();
    } catch (e) {
      toast("Smazání leadu selhalo: " + e.message, "error");
    } finally {
      setLeadDeleting(false);
    }
  };
  // Přejmenování klienta — modal s text input. Po confirm volá /api/client-training-profile {action:"rename"}.
  // UUID v PG zůstane, jen klient_id + klient_name se přepíše + Sheet + Notion.
  // 2-step confirm: RenameClientDialog (zadání nového jména) → ConfirmDialog (potvrzení) → API.
  // Po úspěchu toast (žádný native alert) + audit do system_errors info-level.
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  // 28. 10. 2026 (dávka 3, blok 3): náhled klientské aplikace bez master tokenu v URL.
  // Server podepíše token na 8 hodin pro telefon klientky, aplikace ho přijme jen ke čtení.
  const [nahledOtviram, setNahledOtviram] = useState(false);
  const otevritNahled = async () => {
    if (nahledOtviram) return;
    setNahledOtviram(true);
    const okno = window.open("", "_blank"); // otevřít hned při kliknutí, jinak ho prohlížeč zablokuje
    try { if (okno) okno.opener = null; } catch (e) { /* nevadí */ }
    try {
      const r = await apiFetch("/api/portal-nahled-token", { method: "POST", body: JSON.stringify({ phone: client.telefon }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.url) throw new Error(j.error || "Náhled se nepodařilo otevřít.");
      if (okno) okno.location.href = j.url; else window.location.href = j.url;
    } catch (e) {
      if (okno) okno.close();
      toast(e.message || "Náhled se nepodařilo otevřít.", "error");
    } finally { setNahledOtviram(false); }
  };
  const [poslatSalesOpen, setPoslatSalesOpen] = useState(false);
  // 17. 10. 2026 (Láďa, Tinka): naplánovaný hovor sales je vidět hned v hlavičce karty,
  // aby nikdo nenastavoval další. Jen owner, manažer a CSM (mají přístup do sales).
  const [salesHovor, setSalesHovor] = useState(null);
  const salesHovorKlient = client && (client.notion_id || (client.notion ? notionIdFromUrlCd(client.notion) : ""));
  const salesHovorRole = ["owner", "manager", "csm"].includes(String(getCurrentUser()?.role || "").toLowerCase());
  useEffect(() => {
    setSalesHovor(null);
    if (!salesHovorKlient || !salesHovorRole || poslatSalesOpen) return undefined;
    let zivy = true;
    apiFetch(`/api/sales?akce=hovor_klientky&klient_id=${encodeURIComponent(salesHovorKlient)}`)
      .then((r) => (r.ok ? r.json() : null)).then((d) => { if (zivy) setSalesHovor(d?.hovor || null); }).catch(() => {});
    return () => { zivy = false; };
  }, [salesHovorKlient, salesHovorRole, poslatSalesOpen]);
  // GDPR 19.10.2026: štítek „Chybí souhlas“ (varianta A). false = nedala, true = dala, null = nevíme.
  const [zdravSouhlas, setZdravSouhlas] = useState(null);
  useEffect(() => {
    setZdravSouhlas(null);
    if (!salesHovorKlient) return undefined;
    let zivy = true;
    apiFetch(`/api/klient-souhlas?klientId=${encodeURIComponent(salesHovorKlient)}`)
      .then((r) => (r.ok ? r.json() : null)).then((d) => { if (zivy && d && d.ok) setZdravSouhlas(!!d.souhlas); }).catch(() => {});
    return () => { zivy = false; };
  }, [salesHovorKlient]);
  const salesHovorText = salesHovor ? `Sales volá ${(() => { const [y, m, d] = salesHovor.datum.split("-").map(Number); return `${d}. ${m}. ${y}`; })()}` : "";
  const [renameConfirmOpen, setRenameConfirmOpen] = useState(false);
  // Trigger pro otevreni formulare "Volno klienta" z tlacitka v hlavicce (bez scrollovani).
  const [volnoOpenTrigger, setVolnoOpenTrigger] = useState(0);
  // 9.9.2026 — tlačítka pod hlavičkou otevírají volno i dotazník hodnocení.
  const [hodnoceniOpenTrigger, setHodnoceniOpenTrigger] = useState(0);
  const [volnoPocet, setVolnoPocet] = useState(undefined);
  const [hodnoceniPocet, setHodnoceniPocet] = useState(undefined);
  const [detiPocet, setDetiPocet] = useState(undefined);
  const [bootcampPocet, setBootcampPocet] = useState(undefined);
  const [kamaradkyPocet, setKamaradkyPocet] = useState(undefined);
  const [renameNewName, setRenameNewName] = useState("");
  const [renameLoading, setRenameLoading] = useState(false);
  const [renameToast, setRenameToast] = useState(null); // { variant, title, detail } | null
  // Krok 1: user vyplnil nové jméno v RenameClientDialog → ulož a otevři ConfirmDialog.
  const handleRenameStep1 = useCallback((newName) => {
    setRenameNewName(newName);
    setRenameDialogOpen(false);
    setRenameConfirmOpen(true);
  }, []);
  // Krok 2: user potvrdil v ConfirmDialog → API call.
  const doRename = useCallback(async () => {
    if (!renameNewName) return;
    setRenameLoading(true);
    try {
      const r = await apiFetch("/api/client-training-profile", {
        method: "POST",
        body: JSON.stringify({ action: "rename", oldName: client.klient, newName: renameNewName, confirm: "yes" }),
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.error || "Přejmenování selhalo");
      setRenameConfirmOpen(false);
      // Hezký toast místo native alert. Detaily jsou v system log (auditní stopa).
      const ok = j.summary?.allOk !== false;
      setRenameToast({
        variant: ok ? "success" : "warning",
        title: `Klient přejmenován na „${renameNewName}"`,
        detail: ok
          ? "Jméno je přepsané v aplikaci. Tréninkový profil zachován."
          : "Část synchronizace neproběhla, detaily v Systém → Hlášení.",
      });
      // Rychlá UX: optimisticky přepsat localStorage cache (přejmenovat klienta v rows
      // bez čekání na server) + paralelně vyhodit force=1 refresh server cache. Po 600ms reload
      // má načteno už čerstvé localStorage (instant render) i čerstvý server cache (zápis hotov).
      const oldNm = client?.klient;
      const newNm = renameNewName;
      try {
        const cached = JSON.parse(localStorage.getItem("api_cache_/api/clients") || "null");
        if (cached && Array.isArray(cached.clients)) {
          cached.clients = cached.clients.map((c) =>
            c.klient === oldNm ? { ...c, klient: newNm } : c
          );
          localStorage.setItem("api_cache_/api/clients", JSON.stringify(cached));
        }
      } catch { /* nefatal */ }
      // Force refresh server-side cache na pozadí (fire-and-forget, neblokuje reload).
      apiFetch("/api/clients?force=1").catch(() => {});
      setTimeout(() => window.location.reload(), 600);
    } catch (e) {
      setRenameToast({ variant: "error", title: "Přejmenování selhalo", detail: e.message });
    } finally {
      setRenameLoading(false);
    }
  }, [client?.klient, renameNewName]);
  // Auto-dismiss toastu po 5s (pokud user sám neklikne X).
  useEffect(() => {
    if (!renameToast) return;
    const t = setTimeout(() => setRenameToast(null), 5000);
    return () => clearTimeout(t);
  }, [renameToast]);

  // Modul 2A1: inline edit kontaktů (Email + Telefon) — žádný modal, fieldy editovatelné přímo
  const [editingContacts, setEditingContacts] = useState(false);
  const [editEmail, setEditEmail] = useState("");
  const [editTelefon, setEditTelefon] = useState("");
  const [savingContacts, setSavingContacts] = useState(false);
  const [contactsConfirmOpen, setContactsConfirmOpen] = useState(false);
  const [contactsErr, setContactsErr] = useState(null);
  // ============================================================================
  // Modul 2B: inline edit pro celou Spolupráce sekci (Balíček, Trenér, Lokalita,
  // Typ spolupráce, Začátek, Konec) + samostatný edit Finance (Způsob platby).
  //
  // VŠE jsou rolovací selecty (kromě dat). Options se načítají z reálných distinct
  // hodnot v /api/clients (helper clientFieldOptions.js, cache 5 min).
  //
  // ConfirmDialog dynamicky sesbírá warningy podle changed fields (balíček + způsob
  // platby → FAPI varování). Backend pošle Slack + in-app notifikaci.
  // ============================================================================
  // Pole které edituje sekce Spolupráce
  const SPOLUPRACE_FIELDS = ["balicek", "trener", "lokalita", "typSpoluprace", "zacatek", "konec", "stage", "stavSpoluprace", "blacklist"];
  const FINANCE_FIELDS = ["zpusobPlatby", "frekvence", "kdoFakturuje", "castka"];
  // Modul 2D: Vstupní dotazník — část 1 z poptávky (FAPI form, klient sám) + část 2 sales call notes.
  // 10.9.2026 (zadani Ladi): "Level tréninku" vypusten z detailu klienta.
  // Byla to jedina kolonka v teto sekci, kterou nevyplnuje klientka v dotazniku
  // ani sales pri hovoru — hodnoceni urovne si vede trener jinde. Hodnota
  // v clients.data zustava a dal tece z Notionu pres Leady, jen se uz nezobrazuje
  // ani needituje. Vraceni zpet = pridat "levelTreninku" do tohoto seznamu
  // a obnovit DotaznikKarta + SelectField nize.
  const PROFIL_POPTAVKA_FIELDS = ["pocetTreninkuTyden", "casProTreninky", "zajemOLokalitu", "zajemTrial", "zkusenostiCviceni", "kdyChceZacit", "delkaSpoluprace"];
  const PROFIL_SALES_FIELDS = ["zdravotniOmezeni", "zraneni", "chronickeBolesti", "aktualniCil", "poznamkySales"];
  const PROFIL_FIELDS = [...PROFIL_POPTAVKA_FIELDS, ...PROFIL_SALES_FIELDS];
  // Lidské labely (pro ConfirmDialog diff + form labels). Synchron s backend FIELD_CONFIG.
  const FIELD_LABELS = {
    balicek: "Balíček",
    trener: "Trenér",
    lokalita: "Lokalita",
    typSpoluprace: "Typ spolupráce",
    zacatek: "Začátek spolupráce",
    konec: "Konec spolupráce",
    stage: "Stage",
    stavSpoluprace: "Stav spolupráce",
    blacklist: "BLACKLIST",
    zpusobPlatby: "Způsob platby",
    frekvence: "Frekvence fakturace",
    kdoFakturuje: "Kdo fakturuje",
    castka: "Částka/měs",
    levelTreninku: "Level tréninku",
    pocetTreninkuTyden: "Počet tréninků týdně",
    casProTreninky: "Čas pro tréninky",
    zajemOLokalitu: "Zájem o lokalitu",
    zajemTrial: "Zájem trial",
    zkusenostiCviceni: "Zkušenosti cvičení",
    kdyChceZacit: "Kdy chce začít",
    delkaSpoluprace: "Délka spolupráce",
    zdravotniOmezeni: "Zdravotní omezení",
    zraneni: "Zranění",
    chronickeBolesti: "Chronické bolesti",
    aktualniCil: "Aktuální cíl",
    poznamkySales: "Poznámky (sales)",
  };
  // Které pole vyvolá warning o FAPI po save (musí korespondovat s backend FIELD_CONFIG.warnings).
  const FIELD_WARNINGS = {
    balicek: "Uprav pravidelnou fakturu v Plánu fakturace (když ji klientka nemá, založ ji tam)",
    zpusobPlatby: "Zkontroluj fakturaci v FAPI (změna způsobu platby může vyžadovat úpravu šablony)",
    frekvence: "Nezapomeň upravit fakturační cyklus klienta v FAPI",
    kdoFakturuje: "Změna může vyžadovat přesun klienta na jiný FAPI účet (Firma vs OSVČ)",
    castka: "Změna částky → uprav FAPI šablonu / cyklus pro klienta",
    stavSpoluprace: "Při Ukončený / Pauza zkontroluj fakturaci v FAPI (možná zrušit cyklus)",
    blacklist: "BLACKLIST = okamžitě informuj tým + zruš všechny budoucí rezervace v Reservio",
    // 24.8.2026: ruční datum zamkne automatický výpočet platnosti permanentky.
    konec: "Ručně zadaný konec spolupráce má přednost před automatickým výpočtem u permanentek. Hlídač ho už nepřepíše, dokud klient nezaplatí další permanentku.",
  };

  // Načtené distinct options z /api/clients (cache 5 min, sdílená utility)
  const [fieldOptions, setFieldOptions] = useState(null); // null = loading
  useEffect(() => {
    let cancelled = false;
    getClientFieldOptions().then((opts) => { if (!cancelled) setFieldOptions(opts); });
    return () => { cancelled = true; };
  }, []);
  const optionsLoaded = fieldOptions !== null;

  // ----- SPOLUPRÁCE edit state -----
  const [editingSpoluprace, setEditingSpoluprace] = useState(false);
  // Hlášení #187 (30. 10. 2026): v nabídce trenéra jen aktivní trenéři (stav z HR přes /api/trainers),
  // nebo s aktivní klientkou (např. Head Coach, který trénuje), ne všichni, kdo kdy měli klientku. Aktuální trenér klientky zůstává vždy (addCurrentToOptions).
  // Načítá se jen při úpravě spolupráce (endpoint je pomalejší), pak je v keši prohlížeče.
  // Když se seznam nenačte (role bez přístupu, chyba), zůstane původní seznam z klientek.
  const { data: treneriData } = useApiData(editingSpoluprace ? `/api/trainers?year=${new Date().getFullYear()}` : null);
  const aktivniTreneri = useMemo(() => {
    const t = (treneriData?.trainers || []).filter((x) => x.status === "Aktivní" || (Array.isArray(x.activeClients) && x.activeClients.length > 0)).map((x) => String(x.jmeno || "").trim()).filter(Boolean);
    return t.length ? Array.from(new Set(t)).sort((a, b) => a.localeCompare(b, "cs", { sensitivity: "base" })) : null;
  }, [treneriData]);
  const notionVypnuto = useNotionVypnuto();
  const [stavKPotvrzeni, setStavKPotvrzeni] = useState(null);
  // 15. 10. 2026: důvod ukončení a volba sales, pošle se s uložením stavu Ukončeno.
  const [ukonceniInfo, setUkonceniInfo] = useState(PRAZDNE_UKONCENI);
  // 1. 11. 2026 (zadání 5): „Ukončit a napsat email“ otevře po uložení náhled rozlučkového e-mailu.
  const [rozluckaPoUlozeni, setRozluckaPoUlozeni] = useState(null); // null | { spokojena }
  const [rozluckaOkno, setRozluckaOkno] = useState(null);           // null | { spokojena }
  const [konecObnova, setKonecObnova] = useState(0);
  const [spolupraceForm, setSpolupraceForm] = useState({});
  const [savingSpoluprace, setSavingSpoluprace] = useState(false);
  const [spolupraceConfirmOpen, setSpolupraceConfirmOpen] = useState(false);
  const [spolupraceErr, setSpolupraceErr] = useState(null);
  const [spolupraceOverride, setSpolupraceOverride] = useState(() => {
    return getClientOverride(client?.klient, {
      balicek: client?.balicek,
      trener: client?.trener,
      lokalita: client?.lokalita,
      typSpoluprace: client?.typSpoluprace,
      zacatek: client?.zacatek,
      konec: client?.konec,
    });
  });

  // ----- FINANCE edit state -----
  const [editingFinance, setEditingFinance] = useState(false);
  const [financeForm, setFinanceForm] = useState({});
  const [savingFinance, setSavingFinance] = useState(false);
  const [financeConfirmOpen, setFinanceConfirmOpen] = useState(false);
  const [financeErr, setFinanceErr] = useState(null);
  const [financeOverride, setFinanceOverride] = useState(() => {
    return getClientOverride(client?.klient, {
      zpusobPlatby: client?.zpusobPlatby,
      frekvence: client?.frekvenceFakturace,
      kdoFakturuje: client?.kdoFakturuje,
      castka: client?.castkaMesic,
    });
  });

  // ----- TRÉNINKOVÝ PROFIL edit state (Modul 2D) -----
  const [editingProfil, setEditingProfil] = useState(false);
  const [profilForm, setProfilForm] = useState({});
  const [savingProfil, setSavingProfil] = useState(false);
  const [profilConfirmOpen, setProfilConfirmOpen] = useState(false);
  const [profilErr, setProfilErr] = useState(null);
  const [profilOverride, setProfilOverride] = useState(() => {
    return getClientOverride(client?.klient, {
      levelTreninku: client?.levelTreninku,
      pocetTreninkuTyden: client?.pocetTreninkuTyden,
      casProTreninky: client?.casProTreninky,
      zajemOLokalitu: client?.zajemOLokalitu,
      zajemTrial: client?.zajemTrial,
      zkusenostiCviceni: client?.zkusenostiCviceni,
      kdyChceZacit: client?.kdyChceZacit,
      delkaSpoluprace: client?.delkaSpoluprace,
      zdravotniOmezeni: client?.zdravotniOmezeni,
      zraneni: client?.zraneni,
      chronickeBolesti: client?.chronickeBolesti,
      aktualniCil: client?.aktualniCil,
      poznamkySales: client?.poznamkySales,
    });
  });

  // ----- KONTAKTY override (Modul 2A1) — paralelně k spolupráce/finance overrides -----
  const [contactOverride, setContactOverride] = useState(() =>
    getContactOverride(client?.klient, client?.email, client?.telefon)
  );

  // ----- EFFECTIVE hodnoty (override > parent prop) pro všechna editovatelná pole -----
  const effectiveEmail = contactOverride?.email !== undefined ? contactOverride.email : client.email;
  const effectiveTelefon = contactOverride?.telefon !== undefined ? contactOverride.telefon : client.telefon;
  const effectiveBalicek = spolupraceOverride?.balicek !== undefined ? spolupraceOverride.balicek : client.balicek;
  const effectiveTrener = spolupraceOverride?.trener !== undefined ? spolupraceOverride.trener : client.trener;
  const effectiveLokalita = spolupraceOverride?.lokalita !== undefined ? spolupraceOverride.lokalita : client.lokalita;
  const effectiveTypSpoluprace = spolupraceOverride?.typSpoluprace !== undefined ? spolupraceOverride.typSpoluprace : client.typSpoluprace;
  const effectiveZacatek = spolupraceOverride?.zacatek !== undefined ? spolupraceOverride.zacatek : client.zacatek;
  const effectiveKonec = spolupraceOverride?.konec !== undefined ? spolupraceOverride.konec : client.konec;
  const effectiveZpusobPlatby = financeOverride?.zpusobPlatby !== undefined ? financeOverride.zpusobPlatby : client.zpusobPlatby;
  const effectiveFrekvence = financeOverride?.frekvence !== undefined ? financeOverride.frekvence : client.frekvenceFakturace;
  const effectiveKdoFakturuje = financeOverride?.kdoFakturuje !== undefined ? financeOverride.kdoFakturuje : client.kdoFakturuje;
  const effectiveCastka = financeOverride?.castka !== undefined ? financeOverride.castka : client.castkaMesic;
  // Modul 2B: Stage / Stav spolupráce / BLACKLIST (override v spoluprace bucket)
  const effectiveStage = spolupraceOverride?.stage !== undefined ? spolupraceOverride.stage : client.stage;
  const effectiveStav = spolupraceOverride?.stavSpoluprace !== undefined ? spolupraceOverride.stavSpoluprace : client.stav;
  const effectiveBlacklist = spolupraceOverride?.blacklist !== undefined ? spolupraceOverride.blacklist : client.blacklist;
  // Modul 2D: Tréninkový profil (samostatný override bucket)
  const effectiveLevelTreninku = profilOverride?.levelTreninku !== undefined ? profilOverride.levelTreninku : client.levelTreninku;
  const effectivePocetTreninkuTyden = profilOverride?.pocetTreninkuTyden !== undefined ? profilOverride.pocetTreninkuTyden : client.pocetTreninkuTyden;
  const effectiveCasProTreninky = profilOverride?.casProTreninky !== undefined ? profilOverride.casProTreninky : client.casProTreninky;
  const effectiveZajemOLokalitu = profilOverride?.zajemOLokalitu !== undefined ? profilOverride.zajemOLokalitu : client.zajemOLokalitu;
  const effectiveZajemTrial = profilOverride?.zajemTrial !== undefined ? profilOverride.zajemTrial : client.zajemTrial;
  const effectiveZkusenostiCviceni = profilOverride?.zkusenostiCviceni !== undefined ? profilOverride.zkusenostiCviceni : client.zkusenostiCviceni;
  const effectiveKdyChceZacit = profilOverride?.kdyChceZacit !== undefined ? profilOverride.kdyChceZacit : client.kdyChceZacit;
  const effectiveDelkaSpoluprace = profilOverride?.delkaSpoluprace !== undefined ? profilOverride.delkaSpoluprace : client.delkaSpoluprace;
  // Modul 2D část 2: sales call notes (rich_text)
  const effectiveZdravotniOmezeni = profilOverride?.zdravotniOmezeni !== undefined ? profilOverride.zdravotniOmezeni : client.zdravotniOmezeni;
  const effectiveZraneni = profilOverride?.zraneni !== undefined ? profilOverride.zraneni : client.zraneni;
  const effectiveChronickeBolesti = profilOverride?.chronickeBolesti !== undefined ? profilOverride.chronickeBolesti : client.chronickeBolesti;
  const effectiveAktualniCil = profilOverride?.aktualniCil !== undefined ? profilOverride.aktualniCil : client.aktualniCil;
  const effectivePoznamkySales = profilOverride?.poznamkySales !== undefined ? profilOverride.poznamkySales : client.poznamkySales;
  // 9.9.2026 — kolik z 13 kolonek dotazníku je vyplněných (odznak v hlavičce sekce)
  // a které poznámky od sales chybí (pilulky pod poznámkami). Jen zobrazení.
  const dotaznikHodnoty = [
    effectiveLevelTreninku, effectivePocetTreninkuTyden, effectiveCasProTreninky, effectiveZajemOLokalitu,
    effectiveZajemTrial, effectiveZkusenostiCviceni, effectiveKdyChceZacit, effectiveDelkaSpoluprace,
    effectiveZdravotniOmezeni, effectiveZraneni, effectiveChronickeBolesti, effectiveAktualniCil, effectivePoznamkySales,
  ];
  const dotaznikCelkem = dotaznikHodnoty.length;
  const dotaznikVyplneno = dotaznikHodnoty.filter((v) => v !== null && v !== undefined && String(v).trim() !== "").length;
  const salesChybi = [
    { label: "Zdravotní omezení", value: effectiveZdravotniOmezeni },
    { label: "Zranění", value: effectiveZraneni },
    { label: "Chronické bolesti", value: effectiveChronickeBolesti },
    { label: "Aktuální cíl", value: effectiveAktualniCil },
    { label: "Poznámky", value: effectivePoznamkySales },
  ].filter((f) => !String(f.value || "").trim()).map((f) => f.label);
  // Helper — přečte effective hodnotu pole z mapy (pro generic ConfirmDialog rendering)
  const getEffective = (fieldKey) => ({
    balicek: effectiveBalicek,
    trener: effectiveTrener,
    lokalita: effectiveLokalita,
    typSpoluprace: effectiveTypSpoluprace,
    zacatek: effectiveZacatek,
    konec: effectiveKonec,
    zpusobPlatby: effectiveZpusobPlatby,
    frekvence: effectiveFrekvence,
    kdoFakturuje: effectiveKdoFakturuje,
    castka: effectiveCastka,
    stage: effectiveStage,
    stavSpoluprace: effectiveStav,
    blacklist: effectiveBlacklist,
    levelTreninku: effectiveLevelTreninku,
    pocetTreninkuTyden: effectivePocetTreninkuTyden,
    casProTreninky: effectiveCasProTreninky,
    zajemOLokalitu: effectiveZajemOLokalitu,
    zajemTrial: effectiveZajemTrial,
    zkusenostiCviceni: effectiveZkusenostiCviceni,
    kdyChceZacit: effectiveKdyChceZacit,
    delkaSpoluprace: effectiveDelkaSpoluprace,
    zdravotniOmezeni: effectiveZdravotniOmezeni,
    zraneni: effectiveZraneni,
    chronickeBolesti: effectiveChronickeBolesti,
    aktualniCil: effectiveAktualniCil,
    poznamkySales: effectivePoznamkySales,
    email: effectiveEmail,
    telefon: effectiveTelefon,
  }[fieldKey]);
  // PDF export povolen pro role kdo má přehled o klientech (vlastník, manager, klient. manager).
  // 5.9.2026 (fáze 4b): telefon má vlastní hlavičku detailu (schváleno).
  const uzka = useUzkaObrazovka();
  const currentUser = getCurrentUser();
  const canExportPdf = currentUser && ["owner", "manager", "csm"].includes(currentUser.role);
  // Edit kontaktů povolen pro owner, manager, csm
  const canEditContacts = currentUser && !isManagerView && ["owner", "manager", "csm"].includes(currentUser.role);
  const canMarkPropad = !!(currentUser && ["owner", "manager", "csm", "trener"].includes(String(currentUser.role || "").toLowerCase()));
  // Planovanou zmenu balicku smi videt a zadavat jen owner a CSM.
  const canPlanBalicek = !!(currentUser && ["owner", "csm"].includes(String(currentUser.role || "").toLowerCase()));
  // 7.8.2026 duplicitní jména: všechny per-klient fetche a sessionStorage klíče
  // scopujeme notion_id, ne jménem — dvě klientky se stejným jménem si jinak
  // míchaly rezervace i faktury.
  const clientCid = String((client && (client.notion_id || (client.notion ? notionIdFromUrlCd(client.notion) : ""))) || "");
  const cidQ = clientCid ? `&klientId=${encodeURIComponent(clientCid)}` : "";
  const cidK = clientCid ? `|${clientCid}` : "";

  const reloadBookings = () => {
    if (!client || !client.klient) return;
    // force=1 obchazi 5min serverovou in-memory cache client-bookings — po zapisu
    // propadnuti tak dostaneme cerstvy stav z PG (a cache se prepise), stejne jako trener.
    apiFetch(`/api/client-bookings?klient=${encodeURIComponent(client.klient)}&force=1${cidQ}`)
      .then((r) => r.json()).then((j) => {
        if (!j.error) {
          setBookings(j);
          try { sessionStorage.setItem(`fw40_client_bookings_${client.klient}${cidK}`, JSON.stringify({ data: j, savedAt: Date.now() })); } catch { /* ignore */ }
        }
      }).catch(() => {});
  };

  // Optimistický lokální update propadnutí (bez reloadu z cache, který lagoval).
  const applyPropadLocal = (b, value) => {
    setBookings((prev) => {
      if (!prev) return prev;
      const match = (x) =>
        x.date === b.date &&
        (x.cas || "") === (b.cas || "") &&
        (x.trener || "") === (b.trener || "");
      let delta = 0;
      const patch = (arr) => (arr || []).map((x) => {
        if (!match(x)) return x;
        const was = !!x.propadnuti, now = !!value;
        if (was !== now) delta += now ? 1 : -1;
        return { ...x, propadnuti: value ? "ano" : "" };
      });
      const next = { ...prev, future: patch(prev.future), history: patch(prev.history) };
      if (prev.stats) next.stats = { ...prev.stats, propadlych: Math.max(0, (Number(prev.stats.propadlych) || 0) + delta) };
      try {
        if (client?.klient) sessionStorage.setItem(`fw40_client_bookings_${client.klient}${cidK}`, JSON.stringify({ data: next, savedAt: Date.now() }));
      } catch { /* ignore */ }
      return next;
    });
  };

  // Otevři edit mode — naplní edit state z aktuálních hodnot
  const startEditContacts = () => {
    setEditEmail(effectiveEmail || "");
    setEditTelefon(effectiveTelefon || "");
    setContactsErr(null);
    setEditingContacts(true);
  };
  const cancelEditContacts = () => {
    setEditingContacts(false);
    setContactsErr(null);
  };

  // Validace pro edit mode
  const editEmailValid = !editEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editEmail);
  const editPhoneValid = !editTelefon || /^\+?\d{9,15}$/.test(String(editTelefon).replace(/[\s\-]/g, ""));
  const editEmailChanged = (editEmail || "").trim() !== (effectiveEmail || "").trim();
  const editTelefonChanged = (editTelefon || "").trim() !== (effectiveTelefon || "").trim();
  const editHasChanges = editEmailChanged || editTelefonChanged;
  const editCanSave = editHasChanges && editEmailValid && editPhoneValid && !savingContacts;

  // Klik Uložit → otevři confirm dialog s warning o Reservio + FAPI
  const askSaveContacts = () => {
    if (!editCanSave) return;
    setContactsConfirmOpen(true);
  };

  // Potvrzení v ConfirmDialog → reálný save
  // AlertContext pro instant zobrazení notifikace v zvonu po edit
  const { addLocal: addLocalNotification } = useNotifications();

  const doSaveContacts = () => {
    // INSTANT UI: zavřít confirm dialog + modal hned, nečekat na backend.
    // Backend (Notion + Leady + Stav 2026 paralelně) běží asynchronně.
    setContactsConfirmOpen(false);
    setContactsErr(null);
    const fields = {};
    if (editEmailChanged) fields.email = editEmail.trim();
    if (editTelefonChanged) fields.telefon = editTelefon.trim();
    const newOverride = { email: editEmail.trim(), telefon: editTelefon.trim() };
    // Optimistic update — uživatel vidí novou hodnotu okamžitě
    setContactOverride(newOverride);
    setContactOverrideCache(client?.klient, newOverride);
    setEditingContacts(false);
    setSavingContacts(true);

    // Backend API call paralelně — pokud selže, revert + ukázat chybu
    apiFetch("/api/klient-edit", {
      method: "POST",
      body: JSON.stringify({ notionUrl: client.notion, fields }),
    })
      .then(async (r) => {
        const j = await r.json();
        if (!r.ok) throw new Error(j.error || `HTTP ${r.status}`);
        // Instant zobrazení notifikace v zvonu (bez čekání na refresh)
        if (j.notification && addLocalNotification) {
          addLocalNotification(j.notification);
        }
        return j;
      })
      .catch((e) => {
        // Revert optimistic update
        setContactOverride(null);
        setContactsErr(`Uložení selhalo: ${e.message}. Změny nebyly uloženy.`);
        setEditingContacts(true); // znovu otevři edit režim aby user viděl chybu
      })
      .finally(() => {
        setSavingContacts(false);
      });
  };

  // ============================================================================
  // Modul 2B — generic SPOLUPRÁCE + FINANCE edit
  // ----------------------------------------------------------------------------
  // Společný flow pro všechny edit režimy mimo kontakty:
  //   1) startEdit{Section} naplní form z effective hodnot
  //   2) user mění inputy v form state
  //   3) askSave{Section} otevře ConfirmDialog s diff + warningy z changedFields
  //   4) doSave{Section} pošle jen změněná pole backendu, optimistic localStorage cache
  //   5) Backend triple-write (Notion + Leady + Stav 2026) + Slack + in-app notifikace
  // ============================================================================

  // Spočítá list změněných polí mezi form state a effective hodnotou (trim porovnání).
  // Pro datumy (zacatek, konec) normalizuje na YYYY-MM-DD před porovnáním.
  function computeChanged(form, fields) {
    const out = [];
    for (const f of fields) {
      const isDate = f === "zacatek" || f === "konec";
      const cur = isDate ? isoDateOnly(getEffective(f)) : (getEffective(f) || "").toString().trim();
      const next = isDate ? isoDateOnly(form[f]) : (form[f] || "").toString().trim();
      if (cur !== next) out.push(f);
    }
    return out;
  }
  // Sesbírá warningy pro list changed fields (dedup).
  // 1. 11. 2026 (Alena Hájková): u balíčku podle nové hodnoty, stejně jako backend (warningsPro).
  function collectWarnings(changedFields) {
    const set = new Set();
    for (const f of changedFields) {
      if (f === "balicek" && /permanentk|permic|v[yý][žz]iv/i.test(String(spolupraceForm?.balicek || ""))) {
        set.add("Permanentka a výživa se platí jednorázově. Pokud klientka měla pravidelnou fakturu za koučink, ukonči ji v Plánu fakturace.");
        continue;
      }
      if (FIELD_WARNINGS[f]) set.add(FIELD_WARNINGS[f]);
    }
    return Array.from(set);
  }

  // Modul 2E: auto-suggest Frekvence dle balíčku.
  // Mapping (case-insensitive substring v názvu balíčku):
  //   "1T" → "1× týdně"
  //   "2T" → "2× týdně"
  //   "3T" → "3× týdně"
  //   "Permanentka 10 OT" → "2× týdně" (default, 10 trén/5 týdnů)
  //   "FLEX" → bez návrhu (klient sám určí)
  // Vrátí navrženou Frekvenci nebo null.
  function suggestFrekvenceFromBalicek(balicek) {
    if (!balicek) return null;
    const b = String(balicek).toLowerCase();
    if (b.includes("flex")) return null; // klient sám
    if (b.includes("permanentka")) return "2× týdně";
    if (b.includes("3t")) return "3× týdně";
    if (b.includes("2t")) return "2× týdně";
    if (b.includes("1t")) return "1× týdně";
    return null;
  }
  // Vrátí auto-frekvence warning pokud uživatel změnil Balíček ve Spolupráce
  // edit a aktuální Frekvence v Stav 2026 nesedí s doporučením.
  // Vrátí string warning nebo null.
  function autoFrekvenceWarning(spolupraceForm) {
    const newBalicek = (spolupraceForm?.balicek || "").trim();
    if (!newBalicek || newBalicek === (effectiveBalicek || "").trim()) return null;
    const suggested = suggestFrekvenceFromBalicek(newBalicek);
    if (!suggested) return null;
    const cur = (effectiveFrekvence || "").trim();
    if (cur === suggested) return null;
    return `Doporučená Frekvence pro balíček "${newBalicek}" je "${suggested}". Aktuálně je nastaveno "${cur || "—"}". Po uložení uprav ve Finance editu.`;
  }

  // ----- SPOLUPRÁCE handlers -----
  const startEditSpoluprace = () => {
    setSpolupraceForm({
      balicek: effectiveBalicek || "",
      trener: effectiveTrener || "",
      lokalita: effectiveLokalita || "",
      typSpoluprace: effectiveTypSpoluprace || "",
      // Datumy normalizovat na YYYY-MM-DD (input type=date vyžaduje tento formát)
      zacatek: isoDateOnly(effectiveZacatek),
      konec: isoDateOnly(effectiveKonec),
      // Modul 2B
      stage: effectiveStage || "",
      stavSpoluprace: effectiveStav || "",
      blacklist: effectiveBlacklist || "",
    });
    setSpolupraceErr(null);
    setEditingSpoluprace(true);
  };
  const cancelEditSpoluprace = () => {
    setEditingSpoluprace(false);
    setSpolupraceErr(null);
  };
  const spolupraceChanged = computeChanged(spolupraceForm, SPOLUPRACE_FIELDS);
  const spolupraceCanSave = editingSpoluprace && spolupraceChanged.length > 0 && !savingSpoluprace;
  const askSaveSpoluprace = () => {
    if (!spolupraceCanSave) return;
    setSpolupraceConfirmOpen(true);
  };
  const doSaveSpoluprace = () => {
    setSpolupraceConfirmOpen(false);
    setSpolupraceErr(null);
    const fields = {};
    const overridePatch = {};
    for (const f of spolupraceChanged) {
      const v = (spolupraceForm[f] || "").trim();
      fields[f] = v;
      overridePatch[f] = v;
    }
    // Optimistic update — uživatel vidí novou hodnotu okamžitě, přežije F5.
    setSpolupraceOverride({ ...(spolupraceOverride || {}), ...overridePatch });
    setClientOverride(client?.klient, overridePatch);
    setEditingSpoluprace(false);
    setSavingSpoluprace(true);

    const rozlucka = fields.stavSpoluprace === "Ukončeno" ? rozluckaPoUlozeni : null;
    apiFetch("/api/klient-edit", {
      method: "POST",
      body: JSON.stringify({ notionUrl: client.notion, fields, ...(fields.stavSpoluprace === "Ukončeno" ? { ukonceni: ukonceniInfo } : {}) }),
    })
      .then(async (r) => {
        const j = await r.json();
        if (!r.ok) throw new Error(j.error || `HTTP ${r.status}`);
        if (fields.stavSpoluprace === "Ukončeno") {
          // Blacklist ve SmartEmailingu se mohl nepovést, ukončení ale proběhlo.
          if (j.ukonceni?.blacklist?.ok === false) toast(`Spolupráce je ukončená, ale blacklist ve SmartEmailingu se nepovedl: ${j.ukonceni.blacklist.chyba || "neznámá chyba"}`, "warning");
          else if (j.ukonceni?.blacklist?.ok) toast("Klientka je na blacklistu ve SmartEmailingu.", "success");
          if (j.ukonceni?.chyba) toast(j.ukonceni.chyba, "warning");
          setRozluckaPoUlozeni(null);
          setKonecObnova((x) => x + 1);
          if (rozlucka) setRozluckaOkno(rozlucka);
        }
        if (j.notification && addLocalNotification) addLocalNotification(j.notification);
        // Pokud se změnily select fields (balíček/trenér/...), invaliduj options cache —
        // při příštím otevření edit režimu se objeví aktualizované hodnoty.
        invalidateClientFieldOptions();
        return j;
      })
      .catch((e) => {
        // 20. 10. 2026: neuložená změna nesmí zůstat v uloženém náhledu (localStorage 24 h).
        odeberClientOverride(client?.klient, Object.keys(overridePatch));
        // Revert optimistic update — odstraň jen ty pole co jsme přidali
        setSpolupraceOverride((prev) => {
          if (!prev) return null;
          const next = { ...prev };
          for (const f of Object.keys(overridePatch)) delete next[f];
          return Object.keys(next).length > 0 ? next : null;
        });
        setSpolupraceErr(`Uložení selhalo: ${e.message}. Změny nebyly uloženy.`);
        setEditingSpoluprace(true);
      })
      .finally(() => {
        setSavingSpoluprace(false);
      });
  };

  // BLACKLIST (24.6.2026) — owner/manager dá klienta na blacklist. Zapíše Notion
  // "Stav spolupráce" = BLACKLIST (přes klient-edit pole stavSpoluprace); tag optimisticky hned.
  // Stávající BLACKLIST klienti nejsou dotčeni (tlačítko se zobrazí jen když ještě není blacklist).
  const [blacklisting, setBlacklisting] = useState(false);
  const [confirmBlacklist, setConfirmBlacklist] = useState(false); // designový confirm místo window.confirm
  const doBlacklist = () => {
    if (blacklisting) return;
    if (!client?.notion) { if (typeof window !== "undefined") toast("Klient nemá Notion odkaz, blacklist nelze zapsat.", "error"); return; }
    setConfirmBlacklist(true);
  };
  const doBlacklistConfirmed = () => {
    setConfirmBlacklist(false);
    const overridePatch = { blacklist: "ano", stavSpoluprace: "BLACKLIST" };
    setSpolupraceOverride({ ...(spolupraceOverride || {}), ...overridePatch });
    setClientOverride(client?.klient, overridePatch);
    setBlacklisting(true);
    apiFetch("/api/klient-edit", {
      method: "POST",
      body: JSON.stringify({ notionUrl: client.notion, fields: { stavSpoluprace: "BLACKLIST" } }),
    })
      .then(async (r) => {
        const j = await r.json();
        if (!r.ok) throw new Error(j.error || `HTTP ${r.status}`);
        if (j.notification && addLocalNotification) addLocalNotification(j.notification);
        return j;
      })
      .catch((e) => {
        // 20. 10. 2026: neuložená změna nesmí zůstat v uloženém náhledu (localStorage 24 h).
        odeberClientOverride(client?.klient, Object.keys(overridePatch));
        setSpolupraceOverride((prev) => {
          if (!prev) return null;
          const next = { ...prev };
          delete next.blacklist; delete next.stavSpoluprace;
          return Object.keys(next).length > 0 ? next : null;
        });
        if (typeof window !== "undefined") toast(`Blacklist se nepodařilo nastavit: ${e.message}`, "error");
      })
      .finally(() => setBlacklisting(false));
  };

  // TRÉNINKOVÉ UPOMÍNKY (7.8.2026) — vypnutí automatických úkolů trenérovi:
  // „klient nebyl na tréninku už X dní, domluv termín" + položky klienta v úkolech
  // na plánování týdne/měsíce. U některých klientů to nedává smysl a trenér pak
  // dostává úkoly, které nemá řešit. Fakturace, permanentky ani propadlé tréninky
  // tím dotčené NEJSOU. Ukládá /api/klient-sprava do clients.data JSONB.
  const [upominkyBusy, setUpominkyBusy] = useState(false);
  // null = beze změny v této session, jinak { vypnuto, kdo, kdy } z odpovědi API.
  const [upominkyOverride, setUpominkyOverride] = useState(null);
  const prepnoutUpominky = async (vypnout) => {
    if (upominkyBusy) return;
    const klientId = client.notion_id || notionIdFromUrlCd(client.notion);
    if (!klientId) { toast("Klient nemá ID, přepínač nelze uložit.", "error"); return; }
    setUpominkyBusy(true);
    try {
      const res = await apiFetch("/api/klient-sprava", {
        method: "POST",
        body: JSON.stringify({ action: vypnout ? "upominky-vypnout" : "upominky-zapnout", klient_id: klientId }),
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok || !j.ok) throw new Error(j.error || `HTTP ${res.status}`);
      setUpominkyOverride({
        vypnuto: !!j.bezTreninkovychUpominek,
        kdo: j.bezTreninkovychUpominekKdo || "",
        kdy: j.bezTreninkovychUpominekOd || "",
      });
      toast(vypnout ? "Tréninkové upomínky vypnuty." : "Tréninkové upomínky zapnuty.", "success");
    } catch (e) {
      toast(`Přepnutí se nepodařilo: ${e.message}`, "error");
    } finally {
      setUpominkyBusy(false);
    }
  };
  // Efektivní stav: optimisticky z posledního přepnutí, jinak z dat klienta (/api/clients).
  const upominkyVypnute = upominkyOverride ? upominkyOverride.vypnuto : !!client.bezTreninkovychUpominek;
  const upominkyKdo = upominkyOverride ? upominkyOverride.kdo : (client.bezTreninkovychUpominekKdo || "");
  // Timestamp z PG je NOW()::text ("2026-08-07 17:02:33+00") — mezeru na "T", ať to
  // spolehlivě rozparsuje Date i mimo Chrome. Když se to nepovede, ukáže se raw text.
  const upominkyKdy = formatDateTime(String((upominkyOverride ? upominkyOverride.kdy : client.bezTreninkovychUpominekOd) || "").replace(" ", "T"));

  // ----- FINANCE handlers — Způsob platby + Frekvence fakturace + Kdo fakturuje + Castka
  // (Poslední faktura je read-only z FAPI) -----
  const startEditFinance = () => {
    // Castka inicializovana: rucni hodnota castkaMesic > auto vypocet z FAPI castkaMesicSpoctena.
    // User vidi predvyplnenou doporucenou hodnotu hned, bez nutnosti klikat Pouzit.
    const initialCastka = effectiveCastka || client.castkaMesicSpoctena || "";
    setFinanceForm({
      zpusobPlatby: effectiveZpusobPlatby || "",
      frekvence: effectiveFrekvence || "",
      kdoFakturuje: effectiveKdoFakturuje || "",
      castka: initialCastka ? String(initialCastka) : "",
    });
    setFinanceErr(null);
    setEditingFinance(true);
  };
  const cancelEditFinance = () => {
    setEditingFinance(false);
    setFinanceErr(null);
  };
  const financeChanged = computeChanged(financeForm, FINANCE_FIELDS);
  const financeCanSave = editingFinance && financeChanged.length > 0 && !savingFinance;
  const askSaveFinance = () => {
    if (!financeCanSave) return;
    setFinanceConfirmOpen(true);
  };
  const doSaveFinance = () => {
    setFinanceConfirmOpen(false);
    setFinanceErr(null);
    const fields = {};
    const overridePatch = {};
    for (const f of financeChanged) {
      const v = (financeForm[f] || "").trim();
      fields[f] = v;
      overridePatch[f] = v;
    }
    setFinanceOverride({ ...(financeOverride || {}), ...overridePatch });
    setClientOverride(client?.klient, overridePatch);
    setEditingFinance(false);
    setSavingFinance(true);

    apiFetch("/api/klient-edit", {
      method: "POST",
      body: JSON.stringify({ notionUrl: client.notion, fields }),
    })
      .then(async (r) => {
        const j = await r.json();
        if (!r.ok) throw new Error(j.error || `HTTP ${r.status}`);
        if (j.notification && addLocalNotification) addLocalNotification(j.notification);
        invalidateClientFieldOptions();
        return j;
      })
      .catch((e) => {
        // 20. 10. 2026: neuložená změna nesmí zůstat v uloženém náhledu (localStorage 24 h).
        odeberClientOverride(client?.klient, Object.keys(overridePatch));
        setFinanceOverride((prev) => {
          if (!prev) return null;
          const next = { ...prev };
          for (const f of Object.keys(overridePatch)) delete next[f];
          return Object.keys(next).length > 0 ? next : null;
        });
        setFinanceErr(`Uložení selhalo: ${e.message}. Změny nebyly uloženy.`);
        setEditingFinance(true);
      })
      .finally(() => {
        setSavingFinance(false);
      });
  };

  // ----- TRÉNINKOVÝ PROFIL handlers (Modul 2D) -----
  const startEditProfil = () => {
    setProfilForm({
      levelTreninku: effectiveLevelTreninku || "",
      pocetTreninkuTyden: effectivePocetTreninkuTyden || "",
      casProTreninky: effectiveCasProTreninky || "",
      zajemOLokalitu: effectiveZajemOLokalitu || "",
      zajemTrial: effectiveZajemTrial || "",
      zkusenostiCviceni: effectiveZkusenostiCviceni || "",
      kdyChceZacit: effectiveKdyChceZacit || "",
      delkaSpoluprace: effectiveDelkaSpoluprace || "",
      zdravotniOmezeni: effectiveZdravotniOmezeni || "",
      zraneni: effectiveZraneni || "",
      chronickeBolesti: effectiveChronickeBolesti || "",
      aktualniCil: effectiveAktualniCil || "",
      poznamkySales: effectivePoznamkySales || "",
    });
    setProfilErr(null);
    setEditingProfil(true);
  };
  const cancelEditProfil = () => {
    setEditingProfil(false);
    setProfilErr(null);
  };
  const profilChanged = computeChanged(profilForm, PROFIL_FIELDS);
  const profilCanSave = editingProfil && profilChanged.length > 0 && !savingProfil;
  const askSaveProfil = () => {
    if (!profilCanSave) return;
    setProfilConfirmOpen(true);
  };
  const doSaveProfil = () => {
    setProfilConfirmOpen(false);
    setProfilErr(null);
    const fields = {};
    const overridePatch = {};
    for (const f of profilChanged) {
      const v = (profilForm[f] || "").trim();
      fields[f] = v;
      overridePatch[f] = v;
    }
    setProfilOverride({ ...(profilOverride || {}), ...overridePatch });
    setClientOverride(client?.klient, overridePatch);
    setEditingProfil(false);
    setSavingProfil(true);

    apiFetch("/api/klient-edit", {
      method: "POST",
      body: JSON.stringify({ notionUrl: client.notion, fields }),
    })
      .then(async (r) => {
        const j = await r.json();
        if (!r.ok) throw new Error(j.error || `HTTP ${r.status}`);
        if (j.notification && addLocalNotification) addLocalNotification(j.notification);
        invalidateClientFieldOptions();
        return j;
      })
      .catch((e) => {
        // 20. 10. 2026: neuložená změna nesmí zůstat v uloženém náhledu (localStorage 24 h).
        odeberClientOverride(client?.klient, Object.keys(overridePatch));
        setProfilOverride((prev) => {
          if (!prev) return null;
          const next = { ...prev };
          for (const f of Object.keys(overridePatch)) delete next[f];
          return Object.keys(next).length > 0 ? next : null;
        });
        setProfilErr(`Uložení selhalo: ${e.message}. Změny nebyly uloženy.`);
        setEditingProfil(true);
      })
      .finally(() => {
        setSavingProfil(false);
      });
  };

  // Editace poznámek ke spolupráci — owner, manager, csm, trener (trener jen své klienty
  // = trener je linkedTrener klienta).
  const canEditNote = currentUser && (
    ["owner", "manager", "csm"].includes(currentUser.role) ||
    (currentUser.role === "trener" && currentUser.linkedTrener && currentUser.linkedTrener === client.trener)
  );

  // Načti historii / budoucnost klienta při otevření. SessionStorage cache 5 min
  // pro instant first paint pri opetovnem otevreni klienta + background refresh.
  useEffect(() => {
    if (!client?.klient) return;
    const cacheKey = `fw40_client_bookings_${client.klient}${cidK}`;
    let aborted = false;

    // 1. Pokud mame cache, ukazme ji okamzite (no spinner)
    let hadCache = false;
    try {
      const raw = sessionStorage.getItem(cacheKey);
      if (raw) {
        const obj = JSON.parse(raw);
        if (obj && obj.savedAt && (Date.now() - obj.savedAt) < 5 * 60 * 1000 && obj.data) {
          setBookings(obj.data);
          setBookingsLoading(false);
          hadCache = true;
        }
      }
    } catch { /* ignore */ }

    if (!hadCache) {
      setBookingsLoading(true);
    }
    setBookingsError(null);

    // 2. Background fetch (vzdy refreshne data)
    apiFetch(`/api/client-bookings?klient=${encodeURIComponent(client.klient)}&force=1${cidQ}`)
      .then((r) => r.json())
      .then((j) => {
        if (aborted) return;
        if (j.error) throw new Error(j.error);
        setBookings(j);
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ data: j, savedAt: Date.now() })); } catch { /* quota */ }
      })
      .catch((e) => !aborted && setBookingsError(e.message))
      .finally(() => !aborted && setBookingsLoading(false));

    return () => { aborted = true; };
  }, [client?.klient, clientCid]);

  // Prefetch ST + Bonus entries (current year) hned po otevreni detailu — aby pri kliku
  // na dlazdici "Bonusové" / "Spojené" bylo data uz hotova (zadna cekani na fetch).
  // 22.5.2026: read sessionStorage cache prvni (z prefetchClient hover), fetch refresh on pozadi.
  useEffect(() => {
    if (!client?.klient || client?.isLead === true) return;
    let aborted = false;
    // 1) Instant load z cache
    try {
      const cached = sessionStorage.getItem("fw40_log_st_bonus_all");
      if (cached) {
        const obj = JSON.parse(cached);
        if (obj && obj.data && (Date.now() - obj.savedAt) < 5 * 60 * 1000) {
          if (Array.isArray(obj.data.bonus)) setBonusEntries(obj.data.bonus);
          if (Array.isArray(obj.data.st)) setStEntries(obj.data.st);
        }
      }
    } catch {}
    // 2) Background refresh
    apiFetch("/api/log-st-bonus?od=epocha")
      .then((r) => r.json())
      .then((j) => {
        if (aborted) return;
        if (j && Array.isArray(j.bonus)) setBonusEntries(j.bonus);
        else setBonusEntries([]);
        if (j && Array.isArray(j.st)) setStEntries(j.st);
        else setStEntries([]);
        try { sessionStorage.setItem("fw40_log_st_bonus_all", JSON.stringify({ data: j, savedAt: Date.now() })); } catch {}
      })
      .catch((e) => {
        if (aborted) return;
        setBonusError(e?.message || "Chyba");
        setStError(e?.message || "Chyba");
      });
    return () => { aborted = true; };
  }, [client?.klient, client?.isLead]);

  // Historie plateb (FAPI faktury + log_cash) — fetch on mount, lazy if needed.
  // POZOR: pouzivame client.isLead inline misto isLead promenne (deklarace az pozdeji
  // pres const → TDZ ReferenceError pri useEffect ktery bezi v body funkce).
  useEffect(() => {
    if (!client?.klient || client?.isLead === true) return;
    let aborted = false;
    // 22.5.2026: instant load z prefetch cache (sessionStorage)
    let hadCache = false;
    try {
      const cached = sessionStorage.getItem(`fw40_client_invoices_${client.klient}${cidK}`);
      if (cached) {
        const obj = JSON.parse(cached);
        if (obj && obj.data && (Date.now() - obj.savedAt) < 5 * 60 * 1000) {
          setInvoices(obj.data);
          hadCache = true;
        }
      }
    } catch {}
    if (!hadCache) setInvoicesLoading(true);
    setInvoicesError(null);
    apiFetch(`/api/client-invoices?klient=${encodeURIComponent(client.klient)}${cidQ}`)
      .then((r) => r.json())
      .then((j) => {
        if (aborted) return;
        if (j.error) throw new Error(j.error);
        setInvoices(j);
        try { sessionStorage.setItem(`fw40_client_invoices_${client.klient}${cidK}`, JSON.stringify({ data: j, savedAt: Date.now() })); } catch {}
      })
      .catch((e) => !aborted && setInvoicesError(e.message))
      .finally(() => !aborted && setInvoicesLoading(false));
    return () => { aborted = true; };
  }, [client?.klient, client?.isLead, clientCid]);

  // Rok vybraný v heatmapě "Tréninky po měsících" (8.9.2026). Výchozí letošní,
  // seznam roků a měsíční čísla posílá /api/client-bookings.
  const [heatRok, setHeatRok] = useState(() => new Date().getFullYear());

  // Načti Log Expired pro klienta (jen schválené propadlé) za vybraný rok heatmapy.
  // Sdílený cache (lib/logExpiredCache.js) — pokud Clients.jsx udělal prewarm,
  // tento fetch je instant (0ms, jen filter z paměti).
  useEffect(() => {
    if (!client?.klient) { setLogExpired([]); return; }
    fetchLogExpired({ clientName: client.klient, year: heatRok })
      .then((entries) => {
        const ano = entries.filter((e) => e.schvaleno === "ANO");
        setLogExpired(ano);
      })
      .catch(() => setLogExpired([]));
  }, [client?.klient, heatRok]);

  // Pole 12 prvků [leden..prosinec] s počtem schválených propadlých per měsíc
  const propadleByMonth = useMemo(() => {
    const arr = new Array(12).fill(0);
    logExpired.forEach((e) => {
      const idx = MONTH_FULL.indexOf(e.mesic);
      if (idx >= 0) arr[idx] += Number(e.propadle) || 0;
    });
    return arr;
  }, [logExpired]);

  // "Zrušené pozdě" = konkrétní tréninky, které trenér označil PROPADL v týdenním rozvrhu
  // (pozdní zrušení < 24 h). Z bookings.history (booking.propadnuti), NE z Log Expired
  // automatizace (měsíční minimum). Ty automatizace sem nepatří.
  const lateBookings = useMemo(() => {
    const h = (bookings && bookings.history) || [];
    const f = (bookings && bookings.future) || [];
    // Propadlý je propadlý bez ohledu na datum (dnešní PROPADL je v "future" bucketu) → bereme oboje.
    return [...h, ...f].filter((b) => b.propadnuti).sort((a, b) => String(b.date).localeCompare(String(a.date)));
  }, [bookings]);
  const lateTotal = lateBookings.length;
  // Pozdě zrušené per měsíc (letošní rok) — pro oranžový badge v heatmapě.
  const lateByMonthHeat = useMemo(() => {
    const arr = Array(12).fill(0);
    for (const b of lateBookings) {
      const m = String(b.date || "").match(/^(\d{4})-(\d{2})/);
      if (m && parseInt(m[1], 10) === heatRok) arr[parseInt(m[2], 10) - 1] += 1;
    }
    return arr;
  }, [lateBookings, heatRok]);

  // Roky, ve kterých má klient odchozené tréninky (z /api/client-bookings). Letošní
  // je tam vždy, ať jde heatmapa otevřít i než dojedou rezervace.
  const heatRoky = useMemo(() => {
    const letos = new Date().getFullYear();
    const zApi = Array.isArray(bookings?.roky) ? bookings.roky.map(Number).filter(Boolean) : [];
    return [...new Set([letos, ...zApi])].sort((a, b) => b - a);
  }, [bookings]);

  // Měsíční čísla pro vybraný rok. Pro letošek necháváme přednost dopočtu z /api/clients
  // (stejný zdroj jako zbytek detailu), pro starší roky jdou z /api/client-bookings.
  const heatMesice = useMemo(() => {
    const letos = new Date().getFullYear();
    const zApi = bookings?.statistikyPoLetech?.[heatRok]?.odchozene;
    if (heatRok === letos) {
      const ulozene = client?.treninkyPoMesicich;
      if (Array.isArray(ulozene) && ulozene.length === 12) return ulozene.map((x) => parseInt(x, 10) || 0);
    }
    return Array.isArray(zApi) && zApi.length === 12 ? zApi.map((x) => parseInt(x, 10) || 0) : Array(12).fill(0);
  }, [bookings, heatRok, client?.treninkyPoMesicich]);

  // Souhrny pro seskupené dlaždice (24.6.2026):
  //  - odchozenoTotal = součet odchozených tréninků po měsících (heatmap data).
  //  - propadleAutoTotal = schválené propadlé z Log Expired (automatizace, měsíční minimum).
  // 13. 10. 2026 (přechod roku bez nulování): zůstatek se počítá od roku 2026, takže
  // k letošku se přičtou odchozené a propadlé z předchozích let (v roce 2026 nuly).
  const odchozenoTotal = (client?.treninkyPoMesicich || []).reduce((s, n) => s + (Number(n) || 0), 0)
    + (Number(client?.odchozenoPredchoziRoky) || 0);
  const propadleAutoTotal = logExpired.reduce((s, e) => s + (Number(e.propadle) || 0), 0)
    + (Number(client?.propadleMinPredchoziRoky) || 0);

  // Esc zavírá detail
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!client) return null;

  // tel: link vždy s mezinárodním prefixem (+420 default pokud display nemá jiný).
  // Display je "724 017 588" bez +420, ale dial musí být +420724017588 pro správné vytáčení.
  const phoneLink = effectiveTelefon ? (() => {
    const stripped = String(effectiveTelefon).replace(/[\s\-()]/g, "");
    if (stripped.startsWith("+")) return `tel:${stripped}`;
    if (/^\d{9}$/.test(stripped)) return `tel:+420${stripped}`;
    return `tel:${stripped}`;
  })() : null;
  const emailLink = effectiveEmail ? `mailto:${effectiveEmail}` : null;
  const months = calcMonthsCooperation(client.zacatek, client.konec, client.typSpoluprace);
  const cooperationLabel = formatCooperationDuration(months);
  // Stav tréninků (k odchození) počítáme ŽIVĚ stejným vzorcem jako stavTreninku.cjs, ale
  // z živé docházky (treninkyPoMesicich = PG bookings), ne ze zastaralého uloženého sloupce.
  // available = z fakturace + z min. roku + bonusové; attended = skutečný součet měsíců;
  // propadle = schválené propadlé; stav_pred = available - attended; propadlé nesrazí pod nulu.
  // 25.6.2026: ZRUŠEN clamp `min(monthsSum, celkem)` — schovával reálné PŘETRÉNOVÁNÍ (klient
  // odchodil víc, než má → záporné). Starý +1 z trialů už řeší filtr výš (reservioTreninky
  // vylučuje "zkušebn") a PG dedup booking_id, takže clamp jen maskoval minus.
  const stavTreninkuNum = (() => {
    // Kanonická hodnota z /api/clients (clientsPg) — propadlé počítá ŽIVĚ z bookings (trenérem
    // označené pozdní zrušení propadá hned). Preferuj ji, ať detail sedí se seznamem.
    if (client.stavTreninku !== undefined && client.stavTreninku !== null && client.stavTreninku !== "") {
      const n = parseInt(client.stavTreninku, 10);
      if (!isNaN(n)) return n;
    }
    // Fallback (chybějící uložená hodnota): lokální výpočet ze schválených propadlých.
    const available = (Number(client.treninkyZFakturace) || 0) + (Number(client.zustatekMinRoku) || 0) + (Number(client.bonusoveTreninky) || 0);
    const attended = (client.treninkyPoMesicich || []).reduce((a, b) => a + (parseInt(b, 10) || 0), 0);
    const approvedPropadle = (propadleByMonth || []).reduce((a, b) => a + (Number(b) || 0), 0);
    const stavPred = available - attended;
    return stavPred <= 0 ? stavPred : Math.max(0, stavPred - approvedPropadle);
  })();
  // "Celkem odchozeno" VČETNĚ propadlých = čisté odchozené + propadlé, které stav reálně odečetl.
  // Drženo konzistentně se zůstatkem: k dispozici − odchozeno (vč. propadlých) = zbývá k odchození.
  // 1. 11. 2026: Nasbíráno a štítek u Zbývá odchodit počítá server ve sdíleném výpočtu
  // (netlify/functions/_lib/treninkySouhrn.cjs, client.treninkySouhrn), stejná čísla vrací
  // externí API. Místní vzorec jen jako záloha, když souhrn v datech chybí (stará keš).
  const souhrnTreninku = client.treninkySouhrn || null;
  const dostupneCelkem = souhrnTreninku && typeof souhrnTreninku.nasbirano === "number"
    ? souhrnTreninku.nasbirano
    : (Number(client.treninkyZFakturace) || 0) + (Number(client.zustatekMinRoku) || 0) + (Number(client.bonusoveTreninky) || 0);
  // Tón štítku: ok = v pořádku, pozor = brzy dojde, problem = vyčerpáno, null = bez čísla.
  const zbyvaTonKarta = isNaN(stavTreninkuNum) ? null
    : ({ "v pořádku": "ok", "brzy dojde": "pozor", "vyčerpáno": "problem" })[souhrnTreninku && souhrnTreninku.zbyva_stav]
      || (stavTreninkuNum >= 3 ? "ok" : stavTreninkuNum >= 1 ? "pozor" : "problem");
  const propadleVcelku = Math.max(0, (dostupneCelkem - odchozenoTotal) - stavTreninkuNum);
  const odchozenoCelkem = odchozenoTotal + propadleVcelku;
  // Rozpad propadlých (těch, co reálně snížily stav) na dvě příčiny — součet = propadleVcelku:
  //  - z nesplněného minima = měsíční automatizace (log_expired),
  //  - z pozdního zrušení = zbytek (trenér označil PROPADL v rozvrhu).
  const propadleMinimum = Math.min(propadleAutoTotal, propadleVcelku);
  const propadleLate = Math.max(0, propadleVcelku - propadleMinimum);
  const hasMonthly = client.treninkyPoMesicich && client.treninkyPoMesicich.some((v) => v > 0);
  // Lead = zaznam jen v Leady (Notion mirror), neni klient. Skryje sekce co nedavaji smysl
  // pro pre-deal stav (Spoluprace, Finance, Treninky po mesicich, Budouci/Historie treninku).
  // Vstupni dotaznik a Treninkovy profil zustavaji (sales tam pise call notes, trener pri zk. treninku).
  const isLead = client.isLead === true;
  // SMS upomínky na dlaždici Poslední faktura jen tehdy, když patří k té faktuře
  // (8. 10. 2026). Upomínky ke starší faktuře jsou vidět v Historii plateb.
  const upominkyKPosledni = !!client.lastReminderSmsAt
    && (!client.fapiLastInvoiceNumber || String(client.lastReminderSmsFaktura || "") === String(client.fapiLastInvoiceNumber));
  // Výživový klient (13.7.2026): typ spolupráce Výživový koučink — bez tréninků
  // a trenéra; v detailu se skrývají tréninkové KPI dlaždice.
  const jeVyzivovyKlient = /v[yý][žz]iv/i.test(String(client.typSpoluprace || ""));

  // Klasifikované sekce z Přehled klientů sheetu (může být null pokud není match).
  const p = client.prehled || {};

  return (
    <div className={`fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm overflow-y-auto ${blurred ? "demo-blur" : ""}`}
         onClick={onClose}>
      {/* Mobile: fullscreen (p-0, bez zaobleni, bez my) — vic mista, nic se nehybe.
          Desktop (sm+): puvodni centrovany dialog. */}
      <div className="min-h-full flex items-start justify-center p-0 sm:p-6">
        <div
          className="bg-slate-50 rounded-none sm:rounded-2xl shadow-2xl w-full max-w-5xl my-0 sm:my-4 min-h-screen sm:min-h-0 overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Dark gradient header — barva odráží stav klienta:
              BLACKLIST=Ano → červený gradient + velký BLACKLIST tag (priority warning).
              Stav=Ukončeno → slate (šedý, neutrální/dead).
              Stav=Přerušeno → amber (varovný oranžový).
              Default (Aktivní/Trial/atd.) → indigo (klasický). */}
          {(() => {
            const isBlacklistHeader = String(effectiveBlacklist || "").trim().toLowerCase() === "ano";
            const stavLow = String(client.stav || "").trim().toLowerCase();
            const isUkonceno = stavLow === "ukončeno" || stavLow === "ukonceno";
            const isPreruseno = stavLow === "přerušeno" || stavLow === "preruseno";
            // Pro lead headerClass dle Stage (Lead/Kvalifikace=blue/sky, Trial=amber, NQLead/Prohra=slate/rose)
            const stageLow = String(effectiveStage || "").toLowerCase();
            let leadHeaderClass = null;
            if (isLead) {
              if (stageLow.includes("kvalifikace")) leadHeaderClass = "bg-gradient-to-r from-sky-700 via-sky-600 to-cyan-500";
              else if (stageLow === "lead") leadHeaderClass = "bg-gradient-to-r from-blue-700 via-blue-600 to-blue-500";
              else if (stageLow.includes("trial")) leadHeaderClass = "bg-gradient-to-r from-amber-700 via-amber-600 to-orange-500";
              else if (stageLow === "nqlead") leadHeaderClass = "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-500";
              else if (stageLow === "prohra") leadHeaderClass = "bg-gradient-to-r from-rose-800 via-rose-700 to-rose-600";
              else leadHeaderClass = "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-500";
            }
            const headerClass = isBlacklistHeader
              ? "bg-gradient-to-r from-rose-900 via-rose-800 to-rose-700"
              : leadHeaderClass
                ? leadHeaderClass
                : isUkonceno
                  ? "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-500"
                  : isPreruseno
                    ? "bg-gradient-to-r from-amber-700 via-amber-600 to-orange-600"
                    : "bg-gradient-to-r from-brand-950 via-brand-900 to-brand-700";

            // 2. 10. 2026 (mockup „Karta klientky a dlaždice“, varianta A): nová hlavička
            // klientky. Leady mají dál původní hlavičku níže.
            const roleH = String(currentUser?.role || "").toLowerCase();
            const akceHlavicky = isLead ? [] : [
              ...(["owner", "manager", "csm"].includes(roleH)
                ? [{ klic: "sales", popis: "Poslat sales k volání", ikona: PhoneForwarded, onClick: () => setPoslatSalesOpen(true) }] : []),
              ...(["owner", "manager", "csm"].includes(roleH) && String(client.telefon || "").replace(/\D/g, "").length >= 9
                ? [{ klic: "nahled", popis: "Otevřít aplikaci jako klientka", ikona: ExternalLink, onClick: otevritNahled }] : []),
              ...(!isManagerView && smiPrejmenovatKlientku(roleH, client, effectiveStage)
                ? [{ klic: "prejmenovat", popis: "Přejmenovat", ikona: Pencil, onClick: () => setRenameDialogOpen(true) }] : []),
              ...(roleH === "owner" ? [
                { klic: "archiv", popis: client.archivovan ? "Obnovit z archivu" : "Archivovat", ikona: Archive, onClick: () => setSpravaConfirm(client.archivovan ? "obnovit" : "archivovat") },
                { klic: "smazat", popis: "Smazat", ikona: Trash2, nebezpecna: true, onClick: () => setSpravaConfirm("smazat") },
              ] : []),
            ];
            const typH = String(effectiveTypSpoluprace || "").trim();
            const maVyzivu = String(client.narokNaVyzSl || "").trim().toLowerCase() === "ano";
            const dniPo = Number(client.fapiLastInvoiceDaysOverdue) || 0;
            // 2. 10. 2026 (varianta D2): mřížka údajů, co je potřeba řešit, se obarví v buňce.
            const udajeH = [
              !isTrenerView && { popisek: "Trenér", hodnota: effectiveTrener },
              !isTrenerView && { popisek: "Lokalita", hodnota: effectiveLokalita },
              { popisek: "Balíček", hodnota: effectiveBalicek ? [balicekKratce(effectiveBalicek), typH.toLowerCase()].filter(Boolean).join(", ") : typH },
              maVyzivu && (client.poslNutricniKonzultace
                ? { popisek: "Výživa", hodnota: `konzultace ${formatDate(client.poslNutricniKonzultace)}` }
                : { popisek: "Výživa", hodnota: "bez konzultace", ton: isUkonceno ? null : "pozor" }),
              { popisek: "Spolupráce", hodnota: effectiveZacatek ? (effectiveKonec ? `${formatDate(effectiveZacatek)} až ${formatDate(effectiveKonec)}` : `od ${formatDate(effectiveZacatek)}`) : "" },
              client.lastPortalLoginAt
                ? { popisek: "Aplikace", hodnota: formatDate(client.lastPortalLoginAt), title: `Naposledy přihlášená ${formatDateTime(client.lastPortalLoginAt)} (SMS ověření)` }
                : { popisek: "Aplikace", hodnota: "nikdy", ton: isUkonceno ? null : "problem", title: "Klientka se zatím nikdy nepřihlásila do aplikace přes SMS ověření. Admin impersonace se nepočítá." },
            ].filter(Boolean);
            // Permanentky v aplikaci Měření ani výživu nemají, kartu souhlasu tam nevidí,
            // proto u nich štítek nesvítí (Láďa 19.10.2026).
            const chybiSouhlas = !isLead && zdravSouhlas === false && client.stav !== "Ukončeno"
              && !/perm/i.test(String(effectiveBalicek || client.balicek || ""));
            const odznakSouhlas = (
              <span key="souhlas" className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-100 px-2.5 py-1 text-[13px] font-bold text-amber-800"
                title="Klientka zatím nedala souhlas se zpracováním zdravotních údajů. V aplikaci se jí ukáže, až otevře Jídelníček nebo Měření.">
                <AlertTriangle className="h-3.5 w-3.5" /> Chybí souhlas
              </span>
            );
            const stitkyH = client.fapiLastInvoiceStatus === "overdue" ? [
              <span key="fpo" className="inline-flex items-center gap-1.5 rounded-full border border-rose-300 bg-rose-600 px-3 py-1 text-sm font-bold text-white">
                <AlertTriangle className="h-4 w-4" />{dniPo ? `Faktura po splatnosti ${dniPo} ${dniPo === 1 ? "den" : dniPo < 5 ? "dny" : "dní"}` : "Faktura po splatnosti"}
              </span>,
            ] : [];
            const odznakyH = [
              chybiSouhlas && odznakSouhlas,
              salesHovor && (
                <span key="hovor" className="inline-flex items-center gap-1 rounded-full border border-white/40 bg-white px-2.5 py-1 text-[13px] font-bold text-brand-deep" title="Sales má s klientkou naplánovaný hovor, další nenastavuj">
                  <PhoneForwarded className="h-3.5 w-3.5" /> {salesHovorText}
                </span>
              ),
              client.naDovolene && (
                <span key="dov" className="inline-flex items-center gap-1 rounded-full border border-sky-300/50 bg-sky-500/30 px-2.5 py-1 text-[13px] font-bold text-white" title="Klientka má právě teď zadané volno typu dovolená">
                  <Plane className="h-3.5 w-3.5" /> Na dovolené
                </span>
              ),
              client.hasDuplicateName && (
                <span key="dup" className="inline-flex items-center gap-1 rounded-full border border-amber-400/50 bg-amber-500/30 px-2.5 py-1 text-[13px] font-bold text-amber-50"
                  title="Existují dvě a více klientek se stejným jménem, rezervace se mohou přiřadit nesprávně.">
                  <AlertTriangle className="h-3.5 w-3.5" /> Duplicitní jméno
                </span>
              ),
            ].filter(Boolean);
            const blacklistH = isBlacklistHeader ? (
              <span className="inline-flex items-center gap-1.5 rounded-xl border-2 border-rose-300 bg-rose-100 px-3 py-1 text-sm font-bold text-rose-800">
                <AlertTriangle className="h-4 w-4" /> Blacklist, nikdy nekontaktovat
              </span>
            ) : null;
            // Telefon má dál původní hlavičku (Láďa 2. 10. 2026), nová je jen na počítači.
            const novaHlavicka = !isLead && !uzka && (
              <HlavickaKlientky headerClass={headerClass} jmeno={client.klient} klientId={client.notion_id || notionIdFromUrlCd(client.notion)}
                stav={<StavBadge stav={client.stav} />} stitky={[...stitkyH, ...odznakyH]} udaje={udajeH}
                blacklist={blacklistH} akce={akceHlavicky} onClose={onClose} />
            );

            // 5.9.2026 (fáze 4b): na telefonu zabírala hlavička skoro půl
            // obrazovky (dvě řady štítků s popisky a textová tlačítka).
            // Schválený návrh: šipka zpět, ikonové akce, fotka vedle jména,
            // klíčové údaje jako dlaždice a kontakt jako tlačítka.
            // Barva hlavičky dál drží stav, `headerClass` se nemění.
            if (uzka) {
              const roleNiz = String(currentUser?.role || "").toLowerCase();
              const smiPrejmenovat = !isLead && !isManagerView && smiPrejmenovatKlientku(roleNiz, client, effectiveStage);
              const tel = String(client.telefon || "").replace(/\s+/g, "");
              const dlazdice = isLead
                ? [
                    ["Sales / kouč", client.trener || "—"],
                    ["Stage", effectiveStage || "—"],
                    ["Kontaktování", formatDate(client.datumKontaktovani) || "—"],
                    ["Zdroj", client.zdrojKontaktu || "—"],
                  ]
                : [
                    ["Trenér", client.trener || "—"],
                    ["Lokalita", client.lokalita || "—"],
                    ["Zbývá tréninků", client.stavTreninku ?? "—"],
                    ["Spolupráce od", formatDate(effectiveZacatek) || "—"],
                  ];
              return (
                <>
                  <div className={`${headerClass} px-3 pb-3 pt-3 text-white`}>
                    <div className="flex items-center gap-2">
                      <button onClick={onClose} aria-label="Zpět na seznam" className="btn-ikona btn-ikona-tmava !h-11 !w-11">
                        <ArrowLeft className="h-6 w-6" />
                      </button>
                      <span className="min-w-0 flex-1" />
                      {/* 30. 9. 2026: poslat klientku sales k volání (owner, manažer, CSM). */}
                      {!isLead && ["owner", "manager", "csm"].includes(roleNiz) && (
                        <button onClick={() => setPoslatSalesOpen(true)} aria-label="Poslat sales k volání" title="Poslat sales k volání" className="btn-ikona btn-ikona-tmava !h-11 !w-11">
                          <PhoneForwarded className="h-[22px] w-[22px]" />
                        </button>
                      )}
                      {!isLead && ["owner", "manager", "csm"].includes(roleNiz) && tel.length >= 9 && (
                        <button onClick={otevritNahled} aria-label="Otevřít aplikaci jako klientka" title="Otevřít aplikaci jako klientka" className="btn-ikona btn-ikona-tmava !h-11 !w-11">
                          <ExternalLink className="h-[22px] w-[22px]" />
                        </button>
                      )}
                      {smiPrejmenovat && (
                        <button onClick={() => setRenameDialogOpen(true)} aria-label="Přejmenovat" title="Přejmenovat klienta" className="btn-ikona btn-ikona-tmava !h-11 !w-11">
                          <Pencil className="h-[22px] w-[22px]" />
                        </button>
                      )}
                      {!isLead && roleNiz === "owner" && (
                        <button onClick={() => setSpravaConfirm(client.archivovan ? "obnovit" : "archivovat")} aria-label={client.archivovan ? "Obnovit z archivu" : "Archivovat"} title={client.archivovan ? "Obnovit klienta z archivu" : "Archivovat klienta"} className="btn-ikona btn-ikona-tmava !h-11 !w-11">
                          <Archive className="h-[22px] w-[22px]" />
                        </button>
                      )}
                      {!isLead && roleNiz === "owner" && (
                        <button onClick={() => setSpravaConfirm("smazat")} aria-label="Smazat klienta" title="Smazat klienta" className="btn-ikona btn-ikona-tmava !h-11 !w-11">
                          <Trash2 className="h-[22px] w-[22px]" />
                        </button>
                      )}
                      {isLead && roleNiz === "owner" && (
                        <button onClick={() => setLeadDeleteConfirm(true)} aria-label="Smazat lead" title="Smazat lead" className="btn-ikona btn-ikona-tmava !h-11 !w-11">
                          <Trash2 className="h-[22px] w-[22px]" />
                        </button>
                      )}
                    </div>
                    <div className="mt-3 flex items-center gap-3">
                      <div className="shrink-0">
                        <ClientPhotoAvatar klientId={client.notion_id} klientNotion={client.notion} klientName={client.klient} />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="font-serif text-xl font-bold leading-tight demo-sensitive">{client.klient}</div>
                        <div className="mt-1 flex flex-wrap items-center gap-1.5">
                          {!isLead && <StavBadge stav={client.stav} />}
                          {chybiSouhlas && odznakSouhlas}
                          {!isLead && client.fapiLastInvoiceStatus && (
                            <InvoiceStatusBadge status={client.fapiLastInvoiceStatus} daysOverdue={client.fapiLastInvoiceDaysOverdue} variant="dark" />
                          )}
                          {!isLead && !client.fapiLastInvoiceStatus && client.lastCashPaymentDate && (
                            <InvoiceStatusBadge status="paid" daysOverdue={null} variant="dark" />
                          )}
                          {isLead && effectiveStage && (
                            <span className="rounded-full bg-white/15 px-2 py-0.5 text-[11px] font-bold text-white">{effectiveStage}</span>
                          )}
                          {!isLead && salesHovor && (
                            <span className="inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[11px] font-bold text-brand-deep" title="Sales má s klientkou naplánovaný hovor, další nenastavuj">
                              <PhoneForwarded className="h-3 w-3" /> {salesHovorText}
                            </span>
                          )}
                          {client.naDovolene && (
                            <span className="inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-[11px] font-bold text-white" title="Klient má právě teď zadané volno typu dovolená">
                              <Plane className="h-3 w-3" /> Na dovolené
                            </span>
                          )}
                          {client.hasDuplicateName && (
                            <span className="inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-[11px] font-bold text-white" title="Existuje 2 a více klientů se stejným jménem, rezervace se mohou přiřadit nesprávně.">
                              <AlertTriangle className="h-3 w-3" /> Duplicitní jméno
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    {isBlacklistHeader && (
                      <div className="mt-3 flex items-center gap-2 rounded-xl bg-white px-3 py-2 text-sm font-bold text-rose-700">
                        <AlertTriangle className="h-4 w-4 shrink-0" /> Blacklist, nikdy nekontaktovat
                      </div>
                    )}
                  </div>

                  <div className="space-y-2 p-3">
                    {/* 9.9.2026 (T1) — dvě nejčastější akce hned pod hlavičkou, ať je
                        trenér vidí na první pohled a nemusí je hledat v sekcích. */}
                    {!isLead && !isManagerView && (
                      <div className="grid grid-cols-2 gap-2">
                        <button type="button" onClick={() => setVolnoOpenTrigger((k) => k + 1)}
                          className="flex min-h-[52px] items-center justify-center gap-2 rounded-2xl bg-brand-deep text-sm font-bold text-white">
                          <CalendarPlus className="h-5 w-5" /> Přidat volno
                        </button>
                        <button type="button" onClick={() => setHodnoceniOpenTrigger((k) => k + 1)}
                          className="flex min-h-[52px] items-center justify-center gap-2 rounded-2xl border-2 border-brand-300 bg-white text-sm font-bold text-brand-deep">
                          <Star className="h-5 w-5" /> Hodnocení
                        </button>
                      </div>
                    )}
                    <div className="glass grid grid-cols-2 gap-px overflow-hidden bg-slate-200 !p-0">
                      {dlazdice.map(([popisek, hodnota]) => (
                        <div key={popisek} className="flex min-h-[62px] flex-col justify-center bg-white px-3 py-2">
                          <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{popisek}</span>
                          <span className="truncate text-sm font-bold text-slate-800 demo-sensitive">{hodnota}</span>
                        </div>
                      ))}
                    </div>
                    {(tel || client.email || (client.notion && !isNutriView)) && (
                      <div className={`grid gap-2 ${client.notion && !isNutriView ? "grid-cols-3" : "grid-cols-2"}`}>
                        {tel && (
                          <a href={`tel:${tel}`} className="flex min-h-[48px] flex-col items-center justify-center gap-0.5 rounded-xl border border-slate-200 bg-white text-brand-deep">
                            <Phone className="h-4 w-4" /><span className="text-[11px] font-semibold">Zavolat</span>
                          </a>
                        )}
                        {client.email && (
                          <a href={`mailto:${client.email}`} className="flex min-h-[48px] flex-col items-center justify-center gap-0.5 rounded-xl border border-slate-200 bg-white text-brand-deep">
                            <Mail className="h-4 w-4" /><span className="text-[11px] font-semibold">E-mail</span>
                          </a>
                        )}
                        {/* Nutriční Notion nepotřebuje (1. 10. 2026). */}
                        {client.notion && !isNutriView && !client.zalozenoVAdminu && (
                          <a href={client.notion} target="_blank" rel="noopener noreferrer" className="flex min-h-[48px] flex-col items-center justify-center gap-0.5 rounded-xl border border-slate-200 bg-white text-brand-deep">
                            <ExternalLink className="h-4 w-4" /><span className="text-[11px] font-semibold">Notion</span>
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                </>
              );
            }

            if (novaHlavicka) return novaHlavicka;
            return (
          <div className={`${headerClass} text-white p-5 sm:p-6 relative`}>
            {/* Owner: archivace + smazání — PRAVÝ DOLNÍ ROH hlavičky (absolutní
                pozice, nic to nezalamuje). Na mobilu skryto (překrývalo by pilly)
                — tam zůstávají potvrzovací akce dostupné přes širší displej. */}
            {!isLead && ["owner", "manager", "csm"].includes(currentUser?.role) && (
              <div className="hidden sm:flex absolute bottom-4 right-5 sm:right-6 gap-1.5 z-10">
                {/* 30. 9. 2026: poslat klientku sales k volání (owner, manažer, CSM). */}
                <button
                  onClick={() => setPoslatSalesOpen(true)}
                  title="Poslat klientku sales k volání, v zadaný den se jí objeví v Plánu"
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-white hover:bg-brand-50 text-xs font-bold text-brand-deep transition-colors whitespace-nowrap"
                >
                  <PhoneForwarded className="w-3.5 h-3.5" /> Poslat sales k volání
                </button>
                {currentUser?.role === "owner" && (<>
                <button
                  onClick={() => setSpravaConfirm(client.archivovan ? "obnovit" : "archivovat")}
                  title={client.archivovan ? "Obnovit klienta z archivu, znovu se objeví v seznamech" : "Archivovat klienta, zmizí ze všech seznamů, v databázi zůstane (najdete ho ve filtru Archiv)"}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-white/10 hover:bg-white/25 border border-white/25 text-xs font-semibold text-white/90 transition-colors whitespace-nowrap"
                >
                  {client.archivovan ? "Obnovit" : "Archivovat"}
                </button>
                <button
                  onClick={() => setSpravaConfirm("smazat")}
                  title="Smazat klienta z databáze, včetně výživy a masterplánu"
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-rose-500/25 hover:bg-rose-500/45 border border-rose-300/40 text-xs font-semibold text-rose-50 transition-colors whitespace-nowrap"
                >
                  <Trash2 className="w-3.5 h-3.5" /> Smazat
                </button>
                </>)}
              </div>
            )}
            <div className={`flex items-start justify-between gap-3 ${!isLead && ["owner", "manager", "csm"].includes(currentUser?.role) ? "sm:pb-12" : ""}`}>
              <div className="flex-1 min-w-0">
                <div className="mb-2 flex items-center gap-2 flex-wrap">
                  <span className="text-xs uppercase tracking-wide opacity-60 font-medium">{isLead ? "Detail leada" : "Detail klienta"}</span>
                  {/* BLACKLIST velký red badge — viditelný hned u nadpisu, sales/CSM nemůže přehlédnout. */}
                  {isBlacklistHeader && (
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-xl bg-rose-100 text-rose-800 text-sm font-bold border-2 border-rose-300 shadow-sm">
                      <AlertTriangle className="w-4 h-4" /> BLACKLIST, NIKDY NEKONTAKTOVAT
                    </span>
                  )}
                  {/* Trenér + Lokalita chips skryty v trener módu — trenér už ví že je to jeho klient na jeho lokalitě. */}
                  {!isTrenerView && client.trener && (
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-white/15 border border-white/20 text-sm font-medium text-white">
                      <UserIcon className="w-3 h-3 opacity-70" />
                      <span className="opacity-70">{isLead ? "Sales/Kouč" : "Trenér"}</span>
                      <span className="font-semibold">{client.trener}</span>
                    </span>
                  )}
                  {!isTrenerView && client.lokalita && (
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-white/15 border border-white/20 text-sm font-medium text-white">
                      <MapPin className="w-3 h-3 opacity-70" />
                      <span className="opacity-70">Lokalita</span>
                      <span className="font-semibold">{client.lokalita}</span>
                    </span>
                  )}
                  {/* Stage badge v hlavicce pro leady */}
                  {isLead && effectiveStage && (
                    <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-lg bg-white/20 border border-white/30 text-xs font-bold text-white">
                      {effectiveStage}
                    </span>
                  )}
                </div>
                <div className="text-2xl sm:text-3xl font-bold flex items-center gap-3 flex-wrap">
                  <span className="demo-sensitive">{client.klient}</span>
                  {client.naDovolene && (
                    <span className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wide px-2 py-1 rounded-lg bg-sky-500 text-white" title="Klient má právě teď zadané volno typu dovolená">
                      Na dovolené
                    </span>
                  )}
                  {/* Přejmenovat klienta: pravidla v smiPrejmenovatKlientku (2. 10. 2026). */}
                  {(() => {
                    const role = String(currentUser?.role || "").toLowerCase();
                    const canRename = !isLead && !isManagerView && smiPrejmenovatKlientku(role, client, effectiveStage);
                    if (!canRename) return null;
                    return (
                      <button
                        onClick={() => setRenameDialogOpen(true)}
                        title="Přejmenovat klientku"
                        className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-white/15 hover:bg-white/25 border border-white/20 text-xs font-semibold text-white/90 hover:text-white transition-colors"
                      >
                        <Pencil className="w-3.5 h-3.5" />
                        <span className="hidden sm:inline">Přejmenovat</span>
                      </button>
                    );
                  })()}
                  {!isLead && <StavBadge stav={client.stav} />}
                  {!isLead && client.fapiLastInvoiceStatus && (
                    <InvoiceStatusBadge
                      status={client.fapiLastInvoiceStatus}
                      daysOverdue={client.fapiLastInvoiceDaysOverdue}
                      variant="dark"
                    />
                  )}
                  {/* Cash-only klient: žádná FAPI faktura, ale ma log_cash → Zaplacená badge.
                      Info ze plati hotovost je ve Finance/Zpusob platby. */}
                  {!isLead && !client.fapiLastInvoiceStatus && client.lastCashPaymentDate && (
                    <InvoiceStatusBadge
                      status="paid"
                      daysOverdue={null}
                      variant="dark"
                    />
                  )}
                  {client.hasDuplicateName && (
                    <span
                      className="inline-flex items-center gap-1.5 text-xs font-bold px-2.5 py-1 rounded-full border bg-amber-500/30 text-amber-100 border-amber-400/50 cursor-help"
                      title="Existuje 2+ klientů s identickým jménem. Reservio bookings se přiřazují přes composite identity (email + telefon). Pokud klient nemá vyplněný email/telefon, bookings se mohou přiřadit nesprávně. Doporučení: přejmenovat jednoho duplikáta (např. suffix '- VT GYM' nebo '(2)') v Notion + Reservio."
                    >
                      <AlertTriangle className="w-3.5 h-3.5" />
                      Duplicitní jméno
                    </span>
                  )}
                </div>
                {!isLead && effectiveBalicek && (
                  <div className="text-base text-white/80 mt-2 flex items-center gap-2 flex-wrap">
                    <Package className="w-4 h-4 flex-shrink-0" />
                    <span>{effectiveBalicek}</span>
                    {client.typSpoluprace && <span className="opacity-60">, {client.typSpoluprace}</span>}
                    {String(client.narokNaVyzSl || "").trim().toLowerCase() === "ano" && (
                      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-emerald-500/20 border border-emerald-300/40 text-emerald-100 text-sm font-medium">
                        <Award className="w-3 h-3" /> Výživa
                      </span>
                    )}
                  </div>
                )}
                {/* Pro klienty: Začátek/Konec/Poslední výživa. Pro leady: Datum kontaktování + Zdroj kontaktu. */}
                {!isLead ? (
                <div className="mt-3 flex items-center gap-2 flex-wrap text-sm">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-white/90">
                    <Calendar className="w-3 h-3 opacity-70" />
                    <span className="opacity-70">Začátek</span>
                    <span className="font-semibold">{formatDate(effectiveZacatek) || "—"}</span>
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-white/90">
                    <Calendar className="w-3 h-3 opacity-70" />
                    <span className="opacity-70">Konec</span>
                    <span className="font-semibold">{formatDate(effectiveKonec) || "—"}</span>
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-white/90">
                    <Calendar className="w-3 h-3 opacity-70" />
                    <span className="opacity-70">Poslední konzultace</span>
                    <span className="font-semibold">{formatDate(client.poslNutricniKonzultace) || "—"}</span>
                  </span>
                  {/* Posledni prihlaseni klienta do portalu — JEN realne SMS verify, NE admin impersonate */}
                  {client.lastPortalLoginAt ? (
                    <span
                      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-white/90"
                      title={`Klient se naposledy přihlásil do aplikace ${formatDateTime(client.lastPortalLoginAt)} (SMS ověření). Admin impersonace se nezapočítává.`}
                    >
                      <Smartphone className="w-3 h-3 opacity-70" />
                      <span className="opacity-70">V app</span>
                      <span className="font-semibold">{formatDateShort(client.lastPortalLoginAt)}</span>
                    </span>
                  ) : (
                    <span
                      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-rose-500/20 border border-rose-400/50 text-rose-100"
                      title="Klient se zatím nikdy nepřihlásil do aplikace přes SMS ověření. Pokud se ti zdá že měl, ověř že nemáš admin bypass session."
                    >
                      <Smartphone className="w-3 h-3 opacity-90" />
                      <span className="opacity-80">V app</span>
                      <span className="font-semibold">nikdy</span>
                    </span>
                  )}
                </div>
                ) : (
                <div className="mt-3 flex items-center gap-2 flex-wrap text-sm">
                  {client.datumKontaktovani && (
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-white/90">
                      <Calendar className="w-3 h-3 opacity-70" />
                      <span className="opacity-70">Kontaktování</span>
                      <span className="font-semibold">{formatDate(client.datumKontaktovani)}</span>
                    </span>
                  )}
                  {client.zdrojKontaktu && (
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-white/90">
                      <span className="opacity-70">Zdroj</span>
                      <span className="font-semibold">{client.zdrojKontaktu}</span>
                    </span>
                  )}
                  {client.kontaktovani && (
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-white/90">
                      <span className="opacity-70">Stav</span>
                      <span className="font-semibold">{client.kontaktovani}</span>
                    </span>
                  )}
                </div>
                )}
              </div>
              {/* Pravý sloupec: tlačítko + fotka vycentrovaná POD ním (10.7.). */}
              <div className="flex flex-col items-center gap-3 flex-shrink-0">
                {/* 9.9.2026 — Přidat volno se přesunulo do dvojice tlačítek pod hlavičkou
                    (spolu s Novým hodnocením), tady by bylo podruhé. */}
                {isLead && currentUser?.role === "owner" && (
                  <button
                    onClick={() => setLeadDeleteConfirm(true)}
                    title="Smazat lead (z databáze + archivovat v Notionu, ať se nevrátí syncem)"
                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-rose-500/25 hover:bg-rose-500/40 border border-rose-200/40 text-sm font-semibold text-white flex-shrink-0 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                    <span className="hidden sm:inline">Smazat lead</span>
                  </button>
                )}
                <div className="hidden sm:block">
                  <ClientPhotoAvatar klientId={client.notion_id} klientNotion={client.notion} klientName={client.klient} />
                </div>
              </div>
              {/* Křížek stejně vysoký jako tlačítko Přidat volno (44px), zarovnaný v řadě. */}
              <button
                onClick={onClose}
                className="w-11 h-11 inline-flex items-center justify-center rounded-xl bg-white/10 hover:bg-white/20 flex-shrink-0 transition-colors"
                aria-label="Zavřít"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
            );
          })()}

          {/* 18. 10. 2026 (Láďa): nepodepsaná smlouva po uzavření po telefonu, vidí trenér klientky a vedení. */}
          {!isLead && clientCid && <PodpisSmlouvyKlientky klientId={clientCid} className="mx-4 mt-4 sm:mx-6" />}

          {/* 1. 11. 2026 (zadání 5, mockup 5B): náhled rozlučkového emailu po „Ukončit a napsat email“. */}
          {!isLead && (
            <EmailNahledDialog
              open={!!rozluckaOkno}
              druh="rozlucka"
              klientId={client.notion_id || notionIdFromUrlCd(client.notion)}
              spokojena={rozluckaOkno?.spokojena !== false}
              popis={`${client.klient}, ukončení v dobrém`}
              onZavrit={() => setRozluckaOkno(null)}
              onOdeslano={() => { setRozluckaOkno(null); setKonecObnova((x) => x + 1); }}
            />
          )}

          {/* Owner: potvrzení smazání leadu */}
          <ConfirmDialog
            open={leadDeleteConfirm}
            title="Smazat lead?"
            description={`Lead „${client.klient}" se trvale smaže z databáze a archivuje se v Notionu (aby se nevrátil hodinovým syncem). Akce je nevratná.`}
            confirmLabel={leadDeleting ? "Mažu…" : "Smazat lead"}
            onConfirm={deleteLead}
            onCancel={() => setLeadDeleteConfirm(false)}
          />

          {/* Owner: archivace / obnovení / smazání klienta (13.7.) */}
          <ConfirmDialog
            open={spravaConfirm === "archivovat"}
            title="Archivovat klienta?"
            description={`„${client.klient}" zmizí ze všech seznamů a přehledů, neuvidí ho nikdo z týmu. V databázi ale dál existuje se všemi daty; najdete ho ve filtru Archiv v Klientech a můžete ho kdykoli obnovit.`}
            confirmLabel={spravaBusy ? "Archivuji…" : "Archivovat 🗂"}
            variant="warning"
            onConfirm={() => klientSprava("archivovat")}
            onCancel={() => setSpravaConfirm(null)}
          />
          <ConfirmDialog
            open={spravaConfirm === "obnovit"}
            title="Obnovit klienta z archivu?"
            description={`„${client.klient}" se znovu objeví v seznamech a přehledech pro celý tým.`}
            confirmLabel={spravaBusy ? "Obnovuji…" : "Obnovit"}
            variant="primary"
            onConfirm={() => klientSprava("obnovit")}
            onCancel={() => setSpravaConfirm(null)}
          />
          <ConfirmDialog
            open={spravaConfirm === "smazat"}
            title="Smazat klienta natrvalo?"
            description={`„${client.klient}" se nenávratně smaže z databáze, včetně výživových dat, jídelníčků a masterplánu. Docházka a finanční logy zůstanou (bez vazby na klienta). Pokud ho chcete jen schovat, použijte Archivovat.`}
            confirmLabel={spravaBusy ? "Mažu…" : "Smazat natrvalo"}
            onConfirm={() => klientSprava("smazat")}
            onCancel={() => setSpravaConfirm(null)}
          />

          {/* Toast po rename - hezký banner místo native alert. Auto-dismiss po 5s. */}
          {renameToast && (
            <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[60] max-w-md w-[calc(100vw-2rem)] animate-in slide-in-from-top-4 duration-200">
              <div className={`rounded-xl shadow-2xl border px-4 py-3 flex items-start gap-3 ${
                renameToast.variant === "success" ? "bg-emerald-50 border-emerald-200 text-emerald-900"
                : renameToast.variant === "warning" ? "bg-amber-50 border-amber-200 text-amber-900"
                : "bg-rose-50 border-rose-200 text-rose-900"
              }`}>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
                  renameToast.variant === "success" ? "bg-emerald-500 text-white"
                  : renameToast.variant === "warning" ? "bg-amber-500 text-white"
                  : "bg-rose-500 text-white"
                }`}>
                  {renameToast.variant === "success" ? <CheckCircle2 className="w-5 h-5" /> : <AlertTriangle className="w-5 h-5" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm">{renameToast.title}</div>
                  {renameToast.detail && <div className="text-xs mt-0.5 opacity-90">{renameToast.detail}</div>}
                </div>
                <button onClick={() => setRenameToast(null)} className="flex-shrink-0 -mr-1 p-1 rounded hover:bg-black/5">
                  <X className="w-4 h-4 opacity-60" />
                </button>
              </div>
            </div>
          )}

          {/* 30. 9. 2026: poslat klientku sales k volání (mockup v8, obrazovka 14). */}
          <PoslatSalesDialog klient={{ ...client, notion_id: clientCid }} hovor={salesHovor} open={poslatSalesOpen} onClose={() => setPoslatSalesOpen(false)} />
          {/* Přejmenovat klienta - krok 1: zadání nového jména */}
          <RenameClientDialog
            open={renameDialogOpen}
            oldName={client.klient}
            onConfirm={handleRenameStep1}
            onCancel={() => setRenameDialogOpen(false)}
            loading={false}
          />
          {/* Přejmenovat klienta - krok 2: potvrzení staré -> nové */}
          <ConfirmDialog
            open={renameConfirmOpen}
            title="Opravdu přejmenovat?"
            description={(
              <div className="mt-2 space-y-2">
                <div className="text-sm text-slate-600">Tato akce přepíše jméno klienta v aplikaci.</div>
                <div className="bg-slate-50 border border-slate-200 rounded-xl p-2.5 space-y-1.5">
                  <div className="flex items-center gap-2 text-sm">
                    <span className="text-[11px] uppercase tracking-wider font-bold text-slate-500 w-12">Z</span>
                    <span className="font-semibold text-slate-700 break-words">{client.klient}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <span className="text-[11px] uppercase tracking-wider font-bold text-amber-700 w-12">Na</span>
                    <span className="font-semibold text-amber-800 break-words">{renameNewName}</span>
                  </div>
                </div>
              </div>
            )}
            confirmLabel="Ano, přejmenovat"
            cancelLabel="Vrátit zpět"
            variant="warning"
            onConfirm={doRename}
            onCancel={() => { setRenameConfirmOpen(false); setRenameDialogOpen(true); }}
            loading={renameLoading}
          />

          {/* Confirm dialog před save kontaktů — warning o Reservio + FAPI */}
          <ConfirmDialog
            open={contactsConfirmOpen}
            title="Změnit kontakty?"
            description={(
              <div className="space-y-3 mt-2">
                <div className="text-sm text-slate-700">
                  <span className="font-semibold">{client.klient}</span>
                </div>
                <div className="space-y-1.5 text-sm">
                  {editEmailChanged && (
                    <div className="flex flex-wrap items-center gap-1.5">
                      <span className="text-slate-500">Email:</span>
                      <span className="line-through text-slate-400">{effectiveEmail || "—"}</span>
                      <span className="text-slate-400">→</span>
                      <span className="font-medium text-slate-900">{editEmail || "—"}</span>
                    </div>
                  )}
                  {editTelefonChanged && (
                    <div className="flex flex-wrap items-center gap-1.5">
                      <span className="text-slate-500">Telefon:</span>
                      <span className="line-through text-slate-400">{effectiveTelefon || "—"}</span>
                      <span className="text-slate-400">→</span>
                      <span className="font-medium text-slate-900">{editTelefon || "—"}</span>
                    </div>
                  )}
                </div>
                <div className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900 leading-relaxed">
                  <div className="font-semibold mb-1">Pozor: manuální kroky po uložení</div>
                  <div>
                    Stejnou změnu kontaktu <span className="font-semibold">musíš ručně provést</span> i v:
                    <ul className="list-disc list-inside mt-1 space-y-0.5">
                      <li>Reservio (rezervační systém)</li>
                      <li>FAPI (fakturační systém)</li>
                    </ul>
                  </div>
                  <div className="mt-2 text-xs text-amber-800">
                    Plus se odešle Slack zpráva do #automatizace, aby tým věděl o změně.
                  </div>
                </div>
              </div>
            )}
            confirmLabel="Uložit"
            cancelLabel="Zrušit"
            variant="warning"
            onConfirm={doSaveContacts}
            onCancel={() => setContactsConfirmOpen(false)}
            loading={savingContacts}
          />

          {/* Univerzální Confirm dialog před save SPOLUPRÁCE — diff všech změněných polí
              + dynamicky sesbírané warningy (např. FAPI při změně balíčku). Stejný layout
              pro Finance dialog níže. */}
          <ConfirmDialog
            open={spolupraceConfirmOpen}
            title="Uložit změny ve spolupráci?"
            description={(
              <div className="space-y-3 mt-2">
                <div className="text-sm text-slate-700">
                  <span className="font-semibold">{client.klient}</span>
                </div>
                <div className="space-y-1.5 text-sm">
                  {spolupraceChanged.map((f) => (
                    <div key={f} className="flex flex-wrap items-center gap-1.5">
                      <span className="text-slate-500">{FIELD_LABELS[f]}:</span>
                      <span className="line-through text-slate-400">{getEffective(f) || "—"}</span>
                      <span className="text-slate-400">→</span>
                      <span className="font-medium text-slate-900">{spolupraceForm[f] || "—"}</span>
                    </div>
                  ))}
                </div>
                {/* Modul 2E: auto-frekvence suggestion pri zmene balicku — modry info banner.
                    Nezablokuje save, jen upozorni ze user by mel jit do Finance editu. */}
                {autoFrekvenceWarning(spolupraceForm) && (
                  <div className="rounded-xl border border-blue-300 bg-blue-50 p-3 text-sm text-blue-900 leading-relaxed">
                    <div className="font-semibold mb-1.5">Doporučení: Frekvence dle balíčku</div>
                    <div>{autoFrekvenceWarning(spolupraceForm)}</div>
                  </div>
                )}
                {collectWarnings(spolupraceChanged).length > 0 && (
                  <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 leading-relaxed">
                    <div className="font-semibold mb-1.5">Pozor: manuální kroky po uložení</div>
                    <ul className="list-disc list-inside space-y-0.5">
                      {collectWarnings(spolupraceChanged).map((w, i) => (
                        <li key={i}>{w}</li>
                      ))}
                    </ul>
                    <div className="mt-2 text-xs text-amber-800">
                      Owner + CSM dostanou notifikaci do zvonečku a Slack zprávu do #automatizace, aby na úpravy nikdo nezapomněl.
                    </div>
                  </div>
                )}
              </div>
            )}
            confirmLabel={collectWarnings(spolupraceChanged).length > 0 ? "Uložit a upozornit" : "Uložit"}
            cancelLabel="Zrušit"
            variant="warning"
            onConfirm={doSaveSpoluprace}
            onCancel={() => setSpolupraceConfirmOpen(false)}
            loading={savingSpoluprace}
          />

          {/* Confirm dialog FINANCE — stejný pattern jako Spolupráce. */}
          <ConfirmDialog
            open={financeConfirmOpen}
            title="Uložit změnu fakturace?"
            description={(
              <div className="space-y-3 mt-2">
                <div className="text-sm text-slate-700">
                  <span className="font-semibold">{client.klient}</span>
                </div>
                <div className="space-y-1.5 text-sm">
                  {financeChanged.map((f) => (
                    <div key={f} className="flex flex-wrap items-center gap-1.5">
                      <span className="text-slate-500">{FIELD_LABELS[f]}:</span>
                      <span className="line-through text-slate-400">{getEffective(f) || "—"}</span>
                      <span className="text-slate-400">→</span>
                      <span className="font-medium text-slate-900">{financeForm[f] || "—"}</span>
                    </div>
                  ))}
                </div>
                {collectWarnings(financeChanged).length > 0 && (
                  <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 leading-relaxed">
                    <div className="font-semibold mb-1.5">Pozor: manuální kroky po uložení</div>
                    <ul className="list-disc list-inside space-y-0.5">
                      {collectWarnings(financeChanged).map((w, i) => (
                        <li key={i}>{w}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
            confirmLabel={collectWarnings(financeChanged).length > 0 ? "Uložit a upozornit" : "Uložit"}
            cancelLabel="Zrušit"
            variant="warning"
            onConfirm={doSaveFinance}
            onCancel={() => setFinanceConfirmOpen(false)}
            loading={savingFinance}
          />

          {/* Confirm dialog VSTUPNÍ DOTAZNÍK — Modul 2D. Žádné FAPI warningy
              (lead info, nemění fakturaci). */}
          <ConfirmDialog
            open={profilConfirmOpen}
            title="Uložit změnu vstupního dotazníku?"
            description={(
              <div className="space-y-3 mt-2">
                <div className="text-sm text-slate-700">
                  <span className="font-semibold">{client.klient}</span>
                </div>
                <div className="space-y-1.5 text-sm">
                  {profilChanged.map((f) => (
                    <div key={f} className="flex flex-wrap items-center gap-1.5">
                      <span className="text-slate-500">{FIELD_LABELS[f]}:</span>
                      <span className="line-through text-slate-400">{getEffective(f) || "—"}</span>
                      <span className="text-slate-400">→</span>
                      <span className="font-medium text-slate-900">{profilForm[f] || "—"}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            confirmLabel="Uložit"
            cancelLabel="Zrušit"
            variant="primary"
            onConfirm={doSaveProfil}
            onCancel={() => setProfilConfirmOpen(false)}
            loading={savingProfil}
          />

          {/* Body */}
          <div className="space-y-4 p-4 pb-24 sm:p-6 sm:pb-10">
            {/* 1. 10. 2026 (Láďa): nutriční vidí kontakt klientky v detailu jako dvě
                dlaždice (telefon, e-mail) s tlačítkem pro zkopírování, bez Notionu a bez úprav. V seznamu klientů kontakt není. Hned pod hlavičkou, před tlačítky a dlaždicemi, vždy otevřený. */}
            {isNutriView && !isLead && (
              <ExpandableSection icon={Phone} title="Kontakt" accent="blue" pevne>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                  <KontaktDlazdice label="Telefon" hodnota={effectiveTelefon} ikona={Phone} />
                  <KontaktDlazdice label="E-mail" hodnota={effectiveEmail} ikona={Mail} citlive mensi />
                </div>
              </ExpandableSection>
            )}
            {/* 9.9.2026 (T1) — na počítači stejná dvojice akcí hned nad obsahem. */}
            {!isLead && !isManagerView && !uzka && (
              <div className="flex flex-wrap items-center gap-2">
                <button type="button" onClick={() => setVolnoOpenTrigger((k) => k + 1)}
                  className="inline-flex min-h-[44px] items-center gap-2 rounded-xl bg-brand-deep px-4 text-sm font-bold text-white hover:bg-brand">
                  <CalendarPlus className="h-5 w-5" /> Přidat volno
                </button>
                <button type="button" onClick={() => setHodnoceniOpenTrigger((k) => k + 1)}
                  className="inline-flex min-h-[44px] items-center gap-2 rounded-xl border-2 border-brand-300 bg-white px-4 text-sm font-bold text-brand-deep hover:bg-brand-50">
                  <Star className="h-5 w-5" /> Nové hodnocení
                </button>
              </div>
            )}
            {/* Top KPI strip — skryto pro leady (zadne treninky / spoluprace data) */}
            {/* 5.9.2026 (fáze 4b): na telefonu pět velkých dlaždic zabralo skoro
                dvě obrazovky, než člověk došel k první sekci. Schválený návrh:
                jedna karta, každý údaj jeden řádek, doplňky jako štítky.
                Obsah, výpočty i nápovědy zůstávají stejné, na počítači
                zůstávají dlaždice. */}
            {!isLead && uzka && (
              <div className="glass divide-y divide-slate-100 overflow-hidden !p-0">
                <div className="flex min-h-[52px] items-center gap-2.5 px-3 py-2">
                  <Calendar className="h-4 w-4 shrink-0 text-slate-400" />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-1 text-sm font-semibold text-slate-700">
                      Spolupráce
                      <InfoTip text="Délka spolupráce. Pokud má klient vyplněné datum konce, počítáme od začátku do konce (celková délka kontraktu). Pokud konec chybí a typ je Neomezeno, počítáme od začátku do dneška. Pokud konec chybí a typ není Neomezeno, dlaždice je prázdná (chybí data)." />
                    </div>
                    {client.zacatek && (
                      <div className="mt-0.5"><Stitek ton="neutralni" velikost="mala">od {formatDateShort(client.zacatek)}</Stitek></div>
                    )}
                  </div>
                  <span className="shrink-0 text-base font-bold tabular-nums text-slate-900">{cooperationLabel || "—"}</span>
                </div>

                {!jeVyzivovyKlient && (
                  <div className="flex min-h-[52px] items-center gap-2.5 px-3 py-2">
                    <Activity className="h-4 w-4 shrink-0 text-slate-400" />
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-1 text-sm font-semibold text-slate-700">
                        Nasbíráno tréninků
                        <InfoTip text="Kolik tréninků má klient celkem k dispozici od začátku roku 2026 = zaplacené z faktur a hotovosti + bonusové + zůstatek z roku 2025. Na konci roku se nenuluje, pokračuje dál. Není to počet odchozených. Roste, jak přibývají další zaplacené a bonusové tréninky." />
                      </div>
                      <div className="mt-1 flex flex-wrap items-center gap-1">
                        <Stitek ton="ok" velikost="mala">Faktury {Number(client.treninkyZFakturace) || 0}</Stitek>
                        <Stitek ton="znacka" velikost="mala">Bonus {Number(client.bonusoveTreninky) || 0}</Stitek>
                        {(Number(client.zustatekMinRoku) || 0) > 0 && <Stitek ton="neutralni" velikost="mala">Z 2025 {Number(client.zustatekMinRoku)}</Stitek>}
                      </div>
                    </div>
                    <span className="shrink-0 text-base font-bold tabular-nums text-slate-900">{dostupneCelkem}</span>
                  </div>
                )}

                {!jeVyzivovyKlient && (
                  <div className="flex min-h-[52px] items-center gap-2.5 px-3 py-2">
                    <ClipboardList className="h-4 w-4 shrink-0 text-slate-400" />
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-1 text-sm font-semibold text-slate-700">
                        Zbývá k odchození
                        <InfoTip text={isTrenerView
                          ? "Počet tréninků, které klient ještě má k dispozici. Výpočet: k dispozici (z fakturace, bonusové, zůstatek z roku 2025) minus odchozené tréninky minus propadlé, vše od začátku roku 2026, na konci roku se nic nenuluje. Bonusové se připočítávají automaticky. Záporné číslo znamená, že si klient odchodil tréninky dopředu nad rámec období nebo přišel o trénink pozdním zrušením. Nesplněné minimum stav pod nulu nesrazí, pozdě zrušené tréninky ano. Odchozené tréninky se počítají vždy za předchozí den, ne v den tréninku (kdyby trenér něco během dne měnil)."
                          : "Kolik tréninků klientovi zbývá. Výpočet: k dispozici minus odchozené minus propadlé. 3+ v pohodě, 2 začíná docházet, 0 nebo méně vázne. Záporné číslo vzniká odtrénováním dopředu nebo pozdním zrušením. Nesplněné minimum pod nulu nesrazí, pozdě zrušené ano. Odchozené tréninky se počítají vždy za předchozí den, ne v den tréninku."} />
                      </div>
                      {!isNaN(stavTreninkuNum) && (
                        <div className="mt-0.5">
                          <Stitek ton={zbyvaTonKarta} velikost="mala">
                            {zbyvaTonKarta === "ok" ? "V pořádku" : zbyvaTonKarta === "pozor" ? "Brzy dojde" : "Vyčerpáno"}
                          </Stitek>
                        </div>
                      )}
                    </div>
                    <span className={`shrink-0 rounded-xl px-2.5 py-1 text-base font-bold tabular-nums ${
                      isNaN(stavTreninkuNum) ? "text-slate-400"
                        : zbyvaTonKarta === "ok" ? "bg-emerald-50 text-emerald-700"
                        : zbyvaTonKarta === "pozor" ? "bg-amber-50 text-amber-700"
                        : "bg-rose-50 text-rose-700"
                    }`}>
                      {isNaN(stavTreninkuNum) ? (client.stavTreninku || "—") : stavTreninkuNum}
                    </span>
                  </div>
                )}

                {!jeVyzivovyKlient && (
                  <div className="flex min-h-[52px] items-center gap-2.5 px-3 py-2">
                    <CalendarClock className="h-4 w-4 shrink-0 text-slate-400" />
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-1 text-sm font-semibold text-slate-700">
                        Poslední trénink
                        <InfoTip text="Datum posledního absolvovaného tréninku." />
                      </div>
                      {client.posledniTrenink && (
                        <div className="mt-0.5"><Stitek ton="neutralni" velikost="mala">{daysAgoLabel(client.posledniTrenink)}</Stitek></div>
                      )}
                    </div>
                    <span className={`shrink-0 text-base font-bold tabular-nums ${client.posledniTrenink ? "text-slate-900" : "text-slate-400"}`}>
                      {client.posledniTrenink ? formatDateShort(client.posledniTrenink) : "—"}
                    </span>
                  </div>
                )}

                <div className="flex min-h-[52px] items-center gap-2.5 px-3 py-2">
                  <Receipt className="h-4 w-4 shrink-0 text-slate-400" />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-1 text-sm font-semibold text-slate-700">
                      Poslední faktura
                      <InfoTip text="Stav poslední FAPI faktury (napříč účty Lada/Firma/Tinka). Preferujem neuhrazenou (overdue/vystavená) před starší zaplacenou. Zaplacená pozdě je červená. Cash klienti: poslední log_cash platba se zobrazuje jako 'Zaplacená' (datum + částka), info že platí hotovostí je ve Finance sekci níže." />
                    </div>
                    <div className="mt-1 flex flex-wrap items-center gap-1">
                      {client.fapiLastInvoiceStatus === "overdue" && (
                        <Stitek ton="problem" velikost="mala">Po splatnosti {client.fapiLastInvoiceDaysOverdue || "?"} d</Stitek>
                      )}
                      {client.fapiLastInvoiceStatus === "paid" && client.fapiLastInvoiceDaysOverdue > 0 && (
                        <Stitek ton="problem" velikost="mala">Zaplaceno pozdě ({client.fapiLastInvoiceDaysOverdue} d)</Stitek>
                      )}
                      {client.fapiLastInvoiceStatus === "paid" && !(client.fapiLastInvoiceDaysOverdue > 0) && client.fapiLastInvoicePaidDate && (
                        <Stitek ton="ok" velikost="mala">Zaplaceno {formatDateShort(client.fapiLastInvoicePaidDate)}</Stitek>
                      )}
                      {!client.fapiLastInvoiceDate && client.lastCashPaymentDate && (
                        <Stitek ton="ok" velikost="mala">Zaplaceno {formatDateShort(client.lastCashPaymentDate)}</Stitek>
                      )}
                      {client.fapiLastInvoiceStatus === "pending" && <Stitek ton="info" velikost="mala">Vystavená</Stitek>}
                      {client.fapiLastInvoiceDueDate && (
                        <Stitek ton="neutralni" velikost="mala">splatnost {formatDateShort(client.fapiLastInvoiceDueDate)}</Stitek>
                      )}
                      {upominkyKPosledni && client.fapiLastInvoiceStatus !== "paid" && (
                        <Stitek ton="pozor" velikost="mala">{client.lastReminderSmsCount || 1} SMS<Oddelovac />poslední {datumPraha(client.lastReminderSmsAt)}</Stitek>
                      )}
                    </div>
                  </div>
                  <span className={`shrink-0 text-base font-bold tabular-nums ${client.fapiLastInvoiceDate || client.lastCashPaymentDate ? "text-slate-900" : "text-slate-400"}`}>
                    {client.fapiLastInvoiceDate
                      ? formatDateShort(client.fapiLastInvoiceDate)
                      : (client.lastCashPaymentDate ? formatDateShort(client.lastCashPaymentDate) : "—")}
                  </span>
                </div>
              </div>
            )}
            {/* 2. 10. 2026 (mockup „Karta klientky a dlaždice“, varianta A): nové dlaždice na
                počítači, telefon má dál řádky výše. Výpočty, nápovědy i pravidla zůstávají stejné. */}
            {!isLead && !uzka && (() => {
              const kratce = (iso) => { const d = datumZIso(iso); return isNaN(d) ? "" : `${d.getDate()}.${d.getMonth() + 1}.`; };
              const rok = (iso) => { const d = datumZIso(iso); return isNaN(d) ? "" : String(d.getFullYear()); };
              const tvarMesicu = (n) => (n === 1 ? "měsíc" : n >= 2 && n <= 4 ? "měsíce" : "měsíců");
              const zbyvaTon = zbyvaTonKarta;
              const fDatum = client.fapiLastInvoiceDate || (!client.fapiLastInvoiceDate ? client.lastCashPaymentDate : null);
              const fStav = client.fapiLastInvoiceStatus;
              const fPozde = fStav === "paid" && client.fapiLastInvoiceDaysOverdue > 0;
              const fTon = !fStav ? (client.lastCashPaymentDate ? "ok" : "neutralni") : fStav === "overdue" || fPozde ? "problem" : fStav === "pending" ? "info" : "ok";
              const fPilulky = [
                ...(fStav === "overdue" ? [{ ton: "problem", casti: ["po splatnosti", `${client.fapiLastInvoiceDaysOverdue || "?"} d`] }] : []),
                ...(fPozde ? [{ ton: "problem", casti: ["zaplaceno pozdě", `${client.fapiLastInvoiceDaysOverdue} d`] }] : []),
                ...(fStav === "paid" && !fPozde && client.fapiLastInvoicePaidDate ? [{ ton: "ok", casti: ["zaplacena", kratce(client.fapiLastInvoicePaidDate)] }] : []),
                ...(!client.fapiLastInvoiceDate && client.lastCashPaymentDate ? [{ ton: "ok", casti: ["zaplaceno", kratce(client.lastCashPaymentDate)] }] : []),
                ...(fStav === "pending" ? [{ ton: "info", casti: ["vystavená"] }] : []),
                ...(client.fapiLastInvoiceDueDate ? [{ ton: "neutralni", casti: ["splatnost", kratce(client.fapiLastInvoiceDueDate)] }] : []),
                ...(upominkyKPosledni && fStav !== "paid" ? [{ ton: "pozor", casti: [`${client.lastReminderSmsCount || 1} SMS`, `poslední ${datumPraha(client.lastReminderSmsAt, { mezery: false })}`] }] : []),
              ];
              const spoluprace = {
                klic: "spoluprace", ikona: Calendar, ikonaTon: "info", popisek: "Spolupráce",
                napoveda: "Délka spolupráce. Pokud má klient vyplněné datum konce, počítáme od začátku do konce (celková délka kontraktu). Pokud konec chybí a typ je Neomezeno, počítáme od začátku do dneška. Pokud konec chybí a typ není Neomezeno, dlaždice je prázdná (chybí data).",
                hodnota: months === null || months === undefined ? "chybí" : months < 1 ? "pod 1" : String(months),
                jednotka: months === null || months === undefined ? null : months < 1 ? "měsíc" : tvarMesicu(months),
                pilulky: client.zacatek ? [{ ton: "neutralni", casti: ["od", formatDate(client.zacatek)] }] : [],
              };
              const nasbirano = {
                klic: "nasbirano", ikona: Activity, ikonaTon: "znacka", popisek: "Nasbíráno tréninků",
                napoveda: "Kolik tréninků má klient celkem k dispozici od začátku roku 2026 = zaplacené z faktur a hotovosti + bonusové + zůstatek z roku 2025. Na konci roku se nenuluje, pokračuje dál. Není to počet odchozených. Roste, jak přibývají další zaplacené a bonusové tréninky.",
                hodnota: String(dostupneCelkem),
                pilulky: [
                  { ton: "neutralni", casti: ["faktury", String(Number(client.treninkyZFakturace) || 0)] },
                  { ton: "znacka", casti: ["bonus", String(Number(client.bonusoveTreninky) || 0)] },
                  ...((Number(client.zustatekMinRoku) || 0) > 0 ? [{ ton: "neutralni", casti: ["z 2025", String(Number(client.zustatekMinRoku))] }] : []),
                ],
              };
              const zbyva = {
                klic: "zbyva", ikona: CheckCircle2, ikonaTon: zbyvaTon || "neutralni", popisek: "Zbývá odchodit",
                napoveda: isTrenerView
                  ? "Počet tréninků, které klient ještě má k dispozici. Výpočet: k dispozici (z fakturace, bonusové, zůstatek z roku 2025) minus odchozené tréninky minus propadlé, vše od začátku roku 2026, na konci roku se nic nenuluje. Bonusové se připočítávají automaticky. Záporné číslo znamená, že si klient odchodil tréninky dopředu nad rámec období nebo přišel o trénink pozdním zrušením. Nesplněné minimum stav pod nulu nesrazí, pozdě zrušené tréninky ano. Odchozené tréninky se počítají vždy za předchozí den, ne v den tréninku (kdyby trenér něco během dne měnil)."
                  : "Kolik tréninků klientovi zbývá. Výpočet: k dispozici minus odchozené minus propadlé. 3+ v pohodě, 2 začíná docházet, 0 nebo méně vázne. Záporné číslo vzniká odtrénováním dopředu nebo pozdním zrušením. Nesplněné minimum pod nulu nesrazí, pozdě zrušené ano. Odchozené tréninky se počítají vždy za předchozí den, ne v den tréninku.",
                hodnota: isNaN(stavTreninkuNum) ? String(client.stavTreninku || "nezjištěno") : String(stavTreninkuNum),
                hodnotaTon: zbyvaTon,
                pilulky: zbyvaTon ? [{ ton: zbyvaTon, casti: [zbyvaTon === "ok" ? "v pořádku" : zbyvaTon === "pozor" ? "brzy dojde" : "vyčerpáno"] }] : [],
              };
              const bezTreninku = !client.posledniTrenink;
              const trenink = {
                klic: "trenink", ikona: Clock, ikonaTon: bezTreninku ? (String(client.stav || "").trim() === "Aktivní" ? "problem" : "neutralni") : "znacka", popisek: "Poslední trénink",
                napoveda: "Datum posledního odchozeného tréninku podle rezervací.",
                hodnota: bezTreninku ? "zatím žádný" : kratce(client.posledniTrenink),
                jednotka: bezTreninku ? null : rok(client.posledniTrenink),
                hodnotaTon: bezTreninku && String(client.stav || "").trim() === "Aktivní" ? "problem" : null,
                pilulky: bezTreninku ? [] : [{ ton: "neutralni", casti: [String(daysAgoLabel(client.posledniTrenink) || "").toLowerCase()] }],
              };
              const faktura = {
                klic: "faktura", ikona: Receipt, ikonaTon: fTon, popisek: "Poslední faktura",
                napoveda: "Stav poslední FAPI faktury (napříč účty Lada/Firma/Tinka). Preferujem neuhrazenou (overdue/vystavená) před starší zaplacenou. Zaplacená pozdě je červená. Cash klienti: poslední log_cash platba se zobrazuje jako 'Zaplacená' (datum + částka), info že platí hotovostí je ve Finance sekci níže.",
                hodnota: fDatum ? kratce(fDatum) : "žádná",
                jednotka: fDatum ? rok(fDatum) : null,
                pilulky: fPilulky,
              };
              const dlazdice = jeVyzivovyKlient
                ? [spoluprace, faktura]
                : [spoluprace, nasbirano, zbyva, trenink, faktura];
              return <DlazdiceKlientky dlazdice={dlazdice} />;
            })()}

            {/* Nutritionist (12.7.2026): jen hlavička výše + sekce Výživa. Vše
                ostatní pod wrapperem !isNutriView níže. */}
            {isNutriView && !isLead && (client.notion_id || client.notion) && (
              <VyzivaExpandable
                klientId={client.notion_id}
                klientNotion={client.notion}
                klientName={client.klient}
                readOnly={false}
                defaultOpen={true}
                narokNaVyzSl={client.narokNaVyzSl}
                posledniVyziva={client.poslNutricniKonzultace}
              />
            )}
            {!isNutriView && (<>

            {/* Komentáře ke spolupráci — vyextrahováno jako samostatná PRVNÍ sekce (drive bylo v Spolupráce).
                Vícevláknové, pinable, archive bez delete.
                Trenér nevidí (28.5.2026 — restrictMode). */}

            {/* Trenér: Tréninkový profil úplně nahoře, default OPEN.
                Trenérská sekce co denně používají - musí být první věc co vidí. */}
            {isTrenerView && (
              <ExpandableSection
                icon={ClipboardList}
                title="Tréninkový profil"
                subtitle="Základní info, cíle, cviky, kardio, log, poznámky, info pro náhrady"
                accent="amber"
                defaultOpen
              >
                <TrainingProfileSection
                  klientName={client.klient}
                  canEdit={["owner", "manager", "head_coach", "trener", "csm"].includes(String(currentUser?.role || "").toLowerCase())}
                />
              </ExpandableSection>
            )}

            {/* Kontakt (28. 10. 2026, Láďa): úplně nahoře, před komentáři ke spolupráci. Odkazy v polích bez ikony ExternalLink. */}
            <ExpandableSection
              icon={Phone}
              title={(() => {
                const isBlacklist = String(effectiveBlacklist || "").trim().toLowerCase() === "ano";
                if (!isBlacklist) return "Kontakt";
                return (
                  <span className="inline-flex items-center gap-2 flex-wrap">
                    Kontakt
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-bold rounded-lg bg-rose-100 text-rose-700 border border-rose-300">
                      <AlertTriangle className="w-3.5 h-3.5" /> Nikdy nekontaktovat
                    </span>
                  </span>
                );
              })()}
              accent="blue"
              defaultOpen
              action={!isTrenerView && canEditContacts && client.notion && !editingContacts ? (
                <button
                  onClick={(e) => { e.stopPropagation(); startEditContacts(); }}
                  className="px-2.5 py-1 text-xs rounded-lg bg-blue-50 hover:bg-blue-100 border border-blue-200 text-blue-700 font-medium transition"
                >
                  Upravit
                </button>
              ) : null}
            >
              {/* 28.5.2026: Trenér Kontakt nesmí editovat — i kdyby se nějak dostal do editingContacts=true, render fallback na read-only grid. */}
              {editingContacts && !isTrenerView ? (
                <div className="space-y-3">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <label className="block text-sm">
                      <div className="flex items-center gap-2 text-slate-500 mb-1">
                        <Phone className="w-4 h-4" /> Telefon
                      </div>
                      <PhoneInput
                        value={editTelefon}
                        onChange={setEditTelefon}
                        disabled={savingContacts}
                      />
                      {!editPhoneValid && <span className="text-xs text-rose-600 mt-1 inline-block">Neplatný telefon, zadej 9 číslic</span>}
                    </label>
                    <label className="block text-sm">
                      <div className="flex items-center gap-2 text-slate-500 mb-1">
                        <Mail className="w-4 h-4" /> Email
                      </div>
                      <input
                        type="email"
                        value={editEmail}
                        onChange={(e) => setEditEmail(e.target.value)}
                        disabled={savingContacts}
                        placeholder="email@klient.cz"
                        className={`w-full text-base font-medium border rounded-lg px-3 py-2 focus:outline-none transition ${
                          !editEmailValid ? "border-rose-300 focus:border-rose-500 bg-rose-50" : "border-slate-300 focus:border-blue-500"
                        }`}
                      />
                      {!editEmailValid && <span className="text-xs text-rose-600 mt-1 inline-block">Neplatný email formát</span>}
                    </label>
                  </div>
                  {contactsErr && (
                    <div className="bg-rose-50 border border-rose-200 rounded-lg p-2 text-sm text-rose-700">
                      Chyba: {contactsErr}
                    </div>
                  )}
                  <div className="flex items-center gap-2 pt-1">
                    <button
                      onClick={cancelEditContacts}
                      disabled={savingContacts}
                      className="btn btn-secondary"
                    >
                      Zrušit
                    </button>
                    <button
                      onClick={askSaveContacts}
                      disabled={!editCanSave}
                      className="btn btn-primary"
                    >
                      {savingContacts ? "Ukládám…" : "Uložit"}
                    </button>
                    {editHasChanges && (
                      <span className="text-xs text-amber-600 ml-2">Máš neuložené změny</span>
                    )}
                  </div>
                </div>
              ) : (
                <FieldGrid items={[
                  { label: "Telefon", value: effectiveTelefon, icon: Phone, link: phoneLink, copy: effectiveTelefon },
                  { label: "Email", value: effectiveEmail, icon: Mail, link: emailLink, demoSensitive: true, copy: effectiveEmail },
                  // Notion link skryt pro trenéra (28.5.2026 — restrictMode).
                  !isTrenerView && { label: "Notion", value: client.notion ? "Otevřít v Notion" : null, icon: ExternalLink, link: client.notion },
                ].filter(Boolean)} />
              )}
            </ExpandableSection>

            {!isTrenerView && (
            <ExpandableSection
              icon={MessageSquare}
              title="Komentáře ke spolupráci"
              accent="indigo"
              defaultOpen
            >
              <ClientCommentsPanel client={client} canEdit={canEditNote} />
            </ExpandableSection>
            )}

            {/* Email komunikace — Gmail API multi-account (info/klienti/mereni).
                Trenér nevidí (28.5.2026 — restrictMode). */}
            {!isTrenerView && (
            <ExpandableSection
              icon={Inbox}
              title="Email komunikace"
              accent="indigo"
              defaultOpen={false}
            >
              <ClientEmailsSection client={client} />
            </ExpandableSection>
            )}

            {/* Spolupráce — Modul 2B: edit režim s rolovacími selecty pro Balíček, Trenér,
                Lokalita, Typ spolupráce + date pickery pro Začátek, Konec. Změna balíčku
                vyvolá v ConfirmDialogu varování o úpravě fakturace v FAPI.
                Pod sekcí editovatelné poznámky ke spolupráci (volný text).
                NEZOBRAZUJE se pro leady — ti nemaji uzavrenou spolupraci.
                Trenér nevidí (28.5.2026 — restrictMode). */}
            {!isLead && !isTrenerView && (
            <ExpandableSection
              icon={Building2}
              title="Spolupráce"
              accent="indigo"
              defaultOpen={false}
              action={canEditContacts && client.notion && !editingSpoluprace ? (
                <div className="flex items-center gap-1.5" onClick={(e) => e.stopPropagation()}>
                  {/* BLACKLIST tlačítko — jen owner/manager a jen pokud klient JEŠTĚ není BLACKLIST.
                      Zapíše Notion "Stav spolupráce" = BLACKLIST (přes klient-edit). 24.6.2026. */}
                  {String(effectiveBlacklist || "").trim().toLowerCase() !== "ano"
                    && ["owner", "manager"].includes(currentUser?.role) && (
                    <button
                      type="button"
                      onClick={doBlacklist}
                      disabled={blacklisting}
                      title="Dát klienta na BLACKLIST (zapíše se i do Notionu: Stav spolupráce = BLACKLIST)"
                      className="inline-flex items-center gap-1 px-2 py-1 text-xs rounded-lg bg-rose-50 hover:bg-rose-100 border border-rose-200 text-rose-700 font-medium transition disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px] sm:min-h-0"
                    >
                      <AlertTriangle className="w-3 h-3" /> {blacklisting ? "Nastavuji…" : "BLACKLIST"}
                    </button>
                  )}
                  <ConfirmDialog
                    open={confirmBlacklist}
                    title="Dát klienta na BLACKLIST?"
                    description={<>Klient <strong>{client.klient}</strong> se označí jako BLACKLIST.{notionVypnuto ? " Nikdo ho už nebude kontaktovat." : " V Notionu se Stav spolupráce změní na BLACKLIST."}</>}
                    confirmLabel="Dát na BLACKLIST"
                    variant="danger"
                    onConfirm={doBlacklistConfirmed}
                    onCancel={() => setConfirmBlacklist(false)}
                  />
                  <button
                    onClick={() => startEditSpoluprace()}
                    disabled={false}
                    title="Upravit smluvní údaje"
                    className="px-2.5 py-1 text-xs rounded-lg bg-plum-50 hover:bg-plum-100 border border-plum-200 text-plum-700 font-medium transition disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Upravit
                  </button>
                </div>
              ) : null}
            >
              {!editingSpoluprace ? (
                (() => {
                  const hasKonec = !!effectiveKonec;
                  const isOpenEnded = (effectiveTypSpoluprace || "").toLowerCase().includes("neomezen");
                  const isEnded = client.stav === "Ukončeno";
                  const konecAlert = !hasKonec && !isOpenEnded && !isEnded
                    ? "Chybí konec, doplnit"
                    : null;
                  // BLACKLIST="Ano" = červený alert. Stage / Stav / BLACKLIST jsou read-only z Notion mirror
                  // (Leady sync), do migrace na Postgres se needitují, mají LockBadge.
                  const isBlacklist = String(effectiveBlacklist || "").trim().toLowerCase() === "ano";
                  const stageEmpty = !String(effectiveStage || "").trim();
                  const stavEmpty = !String(effectiveStav || "").trim();
                  // Pořadí 6.5.2026 final:
                  // 1. Stage, 2. Stav spolupráce, 3. Balíček (s Výživa tagem inline pokud Ano),
                  // 4. Typ spolupráce, 5. Lokalita, 6. Trenér, 7. Začátek, 8. Konec,
                  // 9. Poslední nutriční konzultace.
                  // BLACKLIST se zobrazuje JEN pokud Ano (jinak skrytý), Nárok na výž. sl. je tag
                  // v Balíček value místo samostatného pole (šetří místo, hned vidíš jestli má).
                  const hasNutrice = String(client.narokNaVyzSl || "").trim().toLowerCase() === "ano";
                  const balicekDisplay = (
                    <span className="inline-flex items-center gap-2 flex-wrap">
                      {/* 5.9.2026: krátký název balíčku, celý zůstává v datech i v bublině. */}
                      <span title={effectiveBalicek || ""}>{balicekKratce(effectiveBalicek) || "—"}</span>
                      {hasNutrice && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-200">
                          <Award className="w-3 h-3" /> Výživa
                        </span>
                      )}
                    </span>
                  );
                  return (
                    <FieldGrid items={[
                      { label: notionVypnuto ? "Stage" : <>Stage <LockBadge /></>,
                        value: effectiveStage ? <StageBadge stage={effectiveStage} /> : "",
                        icon: UserIcon, forceShow: true,
                        alert: stageEmpty ? (notionVypnuto ? "Chybí, doplň v úpravě" : "Chybí ve Notion (Leady sync)") : null },
                      { label: notionVypnuto ? "Stav spolupráce" : <>Stav spolupráce <LockBadge /></>, value: effectiveStav, icon: Building2, forceShow: true,
                        alert: stavEmpty ? (notionVypnuto ? "Chybí, doplň v úpravě" : "Chybí ve Notion (Leady sync)") : null },
                      { label: "Balíček", value: effectiveBalicek ? balicekDisplay : "", icon: Package, forceShow: true },
                      { label: typZBalicku(effectiveBalicek) ? "Typ" : "Smlouva", value: typZBalicku(effectiveBalicek) || smlouvaText(effectiveTypSpoluprace), icon: UserIcon, forceShow: true },
                      { label: "Lokalita", value: effectiveLokalita, icon: MapPin, forceShow: true },
                      { label: "Trenér", value: effectiveTrener, icon: UserIcon, forceShow: true },
                      { label: "Začátek", value: formatDate(effectiveZacatek), icon: Calendar, forceShow: true },
                      // 20.7.2026 (feedback #36): neomezena spoluprace bez konce se zobrazi
                      // jako "Neomezená" misto prazdneho pole, konec se doplni az pri ukonceni.
                      { label: "Konec", value: effectiveKonec ? formatDate(effectiveKonec) : (isOpenEnded ? "Neomezená" : ""), icon: Calendar, forceShow: true, alert: konecAlert },
                      { label: "Poslední nutriční konzultace", value: formatDate(client.poslNutricniKonzultace), icon: Calendar, forceShow: true },
                      // BLACKLIST jen pokud Ano (visual-warning use case). Jinak má profil být čistý.
                      ...(isBlacklist ? [{
                        label: <>BLACKLIST <LockBadge /></>,
                        value: "Ano",
                        icon: AlertTriangle,
                        forceShow: true,
                        alert: "Nikdy nekontaktovat",
                      }] : []),
                    ]} />
                  );
                })()
              ) : (
                /* EDIT MODE — všechna pole najednou, rolovací selecty (žádné text inputy) */
                <div className="space-y-4 p-4 bg-plum-50/50 border border-plum-200 rounded-xl">
                  {notionVypnuto && (
                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                      <div className="sm:col-span-2">
                        <div className="mb-1.5 flex items-center gap-2 text-sm font-medium text-slate-600"><Building2 className="h-4 w-4" /> Stav spolupráce</div>
                        <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Stav spolupráce">
                          {STAVY_KLIENTKY.map((st) => {
                            const zap = spolupraceForm.stavSpoluprace === st.key;
                            return (
                              <button key={st.key} type="button" role="radio" aria-checked={zap} disabled={savingSpoluprace}
                                onClick={() => { if (!zap) { setUkonceniInfo({ ...PRAZDNE_UKONCENI, ...VYCHOZI_KONEC }); setRozluckaPoUlozeni(null); setStavKPotvrzeni(st); } }}
                                className={`flex min-h-[48px] items-center justify-center gap-2 rounded-xl border px-2 text-[14px] font-bold transition disabled:opacity-50 ${zap ? st.zap : "border-slate-200 bg-white text-slate-700 hover:border-plum-300"}`}>
                                <span aria-hidden className={`h-2.5 w-2.5 shrink-0 rounded-full ${st.tecka}`} />{st.key}
                              </button>
                            );
                          })}
                        </div>
                        {spolupraceForm.stavSpoluprace && !STAVY_KLIENTKY.some((x) => x.key === spolupraceForm.stavSpoluprace) && (
                          <div className="mt-1.5 text-xs text-slate-500">Teď: {spolupraceForm.stavSpoluprace}. Vyber jeden ze tří stavů.</div>
                        )}
                        {/* 2. 10. 2026 (Láďa, varianta A): stage se nevybírá, nastaví ji klient-edit ze stavu. */}
                        <div className="mt-1.5 text-[13px] text-slate-500">Stage se nastaví sama: Aktivní a Přerušeno = Deal.</div>
                      </div>
                    </div>
                  )}
                  <ConfirmDialog
                    open={!!stavKPotvrzeni && stavKPotvrzeni.key !== "Ukončeno"}
                    title={stavKPotvrzeni ? `Změnit stav na ${stavKPotvrzeni.key}?` : ""}
                    description={stavKPotvrzeni ? <><strong>{client.klient}</strong>: {stavKPotvrzeni.potvrzeni} Změna se uloží až tlačítkem Uložit.</> : ""}
                    confirmLabel={stavKPotvrzeni ? `Změnit na ${stavKPotvrzeni.key}` : "Změnit"}
                    variant="primary"
                    onConfirm={() => {
                      setSpolupraceForm({ ...spolupraceForm, stavSpoluprace: stavKPotvrzeni.key });
                      setStavKPotvrzeni(null);
                    }}
                    onCancel={() => setStavKPotvrzeni(null)}
                  />
                  {/* 1. 11. 2026 (zadání 5, mockup 5A): ukončení s volbou v dobrém / ne v dobrém. */}
                  <UkonceniDialog
                    open={stavKPotvrzeni?.key === "Ukončeno"}
                    klientJmeno={client.klient}
                    popis={stavKPotvrzeni?.potvrzeni || ""}
                    value={ukonceniInfo}
                    onChange={setUkonceniInfo}
                    klientId={client.notion_id || notionIdFromUrlCd(client.notion)}
                    onZrusit={() => setStavKPotvrzeni(null)}
                    onPotvrdit={(sEmailem) => {
                      const ch = chybaKonce(ukonceniInfo) || chybaUkonceni(ukonceniInfo);
                      if (ch) { toast(ch, "warning"); return; }
                      // FW-145/155: při ukončení se Konec vyplní dnešním dnem (den změny na Ukončeno).
                      const dnes = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Prague" });
                      setSpolupraceForm({ ...spolupraceForm, stavSpoluprace: "Ukončeno", konec: dnes });
                      setRozluckaPoUlozeni(sEmailem && ukonceniInfo.typ === "v_dobrem" ? { spokojena: ukonceniInfo.spokojena !== false } : null);
                      if (sEmailem) toast("Po uložení se otevře náhled rozlučkového emailu.", "info");
                      setStavKPotvrzeni(null);
                    }}
                  />
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {/* Balíček — select */}
                    <SelectField
                      label="Balíček"
                      icon={Package}
                      value={spolupraceForm.balicek}
                      onChange={(v) => {
                        // FW-154: typ podle balíčku (permanentka, výživa), u koučinku zpět na Úvodní.
                        const odv = typZBalicku(v);
                        const typ = odv || (typZBalicku(spolupraceForm.balicek) || /^(permice|v[yý][žz]ivov)/i.test(String(spolupraceForm.typSpoluprace || "")) ? "Úvodní" : spolupraceForm.typSpoluprace);
                        setSpolupraceForm({ ...spolupraceForm, balicek: v, typSpoluprace: typ });
                      }}
                      options={addCurrentToOptions(fieldOptions?.balicek, effectiveBalicek)}
                      disabled={savingSpoluprace}
                      placeholder="Vyber balíček"
                    />
                    {/* Trenér — select */}
                    <SelectField
                      label="Trenér"
                      icon={UserIcon}
                      value={spolupraceForm.trener}
                      onChange={(v) => setSpolupraceForm({ ...spolupraceForm, trener: v })}
                      options={addCurrentToOptions(aktivniTreneri || fieldOptions?.trener, effectiveTrener)}
                      disabled={savingSpoluprace}
                      placeholder="Vyber trenéra"
                    />
                    {/* Lokalita — select */}
                    <SelectField
                      label="Lokalita"
                      icon={MapPin}
                      value={spolupraceForm.lokalita}
                      onChange={(v) => setSpolupraceForm({ ...spolupraceForm, lokalita: v })}
                      options={addCurrentToOptions(fieldOptions?.lokalita, effectiveLokalita)}
                      disabled={savingSpoluprace}
                      placeholder="Vyber lokalitu"
                    />
                    {/* FW-154 (schváleno 15. 10. 2026): místo Typu spolupráce volba Smlouva.
                        U permanentky a výživy se typ odvodí z balíčku a jen se ukáže. */}
                    {typZBalicku(spolupraceForm.balicek) ? (
                      <div className="block text-sm">
                        <div className="flex items-center gap-2 text-slate-600 mb-1.5 font-medium"><UserIcon className="w-4 h-4" /> Typ</div>
                        <div className="flex min-h-[44px] items-center gap-2 rounded-xl border border-slate-200 bg-white px-3">
                          <Stitek ton="znacka">{typZBalicku(spolupraceForm.balicek)}</Stitek>
                          <span className="text-[13px] text-slate-500">podle balíčku</span>
                        </div>
                      </div>
                    ) : (
                      <div className="block text-sm">
                        <div className="flex items-center gap-2 text-slate-600 mb-1.5 font-medium"><UserIcon className="w-4 h-4" /> Smlouva</div>
                        <Segment
                          aria-label="Smlouva"
                          className="w-full"
                          value={/neomezen/i.test(spolupraceForm.typSpoluprace || "") ? "Neomezená" : /^[uú]vodn/i.test(spolupraceForm.typSpoluprace || "") ? "Úvodní" : ""}
                          onChange={(v) => setSpolupraceForm({ ...spolupraceForm, typSpoluprace: v, ...(v === "Neomezená" ? { konec: "" } : {}) })}
                          items={[{ key: "Úvodní", label: "Úvodní období" }, { key: "Neomezená", label: "Na neurčito" }]}
                        />
                      </div>
                    )}
                    {/* Začátek — date picker */}
                    <label className="block text-sm">
                      <div className="flex items-center gap-2 text-slate-600 mb-1.5 font-medium">
                        <Calendar className="w-4 h-4" /> Začátek spolupráce
                      </div>
                      <input
                        type="date"
                        value={spolupraceForm.zacatek || ""}
                        onChange={(e) => setSpolupraceForm({ ...spolupraceForm, zacatek: e.target.value })}
                        disabled={savingSpoluprace}
                        className="field w-full"
                      />
                    </label>
                    {/* Konec — date picker */}
                    <label className="block text-sm">
                      <div className="flex items-center gap-2 text-slate-600 mb-1.5 font-medium">
                        <Calendar className="w-4 h-4" /> Konec spolupráce
                      </div>
                      <input
                        type="date"
                        value={spolupraceForm.konec || ""}
                        onChange={(e) => setSpolupraceForm({ ...spolupraceForm, konec: e.target.value })}
                        disabled={savingSpoluprace}
                        className="field w-full"
                      />
                      {/* 20.7.2026 (feedback #36): rychla volba neomezene spoluprace. Konec neni
                          vyzadovan, doplni se az kdyz klientka bude chtit koncit. Nastavi Typ
                          spoluprace na moznost odpovidajici "Neomezen..." z ciselniku a vymaze
                          konec, cimz zmizi i alert "Chybí konec, doplnit" (vazany na isOpenEnded). */}
                      {/neomezen/i.test(spolupraceForm.typSpoluprace || "") && (
                        <div className="mt-1.5 text-xs text-slate-500">Smlouva na neurčito, konec doplňte až při ukončení.</div>
                      )}
                      {notionVypnuto && spolupraceForm.stavSpoluprace === "Přerušeno" && (
                        <div className="mt-1.5 rounded-xl bg-amber-50 px-3 py-2 text-[13px] text-amber-800">Když do tohoto dne nepřijde na trénink, stav se sám změní na Ukončeno.</div>
                      )}
                    </label>
                    {/* Stage / Stav spolupráce / BLACKLIST se needitují v aplikaci.
                        Read-only z Notion (přes Leady sync), edit povolíme po cutoveru na Postgres.
                        Info banner v edit formu pod fieldy. */}
                    {!notionVypnuto && <div className="sm:col-span-2 flex items-start gap-2 p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs text-slate-600">
                      <Lock className="w-4 h-4 mt-0.5 flex-shrink-0 text-slate-400" />
                      <div>
                        <strong className="text-slate-700">Stage, Stav spolupráce a BLACKLIST</strong> se editují v Notion. Aplikace je čte z Leady sync (každou hodinu). Po migraci na Postgres půjdou editovat tady.
                      </div>
                    </div>}
                  </div>
                  {spolupraceErr && (
                    <div className="bg-rose-50 border border-rose-200 rounded-lg p-2 text-sm text-rose-700">
                      Chyba: {spolupraceErr}
                    </div>
                  )}
                  <div className="flex items-center gap-2 pt-1">
                    <button
                      onClick={cancelEditSpoluprace}
                      disabled={savingSpoluprace}
                      className="btn btn-secondary"
                    >
                      Zrušit
                    </button>
                    <button
                      onClick={askSaveSpoluprace}
                      disabled={!spolupraceCanSave}
                      className="btn btn-primary"
                    >
                      {savingSpoluprace ? "Ukládám…" : `Uložit (${spolupraceChanged.length})`}
                    </button>
                    {spolupraceChanged.length > 0 && (
                      <span className="text-xs text-amber-600 ml-2">
                        {spolupraceChanged.length === 1 ? "1 změna" : `${spolupraceChanged.length} změn`}
                      </span>
                    )}
                  </div>
                </div>
              )}
              {/* Tréninkové upomínky (7.8.2026) — přepínač automatických úkolů trenérovi.
                  Vypnutí se týká JEN upomínkových úkolů (neaktivita + plánování tréninků),
                  ne fakturace, permanentek ani propadlých tréninků. Zobrazuje se i bez
                  práva editace (aby bylo vidět, že je vypnuto), tlačítko jen pro
                  owner/manager/csm (canEditContacts). */}
              {!editingSpoluprace && (
                <div className={`mt-3 p-3 rounded-xl border ${upominkyVypnute ? "bg-amber-50 border-amber-200" : "bg-slate-50 border-slate-200"}`}>
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <div className="min-w-0">
                      <div className="flex items-center gap-2 text-sm font-medium text-slate-700">
                        <CalendarClock className="w-4 h-4 text-slate-400" />
                        Tréninkové upomínky
                      </div>
                      <div className="mt-1 text-xs text-slate-600">
                        Automatické úkoly trenérovi kvůli neaktivitě klienta („nebyl na tréninku už X dní")
                        a položky klienta v úkolech na plánování týdne a měsíce.
                        Fakturace, permanentky ani propadlé tréninky se tím nemění.
                      </div>
                      {upominkyVypnute && (
                        <div className="mt-2">
                          <span className="inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-lg bg-amber-100 text-amber-800 border border-amber-300">
                            <Pause className="w-3 h-3" />
                            Vypnuto
                            {upominkyKdo ? (<><Oddelovac />{upominkyKdo}</>) : null}
                            {upominkyKdy ? (<><Oddelovac />{upominkyKdy}</>) : null}
                          </span>
                        </div>
                      )}
                    </div>
                    {canEditContacts && (
                      <button
                        type="button"
                        onClick={() => prepnoutUpominky(!upominkyVypnute)}
                        disabled={upominkyBusy}
                        title={upominkyVypnute
                          ? "Znovu zapnout automatické úkoly trenérovi (neaktivita + plánování tréninků)"
                          : "Vypnout automatické úkoly trenérovi kvůli neaktivitě klienta a plánování jeho tréninků"}
                        className={`shrink-0 px-2.5 py-1 text-xs rounded-lg border font-medium transition disabled:opacity-50 disabled:cursor-not-allowed ${
                          upominkyVypnute
                            ? "bg-white hover:bg-emerald-50 border-emerald-200 text-emerald-700"
                            : "bg-white hover:bg-amber-50 border-amber-200 text-amber-700"
                        }`}
                      >
                        {upominkyBusy ? "Ukládám…" : (upominkyVypnute ? "Zapnout upomínky" : "Vypnout upomínky")}
                      </button>
                    )}
                  </div>
                </div>
              )}
              {/* Návrh na propadnutí tréninků kvůli faktuře po splatnosti — jen owner a CSM. */}
              {canPlanBalicek && (
                <PropadnutiFakturySection klientName={client.klient} canManage={canPlanBalicek} />
              )}
              {/* Naplánovat změnu balíčku k datu — jen owner a CSM. Automatické přepnutí cronem + notifikace na fakturaci. */}
              {canPlanBalicek && (client.notion_id || client.notion) && (
                <PlanovanaZmenaBalickuSection
                  klientId={client.notion_id || notionIdFromUrlCd(client.notion)}
                  notionPageId={client.notion_id || notionIdFromUrlCd(client.notion)}
                  klientName={client.klient}
                  readOnly={isManagerView || !canEditContacts}
                />
              )}
              {/* FW-145/155: plánované ukončení k datu a doběh 90 dní po ukončení. */}
              {canPlanBalicek && (client.notion_id || client.notion) && (
                <PlanovaneUkonceniSection
                  klientId={client.notion_id || notionIdFromUrlCd(client.notion)}
                  notionPageId={client.notion_id || notionIdFromUrlCd(client.notion)}
                  klientName={client.klient}
                  stav={effectiveStav}
                  konec={effectiveKonec}
                  stavTreninku={client.stavTreninku}
                  readOnly={isManagerView || !canEditContacts}
                />
              )}
              {/* 1. 11. 2026 (zadání 5): jak spolupráce skončila, rozlučkový email jde poslat i později. */}
              {canEditContacts && (client.notion_id || client.notion) && effectiveStav === "Ukončeno" && (
                <KonecSpolupraceSection
                  klientId={client.notion_id || notionIdFromUrlCd(client.notion)}
                  klientName={client.klient}
                  stav={effectiveStav}
                  obnova={konecObnova}
                />
              )}
              {/* Komentáře ke spolupráci — vyextrahované jako samostatná sekce nahoře (viz výše). */}
            </ExpandableSection>
            )}

            {/* Finance — Modul 2B: edit Způsobu platby (rolovací select). Částka/Frekvence
                z FAPI = read-only (přijde editace v 2C). Při změně Způsobu platby varování o FAPI.
                NEZOBRAZUJE se pro leady.
                Trenér nevidí (28.5.2026 — restrictMode). */}
            {!isLead && !isTrenerView && (
            <ExpandableSection
              icon={Receipt}
              title="Finance"
              accent="green"
              defaultOpen={false}
              action={canEditContacts && client.notion && !editingFinance ? (
                <button
                  onClick={(e) => { e.stopPropagation(); startEditFinance(); }}
                  disabled={false}
                  title="Upravit způsob platby"
                  className="px-2.5 py-1 text-xs rounded-lg bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 text-emerald-700 font-medium transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Upravit
                </button>
              ) : null}
            >
              {!editingFinance ? (
                <FieldGrid items={[
                  {
                    label: "Částka / měsíc",
                    // Priorita: auto vypocet z FAPI (castkaMesicSpoctena) > rucni hodnota castkaMesic.
                    // FAPI je single source of truth pro castku — pocita se z posledni faktury / frekvence.
                    // castkaMesic je fallback pro klienty kde FAPI nesedi (jednorazova faktura, neperiodicka).
                    value: client.castkaMesicSpoctena
                      ? `${fmt(client.castkaMesicSpoctena)} Kč`
                      : (client.castkaMesic ? `${fmt(client.castkaMesic)} Kč` : null),
                    icon: DollarSign,
                    demoSensitive: true,
                  },
                  { label: "Frekvence fakturace", value: effectiveFrekvence, icon: Calendar },
                  { label: "Způsob platby", value: effectiveZpusobPlatby, icon: Receipt },
                  { label: "Kdo fakturuje", value: effectiveKdoFakturuje, icon: UserIcon },
                  {
                    label: "Poslední faktura vystavena:",
                    // Pro cash klienta (FAPI null + lastCash) → použij datum cash platby jako "vystavena"
                    value: client.fapiLastInvoiceDate
                      ? formatDate(client.fapiLastInvoiceDate)
                      : (client.lastCashPaymentDate ? formatDate(client.lastCashPaymentDate) : null),
                    icon: Calendar,
                    forceShow: true,
                  },
                  {
                    label: "Splatnost",
                    value: formatDate(client.fapiLastInvoiceDueDate),
                    icon: Calendar,
                    forceShow: !!client.fapiLastInvoiceDate,
                  },
                  {
                    label: (client.fapiLastInvoiceStatus === "paid" || client.lastCashPaymentDate) ? "Zaplaceno dne" : "Datum úhrady",
                    // FAPI paid_date primary, jinak lastCashPaymentDate, jinak "Nezaplaceno" pro pending/overdue FAPI
                    value: client.fapiLastInvoicePaidDate
                      ? formatDate(client.fapiLastInvoicePaidDate)
                      : (client.lastCashPaymentDate
                        ? formatDate(client.lastCashPaymentDate)
                        : (client.fapiLastInvoiceStatus === "paid" ? "—" : "Nezaplaceno")),
                    icon: CheckCircle2,
                    forceShow: !!client.fapiLastInvoiceDate || !!client.lastCashPaymentDate,
                  },
                ]} />
              ) : (
                /* EDIT MODE — 3 select fieldy. Částka/měsíc a Poslední faktura jsou
                   read-only (FAPI feed, viz info box pod formem). */
                <div className="space-y-4 p-4 bg-emerald-50/50 border border-emerald-200 rounded-xl">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <SelectField
                      label="Způsob platby"
                      icon={Receipt}
                      value={financeForm.zpusobPlatby}
                      onChange={(v) => setFinanceForm({ ...financeForm, zpusobPlatby: v })}
                      options={addCurrentToOptions(fieldOptions?.zpusobPlatby, effectiveZpusobPlatby)}
                      disabled={savingFinance}
                      placeholder="Vyber způsob platby"
                    />
                    <SelectField
                      label="Frekvence fakturace"
                      icon={Calendar}
                      value={financeForm.frekvence}
                      onChange={(v) => setFinanceForm({ ...financeForm, frekvence: v })}
                      options={addCurrentToOptions(fieldOptions?.frekvenceFakturace, effectiveFrekvence)}
                      disabled={savingFinance}
                      placeholder="Vyber frekvenci"
                    />
                    <SelectField
                      label="Kdo fakturuje"
                      icon={UserIcon}
                      value={financeForm.kdoFakturuje}
                      onChange={(v) => setFinanceForm({ ...financeForm, kdoFakturuje: v })}
                      options={addCurrentToOptions(fieldOptions?.kdoFakturuje, effectiveKdoFakturuje)}
                      disabled={savingFinance}
                      placeholder="Vyber kdo fakturuje"
                    />
                    {/* Modul 2C: Částka/měs — auto vyplneno z FAPI (castkaMesicSpoctena) pokud
                        nemame rucni hodnotu castkaMesic, jinak ze Sheet Stav 2026. User muze prepsat. */}
                    <label className="block text-sm">
                      <div className="flex items-center gap-2 text-slate-600 mb-1.5 font-medium">
                        <DollarSign className="w-4 h-4" /> Částka / měsíc (Kč)
                      </div>
                      <input
                        type="number"
                        min="0"
                        step="100"
                        value={financeForm.castka ?? client.castkaMesic ?? client.castkaMesicSpoctena ?? ""}
                        onChange={(e) => setFinanceForm({ ...financeForm, castka: e.target.value })}
                        disabled={savingFinance}
                        placeholder={client.castkaMesicSpoctena ? `Auto: ${fmt(client.castkaMesicSpoctena)} Kč (FAPI)` : "Např. 5000"}
                        className="field w-full"
                      />
                      {client.castkaMesicSpoctena && (
                        <div className="mt-1 text-[11px] text-slate-500">
                          Auto z FAPI: <strong>{fmt(client.castkaMesicSpoctena)} Kč</strong>
                          {client.fapiLastInvoiceTotal && ` (poslední faktura ${fmt(client.fapiLastInvoiceTotal)} Kč ÷ ${effectiveFrekvence?.toLowerCase() || "frekvence"})`}
                        </div>
                      )}
                    </label>
                  </div>
                  <div className="text-xs text-slate-500 bg-white border border-slate-200 rounded-lg p-2">
                    <span className="font-medium">Poslední faktura</span> se načítá automaticky z FAPI. <span className="font-medium">Částka/měs</span> má prioritu před FAPI feed (uprav v Notion = single source of truth).
                  </div>
                  {financeErr && (
                    <div className="bg-rose-50 border border-rose-200 rounded-lg p-2 text-sm text-rose-700">
                      Chyba: {financeErr}
                    </div>
                  )}
                  <div className="flex items-center gap-2 pt-1">
                    <button
                      onClick={cancelEditFinance}
                      disabled={savingFinance}
                      className="btn btn-secondary"
                    >
                      Zrušit
                    </button>
                    <button
                      onClick={askSaveFinance}
                      disabled={!financeCanSave}
                      className="btn btn-primary"
                    >
                      {savingFinance ? "Ukládám…" : `Uložit (${financeChanged.length})`}
                    </button>
                    {financeChanged.length > 0 && (
                      <span className="text-xs text-amber-600 ml-2">
                        {financeChanged.length === 1 ? "1 změna" : `${financeChanged.length} změn`}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </ExpandableSection>
            )}

            {/* 17. 10. 2026: Plán fakturace, řízení pravidelné faktury z adminu. Vidí a řídí jen owner a CSM. */}
            {!isLead && !isTrenerView && canPlanBalicek && (client.notion_id || client.notion) && (
            <ExpandableSection icon={CalendarClock} title="Plán fakturace" accent="green" defaultOpen={otevritFakturaci}>
              <PlanFakturaceSection klientId={client.notion_id || notionIdFromUrlCd(client.notion)} canManage={canPlanBalicek} />
            </ExpandableSection>
            )}

            {/* Historie plateb — FAPI faktury + log_cash. Skryto pro leady.
                Trenér nevidí (28.5.2026 — restrictMode). */}
            {!isLead && !isTrenerView && (
            <ExpandableSection
              icon={Receipt}
              title="Historie plateb"
              subtitle={
                invoicesLoading ? "Načítám…" :
                invoicesError ? `Chyba: ${invoicesError}` :
                invoices ? `${invoices.stats.faktury}× faktura, ${invoices.stats.hotovost}× hotovost` : null
              }
              accent="emerald"
              count={invoices ? invoices.stats.total : undefined}
              defaultOpen={false}
            >
              {invoicesLoading && (
                <div className="flex items-center gap-2 text-sm text-slate-500 py-2">
                  <RefreshCw className="w-4 h-4 animate-spin" /> Načítám historii plateb…
                </div>
              )}
              {!invoicesLoading && invoices && invoices.items.length === 0 && (
                <div className="text-sm text-slate-400 italic py-2">Žádné faktury ani cash platby.</div>
              )}
              {/* Telefon (5. 9. 2026): tabulka o osmi sloupcích se nevešla, posouvala se do strany
                  a částka končila mimo obraz. Řádek na platbu: ikona typu vlevo, číslo s částkou
                  nahoře, datum se stavem dole. Položky se po rozkliknutí skládají pod řádek. */}
              {!invoicesLoading && invoices && invoices.items.length > 0 && uzka && (
                <div className="-mx-4 divide-y divide-slate-100 sm:-mx-5">
                  {invoices.items.map((inv) => {
                    const isExpanded = expandedInvoiceIds.has(inv.id);
                    const maUpominky = (inv.upominky || []).length > 0;
                    const hasItems = (inv.items && inv.items.length > 0) || maUpominky;
                    const jeFaktura = inv.type === "faktura";
                    const poSplatnosti = inv.status === "overdue";
                    const pozdeZaplaceno = inv.status === "paid" && inv.daysOverdue > 0;
                    let stavPopisek, stavCls, datumPopisek;
                    if (inv.status === "paid") {
                      const kdy = kratkeDatum(inv.datum_uhrady);
                      stavPopisek = pozdeZaplaceno
                        ? (kdy ? `Zaplaceno pozdě ${kdy}` : "Zaplaceno pozdě")
                        : (kdy ? `Zaplaceno ${kdy}` : "Zaplaceno");
                      stavCls = pozdeZaplaceno ? "bg-rose-100 text-rose-700" : "bg-emerald-50 text-emerald-700";
                      datumPopisek = jeFaktura
                        ? `Vystaveno ${kratkeDatum(inv.datum_vystaveni) || "—"}`
                        : `Přijato ${kratkeDatum(inv.datum_uhrady || inv.datum_vystaveni) || "—"}`;
                    } else if (poSplatnosti) {
                      stavPopisek = inv.daysOverdue ? `${inv.daysOverdue} dní po splatnosti` : "Po splatnosti";
                      stavCls = "bg-rose-100 text-rose-700";
                      datumPopisek = `Splatnost ${kratkeDatum(inv.datum_splatnosti) || "—"}`;
                    } else {
                      stavPopisek = "Vystaveno";
                      stavCls = "bg-blue-50 text-blue-700";
                      datumPopisek = `Splatnost ${kratkeDatum(inv.datum_splatnosti) || "—"}`;
                    }
                    return (
                      <div key={inv.id} className={poSplatnosti ? "bg-rose-50/40" : ""}>
                        <div
                          onClick={() => {
                            if (!hasItems) return;
                            setExpandedInvoiceIds((prev) => {
                              const next = new Set(prev);
                              if (next.has(inv.id)) next.delete(inv.id); else next.add(inv.id);
                              return next;
                            });
                          }}
                          className="flex items-start gap-3 px-3 py-2.5"
                        >
                          <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border ${jeFaktura ? "border-blue-200 bg-blue-50 text-blue-700" : "border-emerald-200 bg-emerald-50 text-emerald-700"}`}>
                            {jeFaktura ? <Receipt className="w-5 h-5" /> : <Wallet className="w-5 h-5" />}
                          </span>
                          <span className="min-w-0 flex-1">
                            <span className="flex items-baseline justify-between gap-2">
                              <span className="min-w-0 truncate text-sm font-bold tabular-nums text-slate-900">{inv.cislo || (jeFaktura ? "—" : "Hotovost")}</span>
                              <span className="shrink-0 text-sm font-bold tabular-nums text-slate-900 demo-sensitive">{fmt(Math.round(inv.castka))} Kč</span>
                            </span>
                            <span className="mt-0.5 flex items-center justify-between gap-2">
                              <span className="min-w-0 truncate text-[11px] text-slate-500">{datumPopisek}</span>
                              <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold ${stavCls}`}>{stavPopisek}</span>
                            </span>
                            {maUpominky && <span className="mt-1.5 flex justify-end"><PocetUpominek upominky={inv.upominky} /></span>}
                          </span>
                        </div>
                        {isExpanded && hasItems && (
                          <div className="border-t border-slate-200 bg-slate-50/60 px-3 py-2">
                            {inv.items && inv.items.length > 0 && (<>
                            <div className="mb-1 text-[11px] font-semibold text-slate-500">Položky</div>
                            <ul className="space-y-1">
                              {inv.items.map((it, i) => (
                                <li key={i} className="flex justify-between gap-2 text-[13px] text-slate-700">
                                  <span className="min-w-0 truncate">{it.name || "—"}{it.quantity ? ` (${it.quantity}${it.unit ? " " + it.unit : ""})` : ""}</span>
                                  <span className="shrink-0 tabular-nums text-slate-500 demo-sensitive">{it.total ? `${fmt(Math.round(it.total))} Kč` : ""}</span>
                                </li>
                              ))}
                            </ul>
                            {inv.source && <div className="mt-1.5 text-[11px] italic text-slate-400">Zdroj: {inv.source}</div>}
                            </>)}
                            {maUpominky && (
                              <div className={inv.items && inv.items.length > 0 ? "mt-3" : ""}>
                                <div className="mb-1 text-[11px] font-semibold text-slate-500">Upomínky</div>
                                <UpominkyFaktury inv={inv} maly />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
              {!invoicesLoading && invoices && invoices.items.length > 0 && !uzka && (
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-xs uppercase tracking-wide text-slate-500 border-b border-slate-200">
                        <th className="text-left py-2 pr-2 font-semibold">Typ</th>
                        <th className="text-left py-2 pr-2 font-semibold">Číslo</th>
                        <th className="text-left py-2 pr-2 font-semibold">Vystaveno</th>
                        <th className="text-left py-2 pr-2 font-semibold">Splatnost</th>
                        <th className="text-left py-2 pr-2 font-semibold">Úhrada</th>
                        <th className="text-right py-2 pr-2 font-semibold">Částka</th>
                        <th className="text-left py-2 pr-2 font-semibold">Stav</th>
                        <th className="w-8"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoices.items.map((inv) => {
                        const isExpanded = expandedInvoiceIds.has(inv.id);
                        const maUpominky = (inv.upominky || []).length > 0;
                        const maPolozky = inv.items && inv.items.length > 0;
                        const hasItems = maPolozky || maUpominky;
                        return (
                          <React.Fragment key={inv.id}>
                            <tr className={`border-b border-slate-100 ${hasItems ? "cursor-pointer hover:bg-slate-50" : ""}`}
                                onClick={() => {
                                  if (!hasItems) return;
                                  setExpandedInvoiceIds((prev) => {
                                    const next = new Set(prev);
                                    if (next.has(inv.id)) next.delete(inv.id); else next.add(inv.id);
                                    return next;
                                  });
                                }}>
                              <td className="py-2 pr-2">
                                {inv.type === "faktura" ? (
                                  <span className="inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-lg border bg-blue-50 text-blue-700 border-blue-200">Faktura</span>
                                ) : (
                                  <span className="inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-lg border bg-emerald-50 text-emerald-700 border-emerald-200">Hotovost</span>
                                )}
                              </td>
                              <td className="py-2 pr-2 text-slate-700 tabular-nums">{inv.cislo || "—"}</td>
                              <td className="py-2 pr-2 text-slate-700">{formatDate(inv.datum_vystaveni) || "—"}</td>
                              <td className="py-2 pr-2 text-slate-700">{formatDate(inv.datum_splatnosti) || "—"}</td>
                              <td className="py-2 pr-2 text-slate-700">{formatDate(inv.datum_uhrady) || (inv.status === "paid" ? "—" : <span className="text-rose-600">Nezaplaceno</span>)}</td>
                              <td className="py-2 pr-2 text-right font-semibold text-slate-900 tabular-nums demo-sensitive">{fmt(Math.round(inv.castka))} Kč</td>
                              <td className="py-2 pr-2">
                                <span className="flex flex-wrap items-center gap-1.5">
                                  <InvoiceStatusBadge status={inv.status} daysOverdue={inv.daysOverdue} variant="light" />
                                  <PocetUpominek upominky={inv.upominky} />
                                </span>
                              </td>
                              <td className="py-2 pr-2 text-slate-400">
                                {hasItems && <ChevronDown className={`w-4 h-4 transition-transform ${isExpanded ? "" : "-rotate-90"}`} />}
                              </td>
                            </tr>
                            {isExpanded && hasItems && (
                              <tr className="border-b border-slate-100 bg-slate-50/60">
                                <td colSpan={8} className="py-2 px-2">
                                  <div className={maUpominky && maPolozky ? "grid gap-4 sm:grid-cols-2" : ""}>
                                    {maPolozky && (
                                      <div className="min-w-0">
                                        <div className="text-xs text-slate-500 mb-1.5 font-medium">Položky:</div>
                                        <ul className="space-y-1 text-sm text-slate-700">
                                          {inv.items.map((it, i) => (
                                            <li key={i} className="flex justify-between gap-2">
                                              <span>{it.name || "—"}{it.quantity ? ` (${it.quantity}${it.unit ? " " + it.unit : ""})` : ""}</span>
                                              <span className="tabular-nums text-slate-500 demo-sensitive">{it.total ? `${fmt(Math.round(it.total))} Kč` : ""}</span>
                                            </li>
                                          ))}
                                        </ul>
                                        {inv.source && <div className="text-[11px] text-slate-400 mt-1.5 italic">Zdroj: {inv.source}</div>}
                                      </div>
                                    )}
                                    {maUpominky && (
                                      <div className="min-w-0">
                                        <div className="text-xs text-slate-500 mb-1.5 font-medium">Upomínky:</div>
                                        <UpominkyFaktury inv={inv} />
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </ExpandableSection>
            )}



            {/* Tréninky — měsíční přehled (skryto pro leady) */}
            {!isLead && hasMonthly && (
              <ExpandableSection
                icon={Activity}
                title="Tréninky po měsících"
                subtitle={`${heatRok}, ${MONTH_FULL[new Date().getMonth()]} je aktuální měsíc`}
                accent="green"
                defaultOpen
              >
                {/* Výběr roku (8.9.2026) — stejný prvek jako výběr portfolia v PM: pilulka
                    s popiskem a vedle ní hodnota. Ukáže se až když má klient víc než jeden
                    rok s rezervacemi, jinak by to bylo klepání navíc. */}
                {heatRoky.length > 1 && (
                  <label className="mb-3 flex min-h-[56px] w-full min-w-0 items-center gap-2.5 rounded-2xl border border-slate-300 bg-white px-3.5 sm:max-w-[260px]">
                    <span className="flex h-[38px] shrink-0 items-center rounded-full bg-brand-light px-3.5 text-[12.5px] font-bold text-brand-deep">Rok</span>
                    <select
                      value={heatRok}
                      onChange={(e) => setHeatRok(parseInt(e.target.value, 10))}
                      aria-label="Rok tréninků"
                      className="min-w-0 flex-1 cursor-pointer appearance-none self-stretch bg-transparent text-base font-bold text-slate-900 focus:outline-none"
                    >
                      {heatRoky.map((r) => <option key={r} value={r}>{r}</option>)}
                    </select>
                    <ChevronDown className="w-5 h-5 shrink-0 text-slate-400" />
                  </label>
                )}
                <MonthlyHeatmap months={heatMesice} propadle={propadleByMonth} late={lateByMonthHeat} rok={heatRok} />
                <div className="mt-4">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    {/* Celkem (k dispozici) — rozbalí z fakturace / bonusové / zůstatek z roku 2025 */}
                    <div>
                      <button
                        type="button"
                        onClick={() => setCelkemOpen((o) => !o)}
                        className={`w-full bg-slate-50 rounded-xl p-3 border border-slate-200 text-left transition hover:bg-slate-100 hover:border-slate-300 ${celkemOpen ? "ring-2 ring-slate-400 ring-offset-1" : ""}`}
                        title={celkemOpen ? "Skrýt rozpad k dispozici" : "Z čeho se skládá celkový počet (z fakturace, bonusové, zůstatek z roku 2025)"}
                      >
                        <div className="text-sm text-slate-500 flex items-center gap-1">
                          Celkem k dispozici
                          <ChevronDown className={`w-3.5 h-3.5 text-slate-400 transition ${celkemOpen ? "rotate-180" : ""}`} />
                        </div>
                        {/* 28.7.2026: hlavicka = SOUCET slozek (z fakturace + bonusove + z min. roku),
                            aby sedela s podpolozkami i se zustatkem. Stazeny sloupec celkem_treninku se umel
                            rozejit o par treninku (napr. 71 vs 72). */}
                        <div className="text-base font-semibold text-slate-900 tabular-nums">{dostupneCelkem}</div>
                      </button>
                      {celkemOpen && (
                        <div className="mt-1.5 space-y-1">
                          <SubStat
                            label="Z fakturace"
                            value={client.treninkyZFakturace || 0}
                            open={faktOpen}
                            hasDetail={(client.treninkyZFakturace || 0) > 0}
                            onClick={() => {
                              setFaktOpen((o) => !o);
                              if (faktEntries === null && !faktLoading) {
                                setFaktLoading(true);
                                apiFetch(`/api/log-pripsane-treninky?od=epocha&klient=${encodeURIComponent(client.klient || "")}`)
                                  .then((r) => r.json())
                                  .then((j) => setFaktEntries(Array.isArray(j?.rows) ? j.rows.filter((x) => x.zdroj === "Faktura" || x.zdroj === "Hotovost") : []))
                                  .catch((e) => setFaktError(e?.message || "Chyba"))
                                  .finally(() => setFaktLoading(false));
                              }
                            }}
                          />
                          <SubStat
                            label="Bonusové"
                            value={client.bonusoveTreninky || 0}
                            open={bonusOpen}
                            hasDetail={(client.bonusoveTreninky || 0) > 0}
                            onClick={() => {
                              setBonusOpen((o) => !o);
                              if (bonusEntries === null && !bonusLoading) {
                                setBonusLoading(true);
                                apiFetch("/api/log-st-bonus?od=epocha")
                                  .then((r) => r.json())
                                  .then((j) => setBonusEntries(Array.isArray(j?.bonus) ? j.bonus : []))
                                  .catch((e) => setBonusError(e?.message || "Chyba"))
                                  .finally(() => setBonusLoading(false));
                              }
                            }}
                          />
                          <SubStat label="Zůstatek z roku 2025" value={client.zustatekMinRoku || 0} hasDetail={false} />
                        </div>
                      )}
                    </div>

                    {/* Celkem odchozeno — rozbalí odchozené / propadnuté (automatizace) / zrušené pozdě */}
                    <div>
                      <button
                        type="button"
                        onClick={() => setOdchozenoOpen((o) => !o)}
                        className={`w-full bg-slate-50 rounded-xl p-3 border border-slate-200 text-left transition hover:bg-slate-100 hover:border-slate-300 ${odchozenoOpen ? "ring-2 ring-slate-400 ring-offset-1" : ""}`}
                        title={odchozenoOpen ? "Skrýt rozpad odchozeného" : "Rozpad: odchozené, propadnuté (automatizace), zrušené pozdě"}
                      >
                        <div className="text-sm text-slate-500 flex items-center gap-1">
                          Celkem odchozeno
                          <ChevronDown className={`w-3.5 h-3.5 text-slate-400 transition ${odchozenoOpen ? "rotate-180" : ""}`} />
                        </div>
                        <div className="text-base font-semibold text-slate-900 tabular-nums flex items-center gap-2 flex-wrap">
                          <span>{odchozenoCelkem}</span>
                          {propadleMinimum > 0 && (
                            <span className="inline-flex items-center gap-1 text-[11px] font-medium px-1.5 py-0.5 rounded-lg bg-rose-50 text-rose-600 border border-rose-200" title="Propadlé z nesplněného minima">
                              <span className="w-1.5 h-1.5 rounded-full bg-rose-500"></span>{propadleMinimum} minimum
                            </span>
                          )}
                          {propadleLate > 0 && (
                            <span className="inline-flex items-center gap-1 text-[11px] font-medium px-1.5 py-0.5 rounded-lg bg-amber-50 text-amber-600 border border-amber-200" title="Zrušené pozdě (klient přišel o trénink)">
                              <span className="w-1.5 h-1.5 rounded-full bg-amber-500"></span>{propadleLate} pozdě
                            </span>
                          )}
                        </div>
                      </button>
                      {odchozenoOpen && (
                        <div className="mt-1.5 space-y-1">
                          <SubStat label="Odchozené tréninky" value={odchozenoTotal} hasDetail={false} />
                          <SubStat
                            label="Propadnuté (automatizace)"
                            value={propadleAutoTotal}
                            open={propadleInlineOpen}
                            hasDetail={propadleAutoTotal > 0}
                            onClick={() => setPropadleInlineOpen((o) => !o)}
                            valueClass={propadleAutoTotal > 0 ? "text-rose-600" : ""}
                          />
                          <SubStat
                            label="Zrušené pozdě"
                            value={lateTotal}
                            open={lateOpen}
                            hasDetail={lateTotal > 0}
                            onClick={() => setLateOpen((o) => !o)}
                            valueClass={lateTotal > 0 ? "text-rose-600" : ""}
                          />
                        </div>
                      )}
                    </div>

                    {/* Zbývá k odchození = stav tréninků (jen zobrazení, datové pole beze změny) */}
                    {(() => {
                      const z = stavTreninkuNum;
                      const cls = isNaN(z)
                        ? "bg-slate-50 border-slate-200"
                        : z >= 3 ? "bg-emerald-50 border-emerald-200"
                        : z >= 1 ? "bg-amber-50 border-amber-200"
                        : "bg-rose-50 border-rose-200";
                      const valCls = isNaN(z)
                        ? "text-slate-900"
                        : z >= 3 ? "text-emerald-700"
                        : z >= 1 ? "text-amber-700"
                        : "text-rose-700";
                      return (
                        <div className={`rounded-xl p-3 border ${cls}`}>
                          <div className="text-sm text-slate-500 flex items-center gap-1">
                            Zbývá k odchození
                            <InfoTip text="Kolik tréninků klientovi zbývá. Výpočet: k dispozici minus odchozené minus propadlé. Nesplněné minimum pod nulu nesrazí, pozdě zrušené ano. Odchozené tréninky se počítají vždy za předchozí den, ne v den tréninku." />
                          </div>
                          <div className={`text-base font-semibold tabular-nums ${valCls}`}>{isNaN(z) ? (client.stavTreninku || "—") : z}</div>
                        </div>
                      );
                    })()}
                  </div>

                  {/* Spojené tréninky — sekundární prvek (chip), ne hlavní dlaždice. Po 10 spojených = 1 bonusový. */}
                  {(client.spojeneTreniky || 0) > 0 && (() => {
                    const stCount = client.spojeneTreniky || 0;
                    const toBonus = 10 - (stCount % 10);
                    return (
                      <div className="mt-2">
                        <button
                          type="button"
                          onClick={() => {
                            setStOpen((o) => !o);
                            if (stEntries === null && !stLoading) {
                              setStLoading(true);
                              apiFetch("/api/log-st-bonus?od=epocha")
                                .then((r) => r.json())
                                .then((j) => setStEntries(Array.isArray(j?.st) ? j.st : []))
                                .catch((e) => setStError(e?.message || "Chyba"))
                                .finally(() => setStLoading(false));
                            }
                          }}
                          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 border text-xs font-medium transition ${stOpen ? "bg-blue-100 border-blue-300 text-blue-800" : "bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100"}`}
                          title="Spojené tréninky (po 10 spojených = 1 bonusový)"
                        >
                          Spojené tréninky: <span className="tabular-nums font-semibold">{stCount}</span>
                          <span className="text-blue-500 tabular-nums">, zbývá {toBonus}/10 do bonusu</span>
                          <ChevronDown className={`w-3 h-3 transition ${stOpen ? "rotate-180" : ""}`} />
                        </button>
                      </div>
                    );
                  })()}
                </div>

                {/* Propadnuté (automatizace) — schválené propadlé z Log Expired (měsíční minimum) */}
                {propadleInlineOpen && propadleAutoTotal > 0 && (
                  <div className="mt-4 border-t border-slate-200 pt-4">
                    <div className="flex items-center gap-2 mb-3 flex-wrap">
                      <AlertTriangle className="w-4 h-4 text-rose-600" />
                      <span className="text-sm font-semibold text-slate-900">Propadnuté tréninky (automatizace, schválené)</span>
                      <InfoTip text="Schválené propadlé tréninky z Log Expired (měsíční automatizace, nesplněné minimum). Plný rozpad je i v sekci Schválené propadlé tréninky níže." />
                    </div>
                    <div className="space-y-1.5">
                      {logExpired.map((e, i) => (
                        <div key={i} className="flex items-center gap-3 rounded-xl px-3 py-2 border bg-rose-50/40 border-rose-100 text-sm">
                          <span className="font-semibold text-slate-800 min-w-[88px]">{e.mesic}</span>
                          <span className="font-bold text-rose-600 tabular-nums">{e.propadle}×</span>
                        </div>
                      ))}
                      <div className="text-xs text-slate-400 pt-1">Celkem propadlých (automatizace) letos: {propadleAutoTotal - (Number(client?.propadleMinPredchoziRoky) || 0)}</div>
                      {(Number(client?.propadleMinPredchoziRoky) || 0) > 0 && (
                        <div className="text-xs text-slate-400">Z předchozích let: {Number(client.propadleMinPredchoziRoky) || 0}</div>
                      )}
                    </div>
                  </div>
                )}

                {/* Zrušené pozdě — rozpad: měsíc, kolik propadlo, důvod a který trenér to zadal */}
                {lateOpen && lateTotal > 0 && (
                  <div className="mt-4 border-t border-slate-200 pt-4">
                    <div className="flex items-center gap-2 mb-3 flex-wrap">
                      <AlertTriangle className="w-4 h-4 text-rose-600" />
                      <span className="text-sm font-semibold text-slate-900">Pozdě zrušené tréninky (klient přišel o trénink)</span>
                      <InfoTip text="Konkrétní tréninky, které trenér označil jako propadlé v týdenním rozvrhu, protože je klient zrušil pozdě (méně než 24 h dopředu) nebo nepřišel. Ukazuje datum, službu a trenéra." />
                    </div>
                    <div className="space-y-1.5">
                      {lateBookings.map((b, i) => (
                        <div key={i} className="flex items-center gap-2 rounded-xl px-3 py-2 border bg-rose-50/40 border-rose-100 flex-wrap text-sm">
                          <span className="font-semibold text-slate-800 tabular-nums whitespace-nowrap">{formatDate(b.date)}{b.cas ? ` ${b.cas}` : ""}</span>
                          <Oddelovac />
                          <span className="text-slate-700">{b.sluzba || "Trénink"}</span>
                          {b.trener && <><Oddelovac /><span className="text-slate-600">{b.trener}</span></>}
                          <span className="ml-auto inline-flex items-center gap-1.5 shrink-0">
                            <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full border bg-amber-50 text-amber-700 border-amber-200">zrušen pozdě</span>
                            <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full border bg-rose-100 text-rose-700 border-rose-200">propadl</span>
                          </span>
                        </div>
                      ))}
                      <div className="text-xs text-slate-400 pt-1">Pozdě zrušených (PROPADL z rozvrhu) letos: {lateTotal}</div>
                    </div>
                  </div>
                )}

                {/* Z fakturace — rozpad: které faktury / hotovostní platby a kolik tréninků připsaly. */}
                {faktOpen && (client.treninkyZFakturace || 0) > 0 && (
                  <div className="mt-4 border-t border-slate-200 pt-4">
                    <div className="flex items-center gap-2 mb-3 flex-wrap">
                      <FileText className="w-4 h-4 text-brand-600" />
                      <span className="text-sm font-semibold text-slate-900">Rozpad připsaných tréninků (faktury + hotovost)</span>
                      <InfoTip text="Které faktury (FAPI) a hotovostní platby klientovi připsaly tréninky a kolik. Počet z faktury se počítá z položek (1T=4, 2T=8, 10T/Permanentka=10). Celý přehled napříč klienty je v Log připsaných tréninků." />
                      <Link to="/clients/log-pripsane-treninky" className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-brand-700 hover:text-brand-800 hover:underline">
                        Otevřít v Logu <ExternalLink className="w-3 h-3" />
                      </Link>
                    </div>
                    {faktLoading && <div className="flex items-center gap-2 text-sm text-slate-500 py-3"><RefreshCw className="w-4 h-4 animate-spin" /> Načítám…</div>}
                    {faktError && !faktLoading && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-xl px-3 py-2">Nepodařilo se načíst: {faktError}</div>}
                    {!faktLoading && !faktError && faktEntries !== null && (
                      faktEntries.length === 0 ? (
                        <div className="text-sm text-slate-500 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2">
                          Žádné dohledatelné faktury/hotovost pro tohoto klienta v letošním roce. Souhrn: {client.treninkyZFakturace} z fakturace.
                        </div>
                      ) : (
                        <div className="space-y-1.5">
                          {faktEntries.map((e, i) => (
                            <div key={i} className="flex items-center gap-3 rounded-xl px-3 py-2 border bg-slate-50 border-slate-200">
                              <div className="text-sm font-semibold text-slate-800 tabular-nums whitespace-nowrap">{formatDate(e.datum)}</div>
                              <div className="text-sm font-bold text-emerald-700 tabular-nums whitespace-nowrap">+{e.pocet}×</div>
                              <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full border shrink-0 ${e.zdroj === "Hotovost" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-brand-50 text-brand-700 border-brand-200"}`}>{e.zdroj}</span>
                              <div className="text-sm text-slate-600 truncate" title={e.za_co}>{e.za_co}</div>
                            </div>
                          ))}
                          <div className="text-xs text-slate-400 pt-1">Součet z rozpadu: {faktEntries.reduce((s, x) => s + (x.pocet || 0), 0)}, souhrn klienta: {client.treninkyZFakturace}</div>
                        </div>
                      )
                    )}
                  </div>
                )}

                {/* Bonusove treniky — strukturovany dropdown.
                    Data: /api/log-st-bonus -> bonus array (current rok). Filter na klienta
                    pres normalizovany match (diakritika, whitespace). Group by rok. */}
                {bonusOpen && (client.bonusoveTreninky || 0) > 0 && (
                  <div className="mt-4 border-t border-slate-200 pt-4">
                    <div className="flex items-center gap-2 mb-3 flex-wrap">
                      <Award className="w-4 h-4 text-emerald-600" />
                      <span className="text-sm font-semibold text-slate-900">Záznamy bonusových tréninků</span>
                      <InfoTip text="Záznamy bonusů od roku 2026. Zobrazuje datum, počet, důvod (za co byl bonus přidělen) a zadavatele. Pro úpravu nebo přehled po rocích otevři sekci Log ST/Bonus." />
                      <Link
                        to={`/clients/log-st-bonus?klient=${encodeURIComponent(client.klient || "")}&tab=bonus`}
                        className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-emerald-700 hover:text-emerald-800 hover:underline"
                      >
                        Otevřít v Log Bonus
                        <ExternalLink className="w-3 h-3" />
                      </Link>
                    </div>
                    {bonusLoading && (
                      <div className="flex items-center gap-2 text-sm text-slate-500 py-3">
                        <RefreshCw className="w-4 h-4 animate-spin" />
                        Načítám záznamy…
                      </div>
                    )}
                    {bonusError && !bonusLoading && (
                      <div className="text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-xl px-3 py-2">
                        Nepodařilo se načíst bonusy: {bonusError}
                      </div>
                    )}
                    {!bonusLoading && !bonusError && bonusEntries !== null && (() => {
                      // Filter podle klienta (normalizovany match)
                      const norm = (s) => String(s || "").toLowerCase()
                        .normalize("NFD").replace(/[̀-ͯ]/g, "")
                        .replace(/\s+/g, " ").trim();
                      const target = canonicalNorm(client.klient);
                      const mine = (bonusEntries || []).filter((e) => canonicalNorm(e.klient) === target);
                      if (mine.length === 0) {
                        return (
                          <div className="text-sm text-slate-500 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2">
                            Pro tohoto klienta nejsou v Log bonus {new Date().getFullYear()} žádné záznamy.
                            Klient má {client.bonusoveTreninky} bonusových v souhrnu.
                          </div>
                        );
                      }
                      // Parse datum -> YYYY-MM-DD pro sort + group by rok
                      const parseDate = (raw) => {
                        const s = String(raw || "").trim();
                        const iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
                        if (iso) return { year: iso[1], iso: `${iso[1]}-${iso[2].padStart(2,"0")}-${iso[3].padStart(2,"0")}`, display: `${parseInt(iso[3],10)}.${parseInt(iso[2],10)}.${iso[1]}` };
                        const cz = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/);
                        if (cz) return { year: cz[3], iso: `${cz[3]}-${cz[2].padStart(2,"0")}-${cz[1].padStart(2,"0")}`, display: `${parseInt(cz[1],10)}.${parseInt(cz[2],10)}.${cz[3]}` };
                        return { year: "—", iso: "", display: s || "—" };
                      };
                      const enriched = mine.map((e) => ({ ...e, _d: parseDate(e.datum) }));
                      enriched.sort((a, b) => b._d.iso.localeCompare(a._d.iso));
                      // Group by rok
                      const groups = new Map();
                      enriched.forEach((e) => {
                        const k = e._d.year;
                        if (!groups.has(k)) groups.set(k, []);
                        groups.get(k).push(e);
                      });
                      const years = [...groups.keys()].sort().reverse();
                      const showYearHeader = years.length > 1;
                      const totalCount = enriched.reduce((s, e) => s + (Number(e.pocet) || 1), 0);
                      return (
                        <>
                          <div className="text-xs text-slate-500 mb-2">
                            {enriched.length} {enriched.length === 1 ? "záznam" : enriched.length < 5 ? "záznamy" : "záznamů"}, celkem {totalCount} {totalCount === 1 ? "trénink" : totalCount < 5 ? "tréninky" : "tréninků"}
                          </div>
                          <div className="space-y-3">
                            {years.map((y) => {
                              const items = groups.get(y);
                              return (
                                <div key={y}>
                                  {showYearHeader && (
                                    <div className="text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1.5">{y}</div>
                                  )}
                                  <div className="space-y-1.5">
                                    {items.map((e, idx) => {
                                      const zRaw = String(e.zadavatel || "").trim().toLowerCase();
                                      const isAuto = ["automatizace", "automaticky", "backfill"].includes(zRaw);
                                      const zLabel = !zRaw ? "—" : isAuto ? "Automatizace" : e.zadavatel.trim();
                                      return (
                                        <div key={`${y}-${idx}-${e.rowNum}`} className="flex items-start gap-3 text-sm bg-emerald-50 border border-emerald-100 rounded-xl px-3 py-2">
                                          <div className="font-semibold text-slate-900 min-w-[88px] pt-0.5 tabular-nums">{e._d.display}</div>
                                          <div className="font-bold text-emerald-700 tabular-nums min-w-[28px] pt-0.5">{e.pocet || 1}×</div>
                                          <div className="flex-1 min-w-0">
                                            <div className="text-slate-800 leading-snug">{e.duvod || "—"}</div>
                                            {e.poznamka && (
                                              <div className="text-xs text-slate-500 mt-0.5">{e.poznamka}</div>
                                            )}
                                          </div>
                                          <div className={`text-xs whitespace-nowrap pt-0.5 ${isAuto ? "text-brand-700" : "text-slate-600"}`}>
                                            {isAuto ? <Sparkles className="w-3 h-3 inline mr-1" /> : null}
                                            {zLabel}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}

                {/* Spojené tréninky (ST) — strukturovany dropdown.
                    Data: /api/log-st-bonus -> st array (current rok). Filter na klienta. */}
                {stOpen && (client.spojeneTreniky || 0) > 0 && (
                  <div className="mt-4 border-t border-slate-200 pt-4">
                    <div className="flex items-center gap-2 mb-3 flex-wrap">
                      <Activity className="w-4 h-4 text-blue-600" />
                      <span className="text-sm font-semibold text-slate-900">Záznamy spojených tréninků (ST)</span>
                      <InfoTip text="Záznamy ST od roku 2026. Zobrazuje datum, počet, důvod a zadavatele. Pro úpravu nebo přehled po rocích otevři sekci Log ST/Bonus." />
                      <Link
                        to={`/clients/log-st-bonus?klient=${encodeURIComponent(client.klient || "")}&tab=st`}
                        className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-blue-700 hover:text-blue-800 hover:underline"
                      >
                        Otevřít v Log ST
                        <ExternalLink className="w-3 h-3" />
                      </Link>
                    </div>
                    {stLoading && (
                      <div className="flex items-center gap-2 text-sm text-slate-500 py-3">
                        <RefreshCw className="w-4 h-4 animate-spin" />
                        Načítám záznamy…
                      </div>
                    )}
                    {stError && !stLoading && (
                      <div className="text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-xl px-3 py-2">
                        Nepodařilo se načíst spojené tréninky: {stError}
                      </div>
                    )}
                    {!stLoading && !stError && stEntries !== null && (() => {
                      const norm = (s) => String(s || "").toLowerCase()
                        .normalize("NFD").replace(/[̀-ͯ]/g, "")
                        .replace(/\s+/g, " ").trim();
                      // 2.6.2026: porovnani pres canonicalNorm (alias) — varianty jmena
                      // ("Zimmermanova" vs "Zimmermannova") se jinak nenapparovaly a zaznam vypadl.
                      const target = canonicalNorm(client.klient);
                      const mine = (stEntries || []).filter((e) => canonicalNorm(e.klient) === target);
                      if (mine.length === 0) {
                        return (
                          <div className="text-sm text-slate-500 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2">
                            Pro tohoto klienta nejsou v Log ST {new Date().getFullYear()} žádné záznamy.
                            Klient má {client.spojeneTreniky} spojených v souhrnu.
                          </div>
                        );
                      }
                      const parseDate = (raw) => {
                        const s = String(raw || "").trim();
                        const iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
                        if (iso) return { year: iso[1], iso: `${iso[1]}-${iso[2].padStart(2,"0")}-${iso[3].padStart(2,"0")}`, display: `${parseInt(iso[3],10)}.${parseInt(iso[2],10)}.${iso[1]}` };
                        const cz = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/);
                        if (cz) return { year: cz[3], iso: `${cz[3]}-${cz[2].padStart(2,"0")}-${cz[1].padStart(2,"0")}`, display: `${parseInt(cz[1],10)}.${parseInt(cz[2],10)}.${cz[3]}` };
                        return { year: "—", iso: "", display: s || "—" };
                      };
                      const enriched = mine.map((e) => ({ ...e, _d: parseDate(e.datum) }));
                      enriched.sort((a, b) => b._d.iso.localeCompare(a._d.iso));
                      const groups = new Map();
                      enriched.forEach((e) => {
                        const k = e._d.year;
                        if (!groups.has(k)) groups.set(k, []);
                        groups.get(k).push(e);
                      });
                      const years = [...groups.keys()].sort().reverse();
                      const showYearHeader = years.length > 1;
                      const totalCount = enriched.reduce((s, e) => s + (Number(e.pocet) || 1), 0);
                      return (
                        <>
                          <div className="text-xs text-slate-500 mb-2">
                            {enriched.length} {enriched.length === 1 ? "záznam" : enriched.length < 5 ? "záznamy" : "záznamů"}, celkem {totalCount} {totalCount === 1 ? "trénink" : totalCount < 5 ? "tréninky" : "tréninků"}
                          </div>
                          <div className="space-y-3">
                            {years.map((y) => {
                              const items = groups.get(y);
                              return (
                                <div key={y}>
                                  {showYearHeader && (
                                    <div className="text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1.5">{y}</div>
                                  )}
                                  <div className="space-y-1.5">
                                    {items.map((e, idx) => {
                                      const zRaw = String(e.zadavatel || "").trim().toLowerCase();
                                      const isAuto = ["automatizace", "automaticky", "backfill"].includes(zRaw);
                                      const zLabel = !zRaw ? "—" : isAuto ? "Automatizace" : e.zadavatel.trim();
                                      return (
                                        <div key={`${y}-${idx}-${e.rowNum}`} className="flex items-start gap-3 text-sm bg-blue-50 border border-blue-100 rounded-xl px-3 py-2">
                                          <div className="font-semibold text-slate-900 min-w-[88px] pt-0.5 tabular-nums">{e._d.display}</div>
                                          <div className="font-bold text-blue-700 tabular-nums min-w-[28px] pt-0.5">{e.pocet || 1}×</div>
                                          <div className="flex-1 min-w-0">
                                            <div className="text-slate-800 leading-snug">{e.duvod || "—"}</div>
                                            {e.poznamka && (
                                              <div className="text-xs text-slate-500 mt-0.5">{e.poznamka}</div>
                                            )}
                                          </div>
                                          <div className={`text-xs whitespace-nowrap pt-0.5 ${isAuto ? "text-brand-700" : "text-slate-600"}`}>
                                            {isAuto ? <Sparkles className="w-3 h-3 inline mr-1" /> : null}
                                            {zLabel}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}

                {logExpired.length > 0 && (
                  <div className="mt-5 border-t border-slate-200 pt-4">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className="inline-block w-2.5 h-2.5 rounded-full bg-rose-500"></span>
                      <span className="text-sm font-semibold text-slate-900">Schválené propadlé tréninky za rok {new Date().getFullYear()}</span>
                      <InfoTip text="Zobrazují se pouze schválené propadlé tréninky (Schváleno=ANO v Log Expired). Neschválené (NE = odpuštěno) zde nejsou, ty se nezapočítávají do propadlých." />
                      <span className="text-xs text-slate-500">
                        (celkem {logExpired.reduce((s, e) => s + (Number(e.propadle) || 0), 0)} tréninků)
                      </span>
                    </div>
                    <div className="space-y-1.5">
                      {logExpired
                        .slice()
                        .sort((a, b) => MONTH_FULL.indexOf(b.mesic) - MONTH_FULL.indexOf(a.mesic))
                        .map((e) => {
                          const parsed = parsePropadleDuvod(e.duvod);
                          // Cron důvod má pattern "{balicek}: minimum X tréninků..." → strukturovaný popis.
                          // Ručně přidaný důvod (volný text) → zobraz raw, ale ořež zbytečné prefixy.
                          let popis;
                          if (parsed.minimum != null) {
                            const balicekLabel = parsed.balicek || "—";
                            popis = `Nesplněno minimum ${parsed.minimum} ${parsed.minimum === 1 ? "tréninku" : parsed.minimum < 5 ? "tréninků" : "tréninků"} pro ${balicekLabel}${parsed.odchozeno != null ? `, odchozeno ${parsed.odchozeno}` : ""}`;
                          } else {
                            // Raw důvod (ruční zápis). Pokud je prázdný, ukaž zástupný text.
                            popis = (e.duvod && e.duvod.trim()) ? e.duvod.trim() : "Bez bližšího důvodu";
                          }
                          // Pilot info — pokud ručně přidaný, ukázat kým
                          const pilotInfo = e.pilot && e.pilot.toLowerCase() !== "automatizace"
                            ? ` (ručně: ${e.pilot})`
                            : "";
                          return (
                            <div key={e.rowIndex} className="flex items-start gap-3 text-sm bg-rose-50 border border-rose-100 rounded-xl px-3 py-2">
                              <div className="font-semibold text-slate-900 min-w-[80px] pt-0.5">{e.mesic}</div>
                              <div className="font-bold text-rose-600 tabular-nums min-w-[24px] pt-0.5">{e.propadle}</div>
                              <div className="text-slate-600 pt-0.5 whitespace-nowrap">{e.propadle === 1 ? "propadlý" : e.propadle < 5 ? "propadlé" : "propadlých"}</div>
                              <div className="text-xs text-slate-600 ml-auto text-right max-w-[60%] leading-snug">
                                {popis}
                                {pilotInfo && <span className="text-slate-400">{pilotInfo}</span>}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </ExpandableSection>
            )}


            {/* Volno klienta — planovane dovolene/nemoci. Promitne se do detekce rozvrh vzoru.
                Nezobrazuje se pro leady (nemaji rozvrh). */}
            {!isLead && (
              <ExpandableSection icon={Plane} title="Volno klienta" accent="sky" count={volnoPocet} defaultOpen={false} vzdyPripojeno>
                <ClientVolnoSection klientName={client.klient} klientId={client.notion_id} openTrigger={volnoOpenTrigger} readOnly={isManagerView} bezRamce onCount={setVolnoPocet} />
              </ExpandableSection>
            )}

            {/* Hodnocení spolupráce (20.7.2026) — nativní dotazník místo Google Formu.
                Vyplňuje se s klientkou (trenér/CSM, např. při prodloužení), odpovědi v PG.
                notion_id nemusí být vyplněné — dopočítá se z Notion URL (stejně jako jinde). */}
            {!isLead && (client.notion_id || client.notion) && (
              <ExpandableSection icon={Star} title="Hodnocení spolupráce" accent="amber" count={hodnoceniPocet} defaultOpen={false} vzdyPripojeno>
                <ClientHodnoceniSection klientId={client.notion_id || notionIdFromUrlCd(client.notion)} klientName={client.klient} trener={client.trener || ""} readOnly={isManagerView} bezRamce onCount={setHodnoceniPocet} openTrigger={hodnoceniOpenTrigger} />
              </ExpandableSection>
            )}

            {/* Děti / permice — dětská permice navázaná na klienta (akce léto 2026).
                Samostatná tabulka client_deti, nepočítá se rodiči. */}
            {!isLead && (client.notion_id || client.notion) && (
              <div className={detiPocet === null ? "hidden" : ""}>
                <ExpandableSection icon={Baby} title="Děti a permice" accent="purple" count={detiPocet === null ? undefined : detiPocet} defaultOpen={false} vzdyPripojeno>
                  <ClientDetiSection klientId={client.notion_id} klientNotion={client.notion} klientName={client.klient} readOnly={isManagerView} bezRamce onCount={setDetiPocet} />
                </ExpandableSection>
              </div>
            )}

            {/* Bootcamp — účast na skupinovém běhu. Samostatné tabulky bootcamp_*,
                nepočítá se do tréninků ani do MRR. Panel se schová, když klient na
                žádném běhu není. */}
            {!isLead && (client.notion_id || client.notion) && (
              <div className={bootcampPocet === null || bootcampPocet === undefined ? "hidden" : ""}>
                <ExpandableSection icon={Flame} title="Bootcamp" accent="amber" count={bootcampPocet || undefined} defaultOpen={false} vzdyPripojeno>
                  <ClientBootcampSection klientId={client.notion_id} klientNotion={client.notion} bezRamce onCount={setBootcampPocet} />
                </ExpandableSection>
              </div>
            )}

            {/* Přivedené kamarádky — akce "Přiveď kamarádku" (léto 2026). Read-only seznam leadů,
                které klient přivedl. Panel se schová, když nikoho nepřivedl. */}
            {!isLead && !isTrenerView && (client.notion_id || client.notion) && (
              <div className={kamaradkyPocet === null || kamaradkyPocet === undefined ? "hidden" : ""}>
                <ExpandableSection icon={UserPlus} title="Přivedené kamarádky" accent="rose" count={kamaradkyPocet || undefined} defaultOpen={false} vzdyPripojeno>
                  <ClientReferralsSection klientId={client.notion_id} klientNotion={client.notion} klientName={client.klient} bezRamce onCount={setKamaradkyPocet} />
                </ExpandableSection>
              </div>
            )}

            {/* Výživa — masterplán + nutriční služby + jídelníček na míru (10.7.2026). */}
            {!isLead && (client.notion_id || client.notion) && (
              <VyzivaExpandable
                klientId={client.notion_id}
                klientNotion={client.notion}
                klientName={client.klient}
                readOnly={isManagerView || isTrenerView}
                jenMasterplan={isTrenerView}
                narokNaVyzSl={client.narokNaVyzSl}
                posledniVyziva={client.poslNutricniKonzultace}
                defaultOpen={VYZIVA_FOCUS}
              />
            )}

            {/* Aktivní víkendy — odznaky za víkendové akce v portálu (8.7.2026).
                9.7.2026: defaultně sbalené, počet zaškrtnutých víkendů v hlavičce. */}
            {/* 13.7.2026: trenér víkendy nevidí (nové moduly bez trenérské viditelnosti). */}
            {!isLead && !isTrenerView && (client.notion_id || client.notion) && (
              <WeekendsExpandable klientId={client.notion_id} klientNotion={client.notion} readOnly={isManagerView} />
            )}

            {/* Budoucí tréninky — grouping + PDF export. Order swap 6.5.2026: budoucí PŘED historií,
                user řeší aktuální termíny častěji než minulost.
                Default closed: po kliknutí se rozbalí + vnitřní YearDropdown auto-otevře aktuální rok
                a MonthDropdown auto-otevře aktuální měsíc (= user vidí relevantní data hned).
                NEZOBRAZUJE se pro leady (nejsou v Reservio). */}
            {!isLead && (
            <ExpandableSection
              icon={CalendarClock}
              title="Budoucí tréninky"
              subtitle={
                bookingsLoading ? "Načítám…" :
                bookings ? `${bookings.stats.totalFuture} naplánovaných` : null
              }
              accent="green"
              count={bookings ? bookings.stats.totalFuture : undefined}
              defaultOpen={false}
              action={
                canExportPdf && bookings && bookings.future.length > 0 ? (
                  <button
                    type="button"
                    onClick={() => exportBookingsToPDF(client.klient, bookings.future, "Budoucí tréninky")}
                    className="btn btn-primary"
                    title="Stáhnout budoucí tréninky jako PDF"
                  >
                    <Download className="w-3.5 h-3.5" /> PDF
                  </button>
                ) : null
              }
            >
              {bookingsLoading && (
                <div className="flex items-center gap-2 text-sm text-slate-500 py-2">
                  <RefreshCw className="w-4 h-4 animate-spin" /> Načítám tréninky…
                </div>
              )}
              {!bookingsLoading && !bookingsError && bookings && (
                <BookingActionsContext.Provider value={{ klientName: client.klient, canManage: canMarkPropad, onOptimistic: applyPropadLocal, onReload: reloadBookings }}><GroupedBookings bookings={bookings.future} sortAsc={true} /></BookingActionsContext.Provider>
              )}
            </ExpandableSection>
            )}

            {/* Historie tréninků — grouping po letech a měsících + PDF export. Skryto pro leady. */}
            {!isLead && (
            <ExpandableSection
              icon={History}
              title="Historie tréninků"
              subtitle={
                bookingsLoading ? "Načítám…" :
                bookings ? `Celkem ${bookings.stats.totalPast}, propadlých ${bookings.stats.propadlych}, z toho zkušebních ${bookings.stats.zkusebnych ?? 0}, nutričních konzultací ${bookings.stats.nutricnichKonzultaci ?? 0} (od 1.3.2026)` : null
              }
              accent="slate"
              count={bookings ? bookings.stats.totalPast : undefined}
              defaultOpen={false}
              action={
                canExportPdf && bookings && bookings.history.length > 0 ? (
                  <button
                    type="button"
                    onClick={() => exportBookingsToPDF(client.klient, bookings.history, "Historie tréninků")}
                    className="inline-flex items-center gap-1.5 text-sm font-medium px-2.5 py-1 rounded-xl bg-slate-900 hover:bg-slate-700 text-white transition-colors"
                    title="Stáhnout historii tréninků jako PDF"
                  >
                    <Download className="w-3.5 h-3.5" /> PDF
                  </button>
                ) : null
              }
            >
              {bookingsLoading && (
                <div className="flex items-center gap-2 text-sm text-slate-500 py-2">
                  <RefreshCw className="w-4 h-4 animate-spin" /> Načítám tréninky…
                </div>
              )}
              {bookingsError && (
                <div className="text-sm text-red-600 py-2">Chyba při načítání: {bookingsError}</div>
              )}
              {!bookingsLoading && !bookingsError && bookings && (
                <BookingActionsContext.Provider value={{ klientName: client.klient, canManage: canMarkPropad, onOptimistic: applyPropadLocal, onReload: reloadBookings }}><GroupedBookings bookings={bookings.history} sortAsc={false} /></BookingActionsContext.Provider>
              )}
            </ExpandableSection>
            )}

            {/* Tréninkový profil pro management view — na původním místě (pod historií).
                Trenér vidí stejnou sekci nahoře (renderována výš), tady se NEDUPLIKUJE. */}
            {!isTrenerView && (
            <ExpandableSection
              icon={ClipboardList}
              title="Tréninkový profil"
              subtitle="Základní info, cíle, cviky, kardio, log, poznámky, info pro náhrady"
              accent="amber"
              info="Tréninkový profil klienta z PG databáze. Trenér + management ho mohou editovat. Šablona pro zápis: kdy vyhovuje cvičit, zdravotní omezení, dlouhodobý cíl, tabulka cviků s váhami, kardio, log posledních tréninků, poznámky, info pro náhrady."
              defaultOpen={false}
            >
              <TrainingProfileSection
                klientName={client.klient}
                canEdit={!isManagerView && ["owner", "manager", "head_coach", "trener", "csm"].includes(String(currentUser?.role || "").toLowerCase())}
              />
            </ExpandableSection>
            )}

            {/* Modul 2D: Vstupní dotazník — základní informace k leadu pro sales při navolávání.
                6 polí: Level, počet/týden, čas, lokalita, trial, zkušenosti. NENÍ to o trénincích
                klienta po nástupu (to ukazují statistiky výše), ale o INPUT datech od leadu.
                Edit přes existing klient-edit framework, triple-write Notion+Leady+Stav 2026.
                Trenér nevidí (28.5.2026 — restrictMode). */}
            {!isTrenerView && (
            <ExpandableSection
              icon={ClipboardList}
              title="Vstupní dotazník"
              accent="purple"
              count={`${dotaznikVyplneno} z ${dotaznikCelkem}`}
              defaultOpen={false}
              action={canEditContacts && client.notion && !editingProfil ? (
                <button
                  onClick={(e) => { e.stopPropagation(); startEditProfil(); }}
                  disabled={false}
                  title="Upravit vstupní dotazník"
                  className="px-2.5 py-1 text-xs rounded-lg bg-brand-50 hover:bg-brand-100 border border-brand-200 text-brand-700 font-medium transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Upravit
                </button>
              ) : null}
            >
              {!editingProfil ? (
                <div className="space-y-4">
                  {/* Z poptávky (FAPI form, klient sám). 9.9.2026: dlaždice místo FieldGridu,
                      prázdné kolonky se už neskrývají, ať sales vidí, na co se doptat. */}
                  <div>
                    <SkupinaNadpis
                      right={client.datumVytvoreni ? (
                        <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-200 bg-white px-2.5 py-1 text-[11.5px] font-bold text-slate-600">
                          <Calendar className="h-3.5 w-3.5 text-slate-400" /> Odesláno {formatDate(client.datumVytvoreni)}
                        </span>
                      ) : null}
                    >
                      Co napsal klient v poptávce
                    </SkupinaNadpis>
                    <div className="grid grid-cols-2 gap-2.5 lg:grid-cols-4">
                      <DotaznikKarta label="Kdy chce začít" value={effectiveKdyChceZacit} />
                      <DotaznikKarta label="Délka spolupráce" value={effectiveDelkaSpoluprace} />
                      <DotaznikKarta label="Tréninků týdně" value={effectivePocetTreninkuTyden} />
                      <DotaznikKarta label="Čas pro tréninky" value={effectiveCasProTreninky} />
                      <DotaznikKarta label="Zájem o lokalitu" value={effectiveZajemOLokalitu} />
                      <DotaznikKarta label="Zájem o trial" value={effectiveZajemTrial} />
                      <DotaznikKarta label="Zkušenosti se cvičením" value={effectiveZkusenostiCviceni} />
                    </div>
                  </div>
                  {/* Od sales (call notes, rich_text) */}
                  <div>
                    <SkupinaNadpis>Co zjistil sales při hovoru</SkupinaNadpis>
                    <div className="space-y-2">
                      <SalesNoteCard label="Zdravotní omezení" value={effectiveZdravotniOmezeni} alert />
                      <SalesNoteCard label="Zranění" value={effectiveZraneni} />
                      <SalesNoteCard label="Chronické bolesti" value={effectiveChronickeBolesti} />
                      <SalesNoteCard label="Aktuální cíl" value={effectiveAktualniCil} />
                      <SalesNoteCard label="Poznámky" value={effectivePoznamkySales} />
                      {salesChybi.length > 0 && (
                        <div className="flex flex-wrap items-center gap-2 rounded-xl border border-dashed border-slate-300 bg-white/60 px-3 py-2.5">
                          <span className="text-xs font-bold text-slate-500">Nevyplněno</span>
                          {salesChybi.map((l) => (
                            <span key={l} className="rounded-full bg-slate-100 px-2.5 py-1 text-[11.5px] font-bold text-slate-600">{l}</span>
                          ))}
                          {canEditContacts && client.notion && (
                            <button
                              onClick={startEditProfil}
                              className="ml-auto rounded-lg border border-brand-200 bg-brand-50 px-2.5 py-1 text-xs font-medium text-brand-700 transition hover:bg-brand-100 min-h-[44px] sm:min-h-0"
                            >
                              Doplnit
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex items-start gap-2.5 rounded-xl border border-brand-200 bg-brand-50 px-3 py-2.5">
                    <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-brand-700" />
                    <div className="text-[13px] leading-snug text-brand-950">
                      Tohle jsou odpovědi z prodeje. Co si o zdraví a cílech vede trenér, je zvlášť v Tréninkovém profilu, jsou to jiné kolonky a nepřepisují se navzájem.
                    </div>
                  </div>
                </div>
              ) : (
                /* EDIT MODE — 7 polí poptávka (selecty/text) + 5 sales textarea */
                <div className="space-y-4 p-4 bg-brand-50/50 border border-brand-200 rounded-xl">
                  <SkupinaNadpis>Z poptávky</SkupinaNadpis>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
<SelectField
                      label="Počet tréninků týdně"
                      icon={Calendar}
                      value={profilForm.pocetTreninkuTyden}
                      onChange={(v) => setProfilForm({ ...profilForm, pocetTreninkuTyden: v })}
                      options={addCurrentToOptions(fieldOptions?.pocetTreninkuTyden, effectivePocetTreninkuTyden)}
                      disabled={savingProfil}
                      placeholder="Vyber frekvenci"
                    />
                    <SelectField
                      label="Čas pro tréninky"
                      icon={CalendarClock}
                      value={profilForm.casProTreninky}
                      onChange={(v) => setProfilForm({ ...profilForm, casProTreninky: v })}
                      options={addCurrentToOptions(fieldOptions?.casProTreninky, effectiveCasProTreninky)}
                      disabled={savingProfil}
                      placeholder="Vyber čas"
                    />
                    <SelectField
                      label="Zájem o lokalitu"
                      icon={MapPin}
                      value={profilForm.zajemOLokalitu}
                      onChange={(v) => setProfilForm({ ...profilForm, zajemOLokalitu: v })}
                      options={addCurrentToOptions(fieldOptions?.zajemOLokalitu, effectiveZajemOLokalitu)}
                      disabled={savingProfil}
                      placeholder="Vyber lokalitu"
                    />
                    <SelectField
                      label="Zájem o trial"
                      icon={Sparkles}
                      value={profilForm.zajemTrial}
                      onChange={(v) => setProfilForm({ ...profilForm, zajemTrial: v })}
                      options={addCurrentToOptions(fieldOptions?.zajemTrial, effectiveZajemTrial)}
                      disabled={savingProfil}
                      placeholder="Vyber"
                    />
                    <SelectField
                      label="Zkušenosti se cvičením"
                      icon={Award}
                      value={profilForm.zkusenostiCviceni}
                      onChange={(v) => setProfilForm({ ...profilForm, zkusenostiCviceni: v })}
                      options={addCurrentToOptions(fieldOptions?.zkusenostiCviceni, effectiveZkusenostiCviceni)}
                      disabled={savingProfil}
                      placeholder="Vyber zkušenosti"
                    />
                    <SelectField
                      label="Kdy chce začít"
                      icon={CalendarClock}
                      value={profilForm.kdyChceZacit}
                      onChange={(v) => setProfilForm({ ...profilForm, kdyChceZacit: v })}
                      options={addCurrentToOptions(fieldOptions?.kdyChceZacit, effectiveKdyChceZacit)}
                      disabled={savingProfil}
                      placeholder="Vyber"
                    />
                    <SelectField
                      label="Délka spolupráce"
                      icon={Calendar}
                      value={profilForm.delkaSpoluprace}
                      onChange={(v) => setProfilForm({ ...profilForm, delkaSpoluprace: v })}
                      options={addCurrentToOptions(fieldOptions?.delkaSpoluprace, effectiveDelkaSpoluprace)}
                      disabled={savingProfil}
                      placeholder="Vyber"
                    />
                  </div>

                  <div className="pt-1"><SkupinaNadpis>Od sales</SkupinaNadpis></div>
                  <div className="grid grid-cols-1 gap-3">
                    {[
                      { key: "zdravotniOmezeni", label: "Zdravotní omezení", placeholder: "Např. astma, cukrovka, vysoký tlak…" },
                      { key: "zraneni", label: "Zranění", placeholder: "Např. operované koleno, výhřez plotýnky…" },
                      { key: "chronickeBolesti", label: "Chronické bolesti", placeholder: "Např. spodní záda po sezení, bolest ramene…" },
                      { key: "aktualniCil", label: "Aktuální cíl", placeholder: "Např. zhubnout 5 kg do léta, zlepšit sílu, prevence bolesti zad…" },
                      { key: "poznamkySales", label: "Poznámky (sales)", placeholder: "Cokoliv zachycené při call: preference, motivace, obavy…" },
                    ].map((f) => (
                      <label key={f.key} className="block text-sm">
                        <div className="text-slate-600 mb-1.5 font-medium">{f.label}</div>
                        <textarea
                          value={profilForm[f.key] || ""}
                          onChange={(e) => setProfilForm({ ...profilForm, [f.key]: e.target.value })}
                          disabled={savingProfil}
                          rows={2}
                          placeholder={f.placeholder}
                          className="field w-full resize-y"
                        />
                      </label>
                    ))}
                  </div>
                  {profilErr && (
                    <div className="bg-rose-50 border border-rose-200 rounded-lg p-2 text-sm text-rose-700">
                      Chyba: {profilErr}
                    </div>
                  )}
                  <div className="safe-bottom lepive-nad-klavesnici sticky bottom-0 -mx-4 -mb-4 flex items-center gap-2 rounded-b-xl border-t border-brand-200 bg-white/95 px-4 py-3 backdrop-blur">
                    <button
                      onClick={cancelEditProfil}
                      disabled={savingProfil}
                      className="btn btn-secondary"
                    >
                      Zrušit
                    </button>
                    <button
                      onClick={askSaveProfil}
                      disabled={!profilCanSave}
                      className="btn btn-primary"
                    >
                      {savingProfil ? "Ukládám…" : `Uložit (${profilChanged.length})`}
                    </button>
                    {profilChanged.length > 0 && (
                      <span className="text-xs text-amber-600 ml-2">
                        {profilChanged.length === 1 ? "1 změna" : `${profilChanged.length} změn`}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </ExpandableSection>
            )}

            {!isLead && clientCid && <SekceDokumenty klientId={clientCid} />}
            </>)}

            {/* Ostatní sekce odstraněna — Nárok na výž. sl. přesunut do Spolupráce,
                Poslední nutriční konzultace a Žebříček nemáme čím naplnit smysluplně. */}
          </div>
        </div>
      </div>
    </div>
  );
}


function daysAgoLabel(iso) {
  try {
    const d = datumZIso(iso);
    if (isNaN(d)) return null;
    const now = new Date();
    const diffMs = now - d;
    const days = Math.round(diffMs / (1000 * 60 * 60 * 24));
    if (days === 0) return "Dnes";
    if (days === 1) return "Včera";
    if (days < 0) return `Za ${Math.abs(days)} ${Math.abs(days) === 1 ? "den" : Math.abs(days) < 5 ? "dny" : "dní"}`;
    if (days < 7) return `Před ${days} dny`;
    if (days < 30) return `Před ${Math.floor(days / 7)} ${Math.floor(days / 7) === 1 ? "týdnem" : "týdny"}`;
    return `Před ${Math.floor(days / 30)} ${Math.floor(days / 30) === 1 ? "měsícem" : "měsíci"}`;
  } catch {
    return null;
  }
}

